"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[35492,42227,68425],{

/***/ 22147:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/**
 * Color name source http://www.htmlcsscolor.com/
 */ /* harmony default export */ __webpack_exports__["Z"] = ({
    light: "#FFFFFF",
    highempahis: "#333333",
    highgray: "#969696",
    midgray: "#B5B5B5",
    lowgray: "#CBCBCB",
    downgray: "#EDEDED",
    component: "#F5F5F5",
    primary: "#00ab6b",
    "primary60%": "#00ab6b99",
    secondary: "#3b5998",
    trading: "#2facb2",
    gainsboro: "#DADADA",
    whisper: "#EEEEEE",
    silver: "#BBBBBB",
    aliceBlue: "#F5F6F7",
    snow: "#F9F9F9",
    dimgray: "#6b6b6b",
    black: "#000000",
    nightRider: "#333333",
    zambezi: "#595959",
    veryLightGrey: "#CCCCCC",
    suvaGrey: "#939393",
    highball: "#979134",
    sunsetOrange: "#ee4a49",
    clearDay: "#e6f8f1",
    darkGray: "#AAAAAA",
    dimGray: "#666666",
    mintCream: "#eafff7",
    nobel: "#999999",
    bubbles: "#DEF2E5",
    heather: "#B5B6B7",
    bermuda: "#80D5B5",
    sundown: "#F7A5A4",
    hummingBird: "#cceee1",
    coralCandy: "#FAC8C8",
    darkGrey: "#AAAAAA",
    valencia: "#d9534f",
    mischka: "#a2a7b0",
    royalBlue: "#5766D3",
    steelBlue: "#4178bb",
    scooter: "#2c8aa3",
    java: "#169b8b",
    jade: "#00ad73",
    /* handling hex code with duplicate name */ "seasonality-darkest-green": "#006c00",
    "seasonality-medium-green": "#018601",
    "seasonality-green": "#009b00",
    "seasonality-bright-green": "#01ad01",
    "seasonality-darkest-red": "#a70000",
    "seasonality-medium-red": "#c20d0d",
    "seasonality-red": "#d00808",
    "seasonality-bright-red": "#e70000",
    amber: "#ffbf00",
    mintTulip: "#bde9d9",
    dodgerBlue: "#1E90FF",
    navyBlue: "#136ad5",
    whiteSmoke: "#F2F2F2",
    pigmentGreen: "#019934",
    lightGreen: "#90E897",
    monaLisa: "#ff988e",
    purpleHeart: "#7924c3",
    venetianRed: "#c11214",
    green: "#0c8414",
    cadetBlue: "#49a3ac",
    pinkSwan: "#B6B6B6",
    grannyApple: "#C7F3CB",
    alertRed: "#FCD0CE",
    alertOrange: "#F0AD4E",
    alertBlue: "#337AB7",
    yellowSea: "#eba031",
    chardonnay: "#ffc774",
    softgreen: "#E5F7F0",
    mountainMeadow: "#0bba7a",
    grey: "#777777",
    nero: "#222222",
    ghostWhite: "#f8f8f9",
    azureBlue: "#2F8EF7",
    bitterSweet: "#fc605c",
    supernova: "#fdbc40",
    limeGreen: "#34c84a",
    softGainsboro: "#DDDDDD",
    mediumAquamarine: "#5dcbad",
    cosmicLatte: "#e1f6e5",
    vividViolet: "#712E9E"
});


/***/ }),

/***/ 74575:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    mobileS: "(min-width:320px)",
    mobileM: "(min-width:375px)",
    mobileL: "(min-width:425px)",
    tablet: "(min-width:768px)",
    laptop: "(min-width:1024px)",
    laptopL: "(min-width:1440px)",
    desktop: "(min-width:2560px)"
});


/***/ }),

/***/ 70821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ convertToPixel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: ",
        ";\n  justify-content: ",
        ";\n  align-items: ",
        ";\n  padding: ",
        ";\n  margin: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  flex-wrap: ",
        ";\n  gap: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var convertToPixel = function(value) {
    if (value === undefined) return value;
    return typeof value === "number" ? "".concat(value, "px") : value;
};
var Flex = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        direction: props.direction || "row",
        justify: props.justify || "left",
        align: props.align || "flex-start",
        padding: props.padding || "0",
        margin: props.margin || "0",
        width: props.width,
        height: props.height,
        wrap: props.wrap || "nowrap",
        gap: props.gap || "0"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-c5bdc04d-0"
})(_templateObject(), function(param) {
    var direction = param.direction;
    return direction;
}, function(param) {
    var justify = param.justify;
    return justify;
}, function(param) {
    var align = param.align;
    return align;
}, function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var width = param.width;
    return convertToPixel(width);
}, function(param) {
    var height = param.height;
    return convertToPixel(height);
}, function(param) {
    var wrap = param.wrap;
    return wrap;
}, function(param) {
    var gap = param.gap;
    return convertToPixel(gap);
}, _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
/* harmony default export */ __webpack_exports__["Z"] = (Flex);


/***/ }),

/***/ 15807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ IconWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  height: ",
        ";\n  width: ",
        ";\n  padding: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: ",
        ";\n  cursor : pointer;\n  \n  ::before {\n    content: '",
        "';\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    top: 7%;\n    left: 7%;\n    color: ",
        ";\n    background: ",
        ";\n    border-radius: 50%;\n    min-width: 18px;\n    font-size: 12px;\n    font-weight: bold;\n    z-index: 2;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "icomoon";\n  font-size: ',
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  margin: 0;\n\n  :hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var IconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        size: props.size || "auto",
        padding: props.padding || "0px",
        newItem: props.newItem || 0,
        justify: props.justify || "center"
    };
}).withConfig({
    componentId: "sc-793d8880-0"
})(_templateObject(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var justify = param.justify;
    return justify;
}, function(param) {
    var newItem = param.newItem;
    return newItem || "";
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary);
var Iconmoon = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.attrs */ .ZP.p.attrs(function(props) {
    return {
        size: props.size || "16px",
        color: props.color || _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highgray */ .Z.highgray,
        isActive: props.isActive || false,
        hoverColor: props.hoverColor || _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary,
        weight: props.weight || "normal"
    };
}).withConfig({
    componentId: "sc-793d8880-1"
})(_templateObject1(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var weight = param.weight;
    return weight;
}, function(props) {
    return !props.isActive ? props.color : _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary;
}, function(props) {
    return props.hoverColor;
});

/* harmony default export */ __webpack_exports__["Z"] = (Iconmoon);


/***/ }),

/***/ 54325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7648);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _style_device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74575);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    font-size: 22px;\n    font-weight: 600;\n    text-align: center;\n    height: 35px;\n    border: 1px solid ",
        ";\n    @media ",
        " {\n      width: 300px;\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "ProximaNovaRg";\n  height: ',
        ";\n  width: ",
        " !important;\n  margin: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: ",
        ";\n\n  .ant-input::placeholder {\n    color: ",
        ";\n    font-size: 13px;\n  }\n\n  :hover,\n  :focus,\n  :focus-within {\n    border-color: ",
        ";\n    outline-color: transparent;\n    box-shadow: none;\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "ProximaNovaRg";\n  height: ',
        ";\n  width: ",
        " !important;\n  margin: ",
        ";\n  border-color: ",
        ";\n\n  .ant-input::placeholder {\n    color: ",
        ";\n    font-size: 13px;\n  }\n\n  :hover,\n  :focus,\n  :focus-within {\n    border-color: ",
        ";\n    box-shadow: none;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





var type = {
    basic: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject()),
    withdraw: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_device__WEBPACK_IMPORTED_MODULE_2__/* ["default"].laptop */ .Z.laptop)
};
var Input = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        height: props.height || "auto",
        width: props.width || "auto",
        margin: props.margin || "0",
        padding: props.padding || "5px",
        round: props.round || true,
        type: props.type || "basic"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-85b10eda-0"
})(_templateObject3(), function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var margin = param.margin;
    return margin;
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var round = param.round;
    return round ? "2px" : "unset";
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dimgray */ .Z.dimgray, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var typeKey = param.type;
    return type[typeKey];
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject2(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props));
});
Input.TextArea = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"].TextArea */ .Z.TextArea).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        height: props.height || "auto",
        width: props.width || "100%",
        margin: props.margin || "0"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-85b10eda-1"
})(_templateObject5(), function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var margin = param.margin;
    return margin;
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dimgray */ .Z.dimgray, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject4(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 95541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n  text-align: ",
        ";\n  padding: ",
        ";\n  width: ",
        ";\n  text-transform: ",
        ";\n  margin: 0;\n\n  ",
        "\n\n  ",
        "\n\n  & > a {\n    color: ",
        ";\n    text-decoration: none;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var familyType = {
    regular: "ProximaNovaRg",
    light: "ProximaNovaLt",
    bold: "ProximaNovaBd"
};
/* harmony default export */ __webpack_exports__["Z"] = (styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    shouldForwardProp: function(prop) {
        return ![
            "ellipsis",
            "textTransform"
        ].includes(prop);
    }
}).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        size: props.size || "14px",
        weight: props.weight || "normal",
        height: props.height || "normal",
        color: props.color || _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis,
        align: props.align || "left",
        padding: props.padding || 0,
        width: props.width,
        ellipsis: props.ellipsis,
        textTransform: props.textTransform,
        family: props.family || "regular"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-8a078c1d-0"
})(_templateObject3(), function(param) {
    var family = param.family;
    return familyType[family];
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var weight = param.weight;
    return weight;
}, function(param) {
    var height = param.height;
    return height;
}, function(props) {
    return props.color;
}, function(param) {
    var align = param.align;
    return align;
}, function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var textTransform = param.textTransform;
    return textTransform;
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props));
}, function(param) {
    var ellipsis = param.ellipsis;
    return ellipsis && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1());
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props));
}));


/***/ }),

/***/ 52435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ spacingProps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36305);




var types = {
    m: "margin",
    p: "padding"
};
var directions = {
    t: [
        "-top"
    ],
    r: [
        "-right"
    ],
    b: [
        "-bottom"
    ],
    l: [
        "-left"
    ],
    x: [
        "-left",
        "-right"
    ],
    y: [
        "-top",
        "-bottom"
    ]
};
var EMPTY_STRING = "";
var WHITE_SPACE = " ";
var REGEX = /^([mp][trblxy]?)$/;
var pipe = function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return function(x) {
        return fns.reduce(function(prev, f) {
            return f(prev, x);
        }, x);
    };
};
var filter = function(keys) {
    return keys.filter(function(key) {
        return key.match(REGEX);
    });
};
var merge = function(props) {
    return props.map(function(param) {
        var type = param.type, direction = param.direction, value = param.value;
        return direction.map(function(d) {
            return "".concat(type).concat(d, ": ").concat(value, ";");
        }).join(WHITE_SPACE);
    });
};
var splitPropKey = function(keys, props) {
    return keys.map(function(key) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(key.split(""), 2), type = ref[0], direction = ref[1];
        return {
            type: types[type],
            direction: directions[direction] || [
                EMPTY_STRING
            ],
            value: props[key]
        };
    });
};
var handleSpaces = function(props) {
    return pipe(Object.keys, filter, splitPropKey, merge)(props).join(WHITE_SPACE);
};
var spacingProps = function(props) {
    var typesKeys = Object.keys(types);
    var directionsKeys = Object.keys(directions);
    var result = typesKeys.map(function(type) {
        return directionsKeys.map(function(dir) {
            return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, "".concat(type).concat(dir), props["".concat(type).concat(dir)]);
        });
    }).reduce(function(prev, curr) {
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(prev).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(curr));
    }, []).filter(function(prop) {
        return Object.values(prop)[0];
    }).reduce(function(prev, curr) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, prev, curr);
    }, {});
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, result);
};
/* harmony default export */ __webpack_exports__["Z"] = (handleSpaces);


/***/ }),

/***/ 60714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ APIErrorMessage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/constants/errorMessage.js
var errorMessage = __webpack_require__(61608);
// EXTERNAL MODULE: ./src/config/APIErrorMessage/utils.ts
var utils = __webpack_require__(63858);
;// CONCATENATED MODULE: ./src/config/APIErrorMessage/handler.js





/**
 * handleDefault
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleDefault = function(errorType, message) {
    // Some API chat with 'blokir' message and 'FORBIDDEN' error_type should show alert
    // remove this block whenever BE possible to change error_type from 'FORBIDDEN'
    if (message.includes("blokir")) {
        var errMessageDefault = message;
        (0,AlertErrorMessage/* default */.Z)(errMessageDefault, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
        return;
    }
    /// ///////////////////////////////////////////////////
    if (errorType === errorMessage/* default.PAYWALL_NOSUBSCRIPTION */.Z.PAYWALL_NOSUBSCRIPTION) return;
    if (errorType === errorMessage/* default.FORBIDDEN */.Z.FORBIDDEN) return;
    var errMessageDefault1 = message;
    (0,AlertErrorMessage/* default */.Z)(errMessageDefault1, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
};
/**
 * handleMaintenance
 * web legacy: app\lib\Api.js line 184
 * @param {*} errorType | MAINTENANCE | ERROR_GATEWAY
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleMaintenance = function(errorType, message) {
    if (errorType === "MAINTENANCE" && message) {
        (0,utils/* dispatchSetErrorCode */.S)(503, message);
    }
};
/**
 * handleUnAuthorized
 * web legacy: app\lib\Api.js line 192
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleInvalidParameter = function(errorType, message) {
    if (errorType === "INVALID_RECAPTCHA") {
        return;
    }
    (0,AlertErrorMessage/* default */.Z)(message, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
};
/**
 * handleInternalServerError
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ // eslint-disable-next-line no-unused-vars
var handleInternalServerError = function(_, message) {
    (0,utils/* dispatchSetErrorCode */.S)(500);
};
/**
 * handleNotFound
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleNotFound = function(_, message) {
    (0,AlertErrorMessage/* default */.Z)(message, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
};
/**
 * handleNotSubscription
 * web legacy: app\lib\Api.js line 238
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleNotSubscription = function() {
// TODO: url
};
/**
 * @deprecated 401 Unathorized is directly handled from API instance
 * handleUnAuthorized
 * @param {Promise} originalRequest
 * @return Promise originalRequest with new Authorization header or error rejection
 */ // eslint-disable-next-line @typescript-eslint/no-empty-function
var handleUnAuthorized = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(originalRequest) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function handleUnAuthorized(originalRequest) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var handler = ({
    handleDefault: handleDefault,
    handleMaintenance: handleMaintenance,
    handleInvalidParameter: handleInvalidParameter,
    handleNotFound: handleNotFound,
    handleNotSubscription: handleNotSubscription,
    handleUnAuthorized: handleUnAuthorized,
    handleInternalServerError: handleInternalServerError
});

;// CONCATENATED MODULE: ./src/config/APIErrorMessage/index.js

var APIErrorMessage_handleDefault = handler.handleDefault, APIErrorMessage_handleMaintenance = handler.handleMaintenance, APIErrorMessage_handleInvalidParameter = handler.handleInvalidParameter, APIErrorMessage_handleNotFound = handler.handleNotFound, APIErrorMessage_handleNotSubscription = handler.handleNotSubscription, APIErrorMessage_handleUnAuthorized = handler.handleUnAuthorized, APIErrorMessage_handleInternalServerError = handler.handleInternalServerError;
/**
 * Exodus API error message handler
 * @param {number} status - HTTP Response status | required
 * @param {string} errorType - Error types | required
 * @param {string} message - Error message | required
 */ var APIExodusErrorHandler = function(status, errorType, message) {
    var listErrorResponse = {
        DEFAULT: APIErrorMessage_handleDefault,
        400: APIErrorMessage_handleInvalidParameter,
        401: APIErrorMessage_handleUnAuthorized,
        402: APIErrorMessage_handleNotSubscription,
        404: APIErrorMessage_handleNotFound,
        500: APIErrorMessage_handleInternalServerError,
        503: APIErrorMessage_handleMaintenance
    };
    var response = listErrorResponse[status] || listErrorResponse.DEFAULT;
    return response(errorType, message);
};
/* harmony default export */ var APIErrorMessage = ({
    APIExodusErrorHandler: APIExodusErrorHandler
});


/***/ }),

/***/ 63858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ dispatchSetErrorCode; }
/* harmony export */ });
/* harmony import */ var global_MainLayout_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73580);
/* eslint-disable import/prefer-default-export */ 
var dispatchSetErrorCode = function(errorCode) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    global_MainLayout_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].setState */ .Z.setState({
        errorCode: errorCode,
        errorMessage: errorMessage
    });
};


/***/ }),

/***/ 14350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RL": function() { return /* binding */ getAccessTokenDataFn; },
/* harmony export */   "oD": function() { return /* binding */ getRefreshTokenConfigFn; },
/* harmony export */   "x5": function() { return /* binding */ refreshExodusToken; }
/* harmony export */ });
/* unused harmony export initialRefreshTokenConfig */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19225);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37213);





var initialRefreshTokenConfig = {
    refreshingTokenStatus: "initial",
    refreshAndRetryQueue: []
};
var getRefreshTokenConfigFn = function() {
    var initNewConfig = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (true) {
        if (initNewConfig) {
            window.refreshRequestConfig = {
                refreshingTokenStatus: "initial",
                refreshAndRetryQueue: []
            };
            return window.refreshRequestConfig;
        }
        if (typeof window.refreshRequestConfig !== "undefined") {
            return window.refreshRequestConfig;
        }
        return undefined;
    }
    return initialRefreshTokenConfig;
};
var getAccessTokenDataFn = function() {
    var ref, ref1, ref2, ref3;
    var parsedToken = utils_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getToken */ .Z.getToken();
    var accessToken = (parsedToken === null || parsedToken === void 0 ? void 0 : (ref = parsedToken.accessToken) === null || ref === void 0 ? void 0 : ref.token) || "";
    var accessTokenExpiry = (parsedToken === null || parsedToken === void 0 ? void 0 : (ref1 = parsedToken.accessToken) === null || ref1 === void 0 ? void 0 : ref1.expiry) || 0;
    var refreshToken = (parsedToken === null || parsedToken === void 0 ? void 0 : (ref2 = parsedToken.refresh) === null || ref2 === void 0 ? void 0 : ref2.token) || "";
    var refreshTokenExpiry = (parsedToken === null || parsedToken === void 0 ? void 0 : (ref3 = parsedToken.refresh) === null || ref3 === void 0 ? void 0 : ref3.expiry) || 0;
    return {
        accessToken: accessToken,
        accessTokenExpiry: accessTokenExpiry,
        refreshToken: refreshToken,
        refreshTokenExpiry: refreshTokenExpiry
    };
};
var refreshExodusToken = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, parsedToken, refreshToken, response, _data, newAccessTokenData, parsedAccessExpired, parsedRefreshExpired;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    parsedToken = utils_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getToken */ .Z.getToken();
                    refreshToken = parsedToken === null || parsedToken === void 0 ? void 0 : (ref = parsedToken.refresh) === null || ref === void 0 ? void 0 : ref.token;
                    _ctx.next = 5;
                    return axios__WEBPACK_IMPORTED_MODULE_1___default().post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_EXODUS_URL */ .q7, "/login/refresh"), null, {
                        headers: {
                            Authorization: "Bearer ".concat(refreshToken)
                        }
                    });
                case 5:
                    response = _ctx.sent;
                    if (!(!response || !response.data || !response.data.data)) {
                        _ctx.next = 8;
                        break;
                    }
                    throw new Error("Failed Refresh Token");
                case 8:
                    _data = response.data, newAccessTokenData = _data.data;
                    parsedAccessExpired = new Date(newAccessTokenData.access.expired_at).getTime();
                    parsedRefreshExpired = new Date(newAccessTokenData.refresh.expired_at).getTime();
                    utils_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].saveToken */ .Z.saveToken({
                        accessToken: newAccessTokenData.access.token,
                        accessTokenExp: parsedAccessExpired,
                        refreshToken: newAccessTokenData.refresh.token,
                        refreshTokenExp: parsedRefreshExpired,
                        accessUser: utils_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getUserAccess */ .Z.getUserAccess()
                    });
                    return _ctx.abrupt("return", newAccessTokenData.access.token);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function refreshExodusToken() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 68425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ config_requestExodus; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./src/constants/errorMessage.js
var errorMessage = __webpack_require__(61608);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/utils/auth.js + 1 modules
var auth = __webpack_require__(19225);
// EXTERNAL MODULE: ./src/utils/logger.ts
var logger = __webpack_require__(91635);
;// CONCATENATED MODULE: ./src/config/refreshToken/index.ts
/* eslint-disable no-param-reassign */ 

var generateNewRequestWithRefreshToken = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var apiInstance, axiosError, getRefreshTokenConfig, getAccessTokenData, refreshTokenPromise, refreshTokenConfig, dateNow, newAccessToken, newRequest;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    apiInstance = param.apiInstance, axiosError = param.axiosError, getRefreshTokenConfig = param.getRefreshTokenConfig, getAccessTokenData = param.getAccessTokenData, refreshTokenPromise = param.refreshTokenPromise;
                    refreshTokenConfig = getRefreshTokenConfig();
                    dateNow = Math.floor(Date.now() / 1000);
                    _ctx.prev = 3;
                    if (!(dateNow > getAccessTokenData().refreshTokenExpiry)) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Failed Refresh Token");
                case 6:
                    if (!(typeof refreshTokenConfig === "undefined" || // Previous success refresh token config need to reset
                    (refreshTokenConfig.refreshingTokenStatus === "success" && dateNow > getAccessTokenData().accessTokenExpiry))) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", generateNewRequestWithRefreshToken({
                        apiInstance: apiInstance,
                        axiosError: axiosError,
                        getAccessTokenData: getAccessTokenData,
                        refreshTokenPromise: refreshTokenPromise,
                        getRefreshTokenConfig: function() {
                            return getRefreshTokenConfig(true);
                        }
                    }));
                case 8:
                    if (!(refreshTokenConfig.refreshingTokenStatus === "initial")) {
                        _ctx.next = 22;
                        break;
                    }
                    refreshTokenConfig.refreshingTokenStatus = "processing";
                    ;
                    _ctx.prev = 11;
                    _ctx.next = 14;
                    return refreshTokenPromise();
                case 14:
                    newAccessToken = _ctx.sent;
                    refreshTokenConfig.refreshingTokenStatus = "success";
                    _ctx.next = 21;
                    break;
                case 18:
                    _ctx.prev = 18;
                    _ctx.t0 = _ctx["catch"](11);
                    throw new Error("Failed Refresh Token");
                case 21:
                    // After refresh token API call success,
                    // proceed every API call within queue
                    refreshTokenConfig.refreshAndRetryQueue.forEach(function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                            var config, resolve, newRequest;
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        config = param.config, resolve = param.resolve;
                                        config.headers.Authorization = "Bearer ".concat(newAccessToken);
                                        _ctx.prev = 2;
                                        _ctx.next = 5;
                                        return apiInstance.request(config);
                                    case 5:
                                        newRequest = _ctx.sent;
                                        resolve(newRequest);
                                        _ctx.next = 12;
                                        break;
                                    case 9:
                                        _ctx.prev = 9;
                                        _ctx.t0 = _ctx["catch"](2);
                                        throw new Error("Failed API call after success refresh token");
                                    case 12:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee, null, [
                                [
                                    2,
                                    9
                                ]
                            ]);
                        }));
                        return function(_) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                case 22:
                    if (!(refreshTokenConfig.refreshingTokenStatus === "success")) {
                        _ctx.next = 30;
                        break;
                    }
                    if (!(axiosError.config.headers.Authorization === "Bearer ".concat(getAccessTokenData().accessToken))) {
                        _ctx.next = 25;
                        break;
                    }
                    throw new Error("Token Alreadry Refreshed");
                case 25:
                    // Proceed new incoming API call with new API token
                    axiosError.config.headers.Authorization = "Bearer ".concat(getAccessTokenData().accessToken);
                    _ctx.next = 28;
                    return apiInstance.request(axiosError.config);
                case 28:
                    newRequest = _ctx.sent;
                    return _ctx.abrupt("return", newRequest);
                case 30:
                    if (refreshTokenConfig.refreshingTokenStatus === "failed") {
                        refreshTokenConfig.refreshAndRetryQueue.forEach(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param, index) {
                                var reject;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            reject = param.reject;
                                            reject(axiosError);
                                            if (index === refreshTokenConfig.refreshAndRetryQueue.length - 1) {
                                                refreshTokenConfig.refreshAndRetryQueue = [];
                                            }
                                        case 3:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(_, index) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                    }
                    _ctx.next = 37;
                    break;
                case 33:
                    _ctx.prev = 33;
                    _ctx.t1 = _ctx["catch"](3);
                    if (typeof refreshTokenConfig !== "undefined") {
                        refreshTokenConfig.refreshingTokenStatus = "failed";
                    }
                    return _ctx.abrupt("return", Promise.reject(_ctx.t1));
                case 37:
                    return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                        getRefreshTokenConfig().refreshAndRetryQueue.push({
                            config: axiosError.config,
                            resolve: resolve,
                            reject: reject
                        });
                    }));
                case 38:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                3,
                33
            ],
            [
                11,
                18
            ]
        ]);
    }));
    return function generateNewRequestWithRefreshToken(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var refreshToken = (generateNewRequestWithRefreshToken);

// EXTERNAL MODULE: ./src/config/refreshToken/exodus.ts
var exodus = __webpack_require__(14350);
// EXTERNAL MODULE: ./src/config/APIErrorMessage/utils.ts
var utils = __webpack_require__(63858);
// EXTERNAL MODULE: ./src/config/APIErrorMessage/index.js + 1 modules
var APIErrorMessage = __webpack_require__(60714);
;// CONCATENATED MODULE: ./src/config/requestExodus.ts















var APIExodusErrorHandler = APIErrorMessage/* default.APIExodusErrorHandler */.Z.APIExodusErrorHandler;
function requestExodus() {
    var isShowAlertMessage = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, customUserAgent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, extraHeaders = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var headers = (0,_object_spread/* default */.Z)({
        Accept: "application/json"
    }, extraHeaders);
    if (customUserAgent) {
        headers = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, headers), {
            "User-Agent": api/* CUSTOM_USER_AGENT */.GV
        });
    }
    var apiInstance = axios_default().create({
        baseURL: api/* API_EXODUS_URL */.q7,
        headers: headers
    });
    apiInstance.interceptors.request.use(function(request) {
        var ref, ref1;
        var requestFromBrowser = (0,app/* isClient */.C5)();
        if (!requestFromBrowser) {
            return request;
        }
        if (!(window === null || window === void 0 ? void 0 : (ref = window.navigator) === null || ref === void 0 ? void 0 : ref.onLine)) {
            (0,AlertErrorMessage/* default */.Z)(errorMessage/* default.OFFLINE */.Z.OFFLINE, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
            return Promise.reject(errorMessage/* default.OFFLINE */.Z.OFFLINE);
        }
        // Custom Authorization Header Exist
        if (request.headers.Authorization) {
            return request;
        }
        // Default Authorization
        var parsedToken = auth/* default.getToken */.Z.getToken();
        var token = parsedToken === null || parsedToken === void 0 ? void 0 : (ref1 = parsedToken.accessToken) === null || ref1 === void 0 ? void 0 : ref1.token;
        if (request.url !== "/user/setting/password/reset" && token) {
            // eslint-disable-next-line no-param-reassign
            request.headers.Authorization = "Bearer ".concat(token);
        }
        return request;
    }, function(error) {
        return Promise.reject(error);
    });
    apiInstance.interceptors.response.use(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(response) {
            var responseRetrieveFromBrowser, _data, errorType, _message, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        responseRetrieveFromBrowser = (0,app/* isClient */.C5)();
                        if (responseRetrieveFromBrowser) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", response);
                    case 3:
                        _data = response.data, errorType = _data.error_type, _message = _data.message, message = _message === void 0 ? errorMessage/* default.DEFAULT_ERROR_MESSAGE */.Z.DEFAULT_ERROR_MESSAGE : _message;
                        if (!(errorType && isShowAlertMessage)) {
                            _ctx.next = 7;
                            break;
                        }
                        (0,AlertErrorMessage/* default */.Z)(message, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
                        throw message;
                    case 7:
                        return _ctx.abrupt("return", response);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(response) {
            return _ref.apply(this, arguments);
        };
    }(), function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(axiosError) {
            var ref, ref1, ref2, ref3, responseRetrieveFromBrowser, newRequest, _response, status, data, message, errorType, errors, parsedMessage;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        responseRetrieveFromBrowser = (0,app/* isClient */.C5)();
                        if (responseRetrieveFromBrowser) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return", Promise.reject(axiosError));
                    case 4:
                        if (axiosError === null || axiosError === void 0 ? void 0 : axiosError.response) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return", Promise.reject(axiosError));
                    case 6:
                        //-------------------------------------------
                        // Error Logger
                        (0,logger/* sentryLog */.gB)({
                            scope: "server-layer",
                            level: "info",
                            httpStatusCode: (ref = axiosError.response) === null || ref === void 0 ? void 0 : ref.status,
                            tags: [
                                {
                                    title: "api-error-url",
                                    value: axiosError === null || axiosError === void 0 ? void 0 : (ref1 = axiosError.request) === null || ref1 === void 0 ? void 0 : ref1.responseURL
                                },
                                {
                                    title: "api-error-text",
                                    value: axiosError === null || axiosError === void 0 ? void 0 : (ref2 = axiosError.request) === null || ref2 === void 0 ? void 0 : ref2.responseText
                                }, 
                            ],
                            error: new Error(axiosError.message)
                        });
                        if (![
                            401
                        ].includes((ref3 = axiosError.response) === null || ref3 === void 0 ? void 0 : ref3.status)) {
                            _ctx.next = 19;
                            break;
                        }
                        _ctx.prev = 8;
                        _ctx.next = 11;
                        return refreshToken({
                            apiInstance: apiInstance,
                            axiosError: axiosError,
                            getRefreshTokenConfig: exodus/* getRefreshTokenConfigFn */.oD,
                            getAccessTokenData: exodus/* getAccessTokenDataFn */.RL,
                            refreshTokenPromise: exodus/* refreshExodusToken */.x5
                        });
                    case 11:
                        newRequest = _ctx.sent;
                        return _ctx.abrupt("return", newRequest);
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](8);
                        (0,utils/* dispatchSetErrorCode */.S)(401);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 19:
                        _response = axiosError.response, status = _response.status, data = _response.data;
                        message = data === null || data === void 0 ? void 0 : data.message;
                        errorType = data === null || data === void 0 ? void 0 : data.error_type;
                        errors = (data === null || data === void 0 ? void 0 : data.errors) || [];
                        // Some error message is unparsed in `message`
                        if (!errorType && message) {
                            parsedMessage = JSON.parse(message);
                            message = parsedMessage.message;
                            errorType = parsedMessage.error_type;
                        }
                        if (isShowAlertMessage) {
                            _ctx.next = 26;
                            break;
                        }
                        return _ctx.abrupt("return", Promise.reject(new Error(axiosError.message, {
                            cause: {
                                status: status,
                                message: message,
                                errorType: errorType,
                                errors: errors
                            }
                        })));
                    case 26:
                        APIExodusErrorHandler(status, errorType, message);
                        return _ctx.abrupt("return", Promise.reject(new Error(axiosError.message, {
                            cause: {
                                status: status,
                                message: message,
                                errorType: errorType,
                                errors: errors
                            }
                        })));
                    case 28:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    8,
                    15
                ]
            ]);
        //-------------------------------------------
        }));
        return function(axiosError) {
            return _ref.apply(this, arguments);
        };
    }());
    return apiInstance;
}
/* harmony default export */ var config_requestExodus = (requestExodus);


/***/ }),

/***/ 37213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BW": function() { return /* binding */ STOCKBIT_ACADEMY_URL; },
/* harmony export */   "CT": function() { return /* binding */ API_BASE_URL; },
/* harmony export */   "Cb": function() { return /* binding */ API_TRADING_URL; },
/* harmony export */   "EU": function() { return /* binding */ DESKTOP_APP_UPDATER_URL; },
/* harmony export */   "GV": function() { return /* binding */ CUSTOM_USER_AGENT; },
/* harmony export */   "J3": function() { return /* binding */ GIPHY_STICKERS_URL; },
/* harmony export */   "Me": function() { return /* binding */ AWS_IMAGES_BUCKET; },
/* harmony export */   "UY": function() { return /* binding */ GIPHY_API_KEY; },
/* harmony export */   "VE": function() { return /* binding */ GOOGLE_PLAY_URL; },
/* harmony export */   "ZB": function() { return /* binding */ API_CURATOR_URL; },
/* harmony export */   "_O": function() { return /* binding */ SITE_URL; },
/* harmony export */   "cU": function() { return /* binding */ AWS_AVATAR_BUCKET; },
/* harmony export */   "cu": function() { return /* binding */ API_TRADING_URL_V2; },
/* harmony export */   "fN": function() { return /* binding */ GIPHY_URL; },
/* harmony export */   "jd": function() { return /* binding */ CURATOR_FEED_ID; },
/* harmony export */   "kg": function() { return /* binding */ API_SECURITIES_GENERAL_URL; },
/* harmony export */   "l5": function() { return /* binding */ APP_STORE_URL; },
/* harmony export */   "lZ": function() { return /* binding */ FACEBOOK_APP_ID; },
/* harmony export */   "oV": function() { return /* binding */ SENTRY_ENV; },
/* harmony export */   "oj": function() { return /* binding */ SENTRY_DSN; },
/* harmony export */   "q$": function() { return /* binding */ AVATAR_URL; },
/* harmony export */   "q7": function() { return /* binding */ API_EXODUS_URL; },
/* harmony export */   "rM": function() { return /* binding */ AWS_EBOOK_BUCKET; },
/* harmony export */   "uJ": function() { return /* binding */ GOPAY_URL_JAVASCRIPT; },
/* harmony export */   "vw": function() { return /* binding */ AWS_TRADE_REG_BUCKET; }
/* harmony export */ });
/* unused harmony exports STAGE, API_SECURITIES_ALT_URL, SOCKET_URL, AWS_CHAT_BUCKET, GOPAY_QR_CODE_URL, GOPAY_REF_ID_URL, API_VERSION_ALT, CURATOR_TOKEN, APPLE_APP_SITE_ID */
/* provided dependency */ var process = __webpack_require__(34155);
var STAGE = (/* unused pure expression or super */ null && ("production" || 0));
var SITE_URL = "https://stockbit.com" || 0;
var SOCKET_URL = (/* unused pure expression or super */ null && ("https://ws3.stockbit.com/"));
// Separate the version with base URL, if we need more version
// just add from `.env`, then add them into this file
var API_VERSION = "v2.5";
var API_VERSION_ALT = "v2.4" || 0;
var API_BASE_URL = "".concat("https://api.stockbit.com", "/").concat(API_VERSION);
var API_EXODUS_URL = "https://exodus.stockbit.com";
var API_TRADING_URL = "https://trading.masonline.id";
var API_TRADING_URL_V2 = "https://carina.stockbit.com";
var API_SECURITIES_ALT_URL = "".concat("https://api.stockbit.com", "/").concat(API_VERSION_ALT);
// Can be used with social or trading authorization
var API_SECURITIES_GENERAL_URL = "https://api-sekuritas.stockbit.com";
var API_CURATOR_URL = "https://api.curator.io";
var AVATAR_URL = "https://avatar.stockbit.com" || 0;
var AWS_AVATAR_BUCKET = "https://avatar.stockbit.com" || 0;
var AWS_IMAGES_BUCKET = "https://stockbit.s3.amazonaws.com";
var AWS_TRADE_REG_BUCKET = "https://simasreg.s3.amazonaws.com";
var AWS_EBOOK_BUCKET = "https://s3-ap-southeast-1.amazonaws.com/ebookstbx";
var AWS_CHAT_BUCKET = process.env.NEXT_PUBLIC_AWS_CHAT_BUCKET;
var GIPHY_URL = "https://api.giphy.com/v1/gifs";
var GIPHY_STICKERS_URL = "https://api.giphy.com/v1/stickers";
var GIPHY_API_KEY = "ZME7nTxOPIqXCf9qhCfqB1ICqtFCbCs5" || 0;
var GOPAY_URL_JAVASCRIPT = "https://app.midtrans.com/snap/snap.js" || 0;
var GOPAY_QR_CODE_URL = (/* unused pure expression or super */ null && ("https://api.sandbox.veritrans.co.id/v2/gopay/" || 0));
var GOPAY_REF_ID_URL = (/* unused pure expression or super */ null && ("https://simulator.sandbox.midtrans.com/gopay/ui/checkout?referenceid=" || 0));
var FACEBOOK_APP_ID = "247631672013136" || 0;
// link to download stockbit app
var GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.stockbit.android&hl=en";
var APP_STORE_URL = "https://itunes.apple.com/us/app/stockbit/id1184800207?mt=8";
var STOCKBIT_ACADEMY_URL = "https://academy.stockbit.com";
var CUSTOM_USER_AGENT = "webapp-api-293bf2f3-2d64-4948-94dd-9277ebbe96d";
var DESKTOP_APP_UPDATER_URL = "https://sda-updater.stockbit.com";
var CURATOR_TOKEN = (/* unused pure expression or super */ null && ("ae406fc1-d23a-4a34-a0c9-164c7d2204ea"));
var CURATOR_FEED_ID = "1e81f0c0-550d-492e-b3ae-0dd4706df21f";
var APPLE_APP_SITE_ID = (/* unused pure expression or super */ null && ("ASHUNREKRL.stockbit.com.stockbit"));
var SENTRY_DSN = "https://98926e1d329e4da4bf7a3dc35a3f2ee9@sentry.stockbit.io/167";
var SENTRY_ENV = "production";



/***/ }),

/***/ 86123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ax": function() { return /* binding */ GTM_ID; },
/* harmony export */   "C5": function() { return /* binding */ isClient; },
/* harmony export */   "Vc": function() { return /* binding */ assetPrefix; },
/* harmony export */   "ah": function() { return /* binding */ TRADING_VIEW_ASSET; },
/* harmony export */   "cU": function() { return /* binding */ AWS_AVATAR_BUCKET; },
/* harmony export */   "d7": function() { return /* binding */ CLEVERTAP_ID; },
/* harmony export */   "m6": function() { return /* binding */ TRADING_VIEW_ASSET_PREFIX; },
/* harmony export */   "mM": function() { return /* binding */ assetsStatic; },
/* harmony export */   "or": function() { return /* binding */ STAGE; },
/* harmony export */   "qV": function() { return /* binding */ PROJECT_FOLDER_PATH; },
/* harmony export */   "sP": function() { return /* binding */ PROJECT_FOLDER; },
/* harmony export */   "t0": function() { return /* binding */ CRISP_ID; },
/* harmony export */   "yv": function() { return /* binding */ isProduction; },
/* harmony export */   "yz": function() { return /* binding */ siteUrl; }
/* harmony export */ });
/* unused harmony exports CDN, R2_ASSET_PREFIX, FB_APP_ID, USER_AGENT, OPEN_HOUR, CLOSE_HOUR, isMarketOpen, STRUCTURED_DATA */
/* provided dependency */ var process = __webpack_require__(34155);
var PROJECT_FOLDER = process.env.NEXT_PUBLIC_PROJECT_FOLDER;
var PROJECT_FOLDER_PATH = PROJECT_FOLDER ? "/".concat(PROJECT_FOLDER) : "";
var CDN = "https://stockbit.com" || 0;
var assetPrefix = CDN ? "".concat(CDN).concat(PROJECT_FOLDER_PATH) : "";
var R2_ASSET_PREFIX = "https://web-assets.stockbit.com";
var TRADING_VIEW_ASSET_PREFIX = process.env.NEXT_PUBLIC_TV_ASSET || "https://stockbit.com/tradingview/charting_library/";
var TRADING_VIEW_ASSET = "https://storage.stockbit.com/assets/tradingview/" || 0;
var FB_APP_ID = (/* unused pure expression or super */ null && ("247631672013136" || 0));
var GTM_ID = "GTM-5DQC6T3" || 0;
var siteUrl = "https://stockbit.com" || 0;
var STAGE = "production" || 0;
var CLEVERTAP_ID = "6ZW-897-5R6Z";
var AWS_AVATAR_BUCKET = "https://avatar.stockbit.com" || 0;
var USER_AGENT = (/* unused pure expression or super */ null && ("webapp-api-293bf2f3-2d64-4948-94dd-9277ebbe96d" || 0));
var CRISP_ID = "44ed90bf-ce78-4f5f-a9f8-82e000538b9b" || 0;
var isClient = function() {
    return "object" !== "undefined";
};
var isProduction = "production" === "production";
// Market hour
var OPEN_HOUR = 9;
var CLOSE_HOUR = 15;
var isMarketOpen = function() {
    var currentTime = new Date().getHours();
    // return currentTime >= OPEN_HOUR && currentTime <= CLOSE_HOUR;
    return currentTime >= OPEN_HOUR;
};
var STRUCTURED_DATA = {
    "@context": "http://schema.org",
    "@type": "Corporation",
    name: "Stockbit",
    legalName: "Stockbit",
    description: "Stockbit adalah komunitas investasi di Indonesia. Stockbit memberi ruang bagi investor dan trader untuk berbagi ide, berita dan informasi keuangan lainya secara real-time. Pengguna bisa membuat profil dan mengikuti saham tertentu atau investor favorit untuk mendapatkan informasi berharga dan bertukar pikiran. Fitur utama dari Stockbit yaitu 'stream' terdiri dari ide-ide, grafik saham, link dan data keuangan lainya. Stockbit menggunakan tanda '$' sebelum kode saham sebagai penandaan ide untuk mempermudah pengguna dalam mencari informasi tentang saham individu tertentu. Platform Stockbit juga terintegrasi dengan platform social media lainya, seperti Twitter dan Facebook, sehingga mudah untuk berbagi ide-ide di Stockbit ke akun Twitter dan Facebook pengguna. Stockbit dirancang dengan fitur yang terfokus dengan keperilakuan investor dan trader sehingga akan lebih berguna sebagai social media khusus investasi.",
    logo: "https://assets-nextjs.stockbit.com/img/favicon.ico",
    url: "https://stockbit.com",
    telephone: "+6221 57906242",
    sameAs: [
        "https://twitter.com/Stockbit",
        "https://www.linkedin.com/company/stockbit",
        "https://www.facebook.com/Stockbit",
        "https://www.youtube.com/c/Stockbit",
        "https://instagram.com/stockbit",
        "https://www.crunchbase.com/organization/stockbit", 
    ],
    address: {
        "@type": "PostalAddress",
        streetAddress: "RDTX Square 33rd Floor, Jl. Prof. Dr. Satrio No 164 - Jakarta",
        addressLocality: "Jakarta Selatan",
        postalCode: "12930",
        addressCountry: "Indonesia"
    }
};
var assetsStatic = "".concat("https://assets.stockbit.com");


/***/ }),

/***/ 61608:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var ERROR_MESSAGE = {
    ALERT_RED: "alert-red",
    DEFAULT: "DEFAULT",
    MAINTENANCE: "MAINTENANCE",
    NOPERMISSION: "NOPERMISSION",
    NOTRADINGPERMISSION: "NOTRADINGPERMISSION",
    INVALIDPARAMETER: "INVALIDPARAMETER",
    INVALID_PARAMETER: "INVALID_PARAMETER",
    INVALID_RECAPTCHA: "INVALID_RECAPTCHA",
    INVALID_LOGIN: "INVALID_LOGIN",
    ERR_SYSTEM: "ERR_SYSTEM",
    ERR_INVALID_PARAMS: "ERR_INVALID_PARAMS",
    ERR_ORDER_FAIL: "ERR_ORDER_FAIL",
    ERR_PIN_INVALID: "ERR_PIN_INVALID",
    ERR_LOGIN_FAIL: "ERR_LOGIN_FAIL",
    INVALID_AMEND: "INVALID_AMEND",
    INVALID_PIN: "INVALID_PIN",
    SYSTEMERROR: "SYSTEMERROR",
    NOTFOUND: "NOTFOUND",
    NOSUBSCRIPTION: "NOSUBSCRIPTION",
    PAYWALL_ERROR: "PAYWALL",
    PAYWALL_NOSUBSCRIPTION: "NO_SUBSCRIPTION",
    NOPHONEVERIFY: "NOPHONEVERIFY",
    UNAUTHORIZED: "UNAUTHORIZED",
    FORBIDDEN: "FORBIDDEN",
    SERVICE_BUSY: "SERVICE_BUSY",
    INVALID_SESSION: "INVALID_SESSION",
    ERR_LOGIN_AUTHORIZATION: "ERR_LOGIN_AUTHORIZATION",
    ERR_PIN_AUTHORIZATION: "ERR_PIN_AUTHORIZATION",
    ERR_UNKNOWN_BROKER: "ERR_UNKNOWN_BROKER",
    INCORRECT_PIN: "INCORRECT_PIN",
    INVALID_CREDS: "INVALID_CREDS",
    UNKNOWN_SYSTEM_ERROR: "Kondisi Internet Kamu Sedang Tidak Stabil.",
    OFFLINE: "Kondisi internet kamu sedang tidak stabil",
    DEFAULT_ERROR_MESSAGE: "Something is terribly wrong, please contact our administrator",
    PERMISSION_DENIED: "You do not have enough permission to access the resources",
    // error message upload avatar onboarding
    UPLOAD_FAILED: "Upload Failed",
    PLEASE_LOAD_IMAGE: "Please load an image",
    UPLOAD_IMAGE_TYPE_NOT_SUPPORTED: "Only image file (type: JPEG, JPG, PNG, and GIF) allowed",
    UPLOAD_DOCUMENT_TYPE_NOT_SUPPORTED: "Only document file (type: PDF, DOC, DOCX, PPT, PPTX, XLS and XLSX) allowed",
    MAX_FILE_SIZE: "Max File Size 2Mb",
    INVALID_AVATAR_EXTENSION: "Only image file (type: JPEG, JPG, and PNG) allowed",
    // stream error message
    DOCUMENT_IMAGE_NOT_ALLOWED: 'Image files (such as jpg, jpeg, png, gif) are not allowed to be uploaded from "Attach Document" input',
    MAX_UPLOAD_FILES: "Maximum of 1 file uploads allowed",
    STREAM_TEXT_REQUIRED: "Text is required in posts",
    STREAM_TARGET_PRICE_REQUIRED: "Target Price is required in posts",
    STREAM_ERROR_UPLOAD_FILE: "Upload file error",
    ACADEMY_ERROR_MESSAGE: "Failed to open Academy, Please reload this page",
    // Screener
    SCREENER_SPECIFY_RULES: "Please enter at least one screening rule",
    SCREENER_SPECIFY_RULES_VALUE: "Please enter a value on your screening rule",
    // Tipping
    TIPPING_MAX_AMOUNT_ERROR: "Jumlah Maksimal Tip Rp 10,000,000",
    // Fundachart
    MAX_METRICES_AND_SYMBOLS: "Harap pilih tidak lebih dari total 10 parameter (perusahaan/metrik) untuk bagan",
    // Chartbit
    LOAD_TEMPLATE: "Failed to load template",
    SAVE_TEMPLATE: "Failed to save template"
};
/* harmony default export */ __webpack_exports__["Z"] = (ERROR_MESSAGE);


/***/ }),

/***/ 44252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BP": function() { return /* binding */ REGISTRATION_DATA; },
/* harmony export */   "Nv": function() { return /* binding */ REFRESH_TOKEN_KEY_EXP; },
/* harmony export */   "Wx": function() { return /* binding */ ACCESS_TOKEN_KEY; },
/* harmony export */   "ns": function() { return /* binding */ ACCESS_USER_KEY; },
/* harmony export */   "w4": function() { return /* binding */ REFRESH_TOKEN_KEY; },
/* harmony export */   "z0": function() { return /* binding */ ACCESS_TOKEN_KEY_EXP; }
/* harmony export */ });
var ACCESS_TOKEN_KEY = "at";
var ACCESS_TOKEN_KEY_EXP = "ate";
var REFRESH_TOKEN_KEY = "ar";
var REFRESH_TOKEN_KEY_EXP = "are";
var ACCESS_USER_KEY = "au";
var REGISTRATION_DATA = "registerData";


/***/ }),

/***/ 41208:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var SUCCESS_MESSAGE = {
    ALERT_GREEN: "alert-green",
    SNACKBAR_GREEN: "snackbar-green",
    PROFILE_UPDATED: "Profile Updated",
    POST_SUCCESSFUL: "Post successful",
    REPOST_SUCCESSFUL: "Post Reposted",
    REPLY_SUCCESSFUL: "Post reply successful!",
    SET_TOP_SUCCESSFUL: "Set as Top successful!",
    REMOVE_TOP_SUCCESSFUL: "Remove as Top successful!",
    RESET_TOP_SUCCESSFUL: "Reset as Top successful!",
    UNTAG_POST_SUCCESSFUL: "Untag Post Topic Success",
    PASSWORD_CHANGED: "Password changed",
    USER_BLOCKED: "User blocked",
    USER_UNBLOCKED: "User unblocked",
    CHANGE_NUMBER_SUCCESSFUL: "Phone number changed!",
    SAVE_TEMPLATE_SUCCESS: "Success save template",
    POST_SHARED_SUCCESSFUL: "Post Shared",
    EVENT_SHARED_SUCCESSFUL: "Event Shared",
    POST_PINNED_SUCCESSFUL: "Post successfully pinned",
    POST_UNPINNED_SUCCESSFUL: "Post successfully unpinned",
    POST_SUCCESSFUL_UPDATE: "Post successfully updated",
    POST_SUCCESSFUL_DELETED: "Successfully deleted",
    SCREENER_TEMPLATE_DELETED: "Screener Template Deleted",
    FACEBOOK_CONNECTED: "Facebook connect successful",
    GOPAY_CHANGED: "Nomor gopay anda berhasil diubah",
    REPORT_DELIVERED: "Success Report User",
    UPDATE_GROUP_PHOTO_SUCCESSFUL: "Group Photo Updated",
    DELETE_STREAM_MULTIPLE_SUCCESSFUL: "Success delete stream",
    FINANCIAL_COLUMN_DELETED: "Financial Column Deleted"
};
/* harmony default export */ __webpack_exports__["Z"] = (SUCCESS_MESSAGE);


/***/ }),

/***/ 51077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A$": function() { return /* binding */ getLocalUserSetting; },
/* harmony export */   "AX": function() { return /* binding */ checkIfDefaultLightMode; },
/* harmony export */   "CQ": function() { return /* binding */ normalizeSymbol; },
/* harmony export */   "Ew": function() { return /* binding */ overrideSavedDataToDesktopDarkMode; },
/* harmony export */   "Fj": function() { return /* binding */ normalizeToSeriesId; },
/* harmony export */   "Fr": function() { return /* binding */ getUnix; },
/* harmony export */   "HE": function() { return /* binding */ injectCustomSetting; },
/* harmony export */   "HY": function() { return /* binding */ getStudyParam; },
/* harmony export */   "Hh": function() { return /* binding */ mapSymbolOnChart; },
/* harmony export */   "Hu": function() { return /* binding */ getWidgetBarAPI; },
/* harmony export */   "IC": function() { return /* binding */ isTVIntraday; },
/* harmony export */   "KG": function() { return /* binding */ getTVDocument; },
/* harmony export */   "L$": function() { return /* binding */ getChartSymbol; },
/* harmony export */   "Ln": function() { return /* binding */ overrideCandleColorOnLoad; },
/* harmony export */   "Mx": function() { return /* binding */ roundPriceByFraction; },
/* harmony export */   "Ok": function() { return /* binding */ overrideCandleColor; },
/* harmony export */   "PW": function() { return /* binding */ checkThemeToOverride; },
/* harmony export */   "U": function() { return /* binding */ preProsesFailedLoadSetting; },
/* harmony export */   "U$": function() { return /* binding */ overrideDesktopDarkMode; },
/* harmony export */   "U7": function() { return /* binding */ getTVWindow; },
/* harmony export */   "V3": function() { return /* binding */ prepareLayoutBeforeLoad; },
/* harmony export */   "VB": function() { return /* binding */ fixDefaultSymbol; },
/* harmony export */   "WS": function() { return /* binding */ isSideToolbarOpen; },
/* harmony export */   "Ws": function() { return /* binding */ checkTextColor; },
/* harmony export */   "Xd": function() { return /* binding */ hideDrawingTemplateSaveMenu; },
/* harmony export */   "Y$": function() { return /* binding */ overrideHtmlClass; },
/* harmony export */   "ZI": function() { return /* binding */ saveClientTheme; },
/* harmony export */   "_4": function() { return /* binding */ injectDefaultRightOffset; },
/* harmony export */   "ad": function() { return /* binding */ compressString; },
/* harmony export */   "bC": function() { return /* binding */ compressChart; },
/* harmony export */   "bd": function() { return /* binding */ normalizeDrawingSourceSymbol; },
/* harmony export */   "cn": function() { return /* binding */ decompressChart; },
/* harmony export */   "e5": function() { return /* binding */ mergeLocalAndApi; },
/* harmony export */   "fO": function() { return /* binding */ fixV26StudyDrawing; },
/* harmony export */   "gQ": function() { return /* binding */ overrideDefaultTheme; },
/* harmony export */   "ih": function() { return /* binding */ optionalArray; },
/* harmony export */   "mB": function() { return /* binding */ localizedColors; },
/* harmony export */   "ob": function() { return /* binding */ injectThemeToSavedLayout; },
/* harmony export */   "pu": function() { return /* binding */ getDataFromTicker; },
/* harmony export */   "qQ": function() { return /* binding */ manipulateContextMenu; },
/* harmony export */   "rY": function() { return /* binding */ getLanguageFromURL; },
/* harmony export */   "uH": function() { return /* binding */ selectTVElementByQuery; },
/* harmony export */   "vq": function() { return /* binding */ checkIfDefaultCandle; },
/* harmony export */   "yn": function() { return /* binding */ getClientTheme; },
/* harmony export */   "zV": function() { return /* binding */ isWidgetbarMinimized; },
/* harmony export */   "zv": function() { return /* binding */ normalizeDrawingGroupSymbol; }
/* harmony export */ });
/* unused harmony exports isMainSeriesExist, injectSymbolToMainSeries, fixHiddenExchangeAndInterval, resolveOldStudy, validateLayout, changeTheme, overrideByTheme, getTVResolution, isTVReady */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(828);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91635);
/* harmony import */ var global_AlertMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6430);
/* harmony import */ var jszip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55733);
/* harmony import */ var jszip__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(jszip__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(12902);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _config_template__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66483);
/* harmony import */ var _chartbit_store__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32713);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83153);
/* eslint-disable no-use-before-define */ /* eslint-disable no-param-reassign */ /* eslint-disable guard-for-in */ /* eslint-disable no-restricted-syntax */ /* eslint-disable no-underscore-dangle */ 











// eslint-disable-next-line import/no-cycle


var lightTemplate = _config_template__WEBPACK_IMPORTED_MODULE_5__/* ["default"][0].template */ .Z[0].template;
var darkTemplate = _config_template__WEBPACK_IMPORTED_MODULE_5__/* ["default"][1].template */ .Z[1].template;
var getClientTheme = function(tvWidgetKey) {
    try {
        if (window && window.tvWidget && window.tvWidget[tvWidgetKey]) {
            return window.tvWidget[tvWidgetKey].getTheme();
        }
        return window.localStorage.getItem("stradingview.current_theme.name") || "light";
    } catch (error) {
        (0,utils_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(error, {
            event: "getClientTheme",
            place: "TradingView/utils"
        });
        return "light";
    }
};
var isMainSeriesExist = function(layout) {
    return layout.charts[0].panes.some(function(param) {
        var sources = param.sources;
        return sources.some(function(param) {
            var type = param.type;
            return type && type.toUpperCase() === "MAINSERIES";
        });
    });
};
var injectSymbolToMainSeries = function(source, symbol) {
    var newSource = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, source);
    if (newSource.type && newSource.type.toUpperCase() === "MAINSERIES" && newSource.state) {
        newSource.state.symbol = symbol.toUpperCase();
        newSource.state.shortName = symbol.toUpperCase();
    }
    return newSource;
};
var fixHiddenExchangeAndInterval = function(source) {
    var newSource = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, source);
    if (newSource.type && newSource.type.toUpperCase() === "MAINSERIES" && newSource.state) {
        // We need to set all saved layout in Database showExhance, showInterval to true
        // Hiding Exchange and Interval for mobile now is controlled by CSS in custom-mobile.css
        newSource.state.statusViewStyle.showExchange = true;
        newSource.state.statusViewStyle.showInterval = true;
    }
    return newSource;
};
var resolveOldStudy = function(source) {
    var newSource = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, source);
    if (newSource.type && newSource.type.toUpperCase() === "STUDY" && newSource.state) {
        var ref, ref1;
        // `source.state.inputs.in_1` will be used to identify is the old data already resolved
        // other data still being keep for unexpected issues in the future
        switch((ref = source.state) === null || ref === void 0 ? void 0 : (ref1 = ref.shortId) === null || ref1 === void 0 ? void 0 : ref1.toUpperCase()){
            case "MOVING AVERAGE":
            case "MOVING AVERAGE EXPONENTIAL":
            case "MOVING AVERAGE WEIGHTED":
                {
                    if (source.state.inputs && source.state.inputs.in_1 !== undefined) {
                        newSource.state.inputs.symbol = "";
                        newSource.state.inputs.length = source.state.inputs.in_0;
                        newSource.state.inputs.source = source.state.inputs.in_1;
                        newSource.state.inputs.offset = source.state.inputs.in_2;
                        delete newSource.state.inputs.in_1;
                    }
                    break;
                }
            default:
                {
                    break;
                }
        }
    }
    return newSource;
};
var validateLayout = function(layout) {
    var themeFromStorage = getClientTheme();
    var fallbackTemplate = themeFromStorage.toLowerCase() === "dark" ? darkTemplate : lightTemplate;
    // probably API load layout error
    if (!layout) return fallbackTemplate;
    // `layout.layout` is used to differentiate Old and New layout schema
    if (!layout.layout) {
        // Old Layout Schema (probably generated when accessing old tradingview versions).
        // Migrate old layout to new layout schema
        var newLayout = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, fallbackTemplate);
        if (layout.panes) {
            newLayout.charts[0].panes = layout.panes;
        }
        if (layout.theme) {
            newLayout.charts[0].theme = layout.theme;
        }
        if (layout.chartProperties) {
            newLayout.charts[0].chartProperties = layout.chartProperties;
        }
        return newLayout;
    }
    if (!isMainSeriesExist(layout)) return fallbackTemplate;
    return layout;
};
var changeTheme = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(tvWidgetKey, theme) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (window.tvWidget) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", false);
                case 2:
                    return _ctx.abrupt("return", window.tvWidget[tvWidgetKey].changeTheme(theme));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function changeTheme(tvWidgetKey, theme) {
        return _ref.apply(this, arguments);
    };
}();
var overrideCandleColor = function(tvWidget, theme) {
    if (!tvWidget) return;
    switch(theme){
        case "light":
            tvWidget.applyOverrides({
                "mainSeriesProperties.candleStyle.upColor": "#00AB6B",
                "mainSeriesProperties.candleStyle.downColor": "#EE4A49",
                "mainSeriesProperties.candleStyle.wickUpColor": "#00AB6B",
                "mainSeriesProperties.candleStyle.wickDownColor": "#EE4A49",
                "mainSeriesProperties.candleStyle.borderColor": "#00AB6B",
                "mainSeriesProperties.candleStyle.borderUpColor": "#00AB6B",
                "mainSeriesProperties.candleStyle.borderDownColor": "#EE4A49",
                "mainSeriesProperties.statusViewStyle.showExchange": true,
                "mainSeriesProperties.statusViewStyle.showInterval": true
            });
            break;
        case "dark":
            tvWidget.applyOverrides({
                "mainSeriesProperties.candleStyle.upColor": "#0BA16B",
                "mainSeriesProperties.candleStyle.downColor": "#D74342",
                "mainSeriesProperties.candleStyle.wickUpColor": "#0BA16B",
                "mainSeriesProperties.candleStyle.wickDownColor": "#D74342",
                "mainSeriesProperties.candleStyle.borderColor": "#0BA16B",
                "mainSeriesProperties.candleStyle.borderUpColor": "#0BA16B",
                "mainSeriesProperties.candleStyle.borderDownColor": "#D74342",
                "mainSeriesProperties.statusViewStyle.showExchange": true,
                "mainSeriesProperties.statusViewStyle.showInterval": true
            });
            break;
        default:
            break;
    }
};
// localize other platform after being forced to change to desktop colors
var localizedColors = function(chartLayout) {
    var overrideLayout = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, chartLayout);
    var toOverride = [];
    if (chartLayout) {
        overrideLayout.layout.charts.forEach(function(x) {
            var temp = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, x);
            if (overrideLayout.theme === "dark") {
                if (x.chartProperties.paneProperties.background.toLowerCase() === "#fff" || x.chartProperties.paneProperties.background.toLowerCase() === "#ffffff" || x.chartProperties.paneProperties.background.toLowerCase() === "#131722" || x.chartProperties.paneProperties.background.toLowerCase() === "#1f1f1f" && x.chartProperties.paneProperties.backgroundType === "gradient" && x.chartProperties.paneProperties.backgroundEndColor === "#131722") {
                    temp.chartProperties.paneProperties.background = "#1f1f1f";
                    temp.chartProperties.paneProperties.backgroundType = "solid";
                    temp.chartProperties.paneProperties.vertGridProperties.color = "rgba(46, 46, 46, 0.2)";
                    temp.chartProperties.paneProperties.horzGridProperties.color = "rgba(46, 46, 46, 0.2)";
                    if (x.chartProperties.scalesProperties.textColor === "#131722") {
                        temp.chartProperties.scalesProperties.textColor = "#B2B5BE";
                    }
                    if (x.chartProperties.paneProperties.separatorColor === "#2A2E39") {
                        temp.chartProperties.paneProperties.separatorColor = "#E0E3EB";
                    }
                }
                if (x.chartProperties.paneProperties.vertGridProperties.color === "rgba(240, 243, 250, 0.06)" && x.chartProperties.paneProperties.horzGridProperties.color === "rgba(240, 243, 250, 0.06)") {
                    temp.chartProperties.paneProperties.vertGridProperties.color = "rgba(46, 46, 46, 0.2)";
                    temp.chartProperties.paneProperties.horzGridProperties.color = "rgba(46, 46, 46, 0.2)";
                }
            }
            if (overrideLayout.theme === "light" && x.chartProperties.paneProperties.background.toLowerCase() === "#1f1f1f" || x.chartProperties.paneProperties.background.toLowerCase() === "#131722") {
                temp.chartProperties.paneProperties.backgroundType = "solid";
                temp.chartProperties.paneProperties.background = "#FFF";
                temp.chartProperties.paneProperties.vertGridProperties.color = "rgba(237, 237, 237, 0.3)";
                temp.chartProperties.paneProperties.horzGridProperties.color = "rgba(237, 237, 237, 0.3)";
            }
            if (x.chartProperties.scalesProperties.textColor === "#B2B5BE" && overrideLayout.theme === "light") {
                temp.chartProperties.scalesProperties.textColor = "#131722";
            }
            if (x.chartProperties.paneProperties.separatorColor === "#E0E3EB") {
                temp.chartProperties.paneProperties.separatorColor = "#2A2E39";
            }
            if (overrideLayout.theme === "light" && x.chartProperties.paneProperties.vertGridProperties.color === "rgba(42, 46, 57, 0.06)" && x.chartProperties.paneProperties.horzGridProperties.color === "rgba(42, 46, 57, 0.06)") {
                temp.chartProperties.paneProperties.vertGridProperties.color = "rgba(237, 237, 237, 0.3)";
                temp.chartProperties.paneProperties.horzGridProperties.color = "rgba(237, 237, 237, 0.3)";
            }
            toOverride.push(temp);
        });
        overrideLayout.layout.charts = toOverride;
    }
    return overrideLayout;
};
var overrideByTheme = function(theme, chartLayout) {
    if (chartLayout) {
        chartLayout.theme = theme;
        chartLayout.layout.charts[0].chartProperties.scalesProperties.textColor = theme === "dark" ? "#B2B5BE" : "#555";
        chartLayout.layout.charts[0].chartProperties.paneProperties.backgroundType = theme === "dark" ? "gradient" : "solid";
        chartLayout.layout.charts[0].chartProperties.paneProperties.background = theme === "dark" ? "#131722" : "#ffffff";
        if (theme === "dark") {
            chartLayout.layout.charts[0].chartProperties.paneProperties.backgroundGradientStartColor = "#181C27";
            chartLayout.layout.charts[0].chartProperties.paneProperties.backgroundGradientEndColor = "#131722";
        }
        chartLayout.layout.charts[0].panes.forEach(function(param) {
            var sources = param.sources;
            var mainSeries = sources.find(function(param) {
                var type = param.type;
                return type && type.toUpperCase() === "MAINSERIES";
            });
            mainSeries.state.candleStyle.upColor = theme === "dark" ? "#0BA16B" : "#00AB6B";
            mainSeries.state.candleStyle.downColor = theme === "dark" ? "#D74342" : "#EE4A49";
            mainSeries.state.candleStyle.wickUpColor = theme === "dark" ? "#0BA16B" : "#00AB6B";
            mainSeries.state.candleStyle.wickDownColor = theme === "dark" ? "#D74342" : "#EE4A49";
            mainSeries.state.candleStyle.borderColor = theme === "dark" ? "#0BA16B" : "#00AB6B";
            mainSeries.state.candleStyle.borderUpColor = theme === "dark" ? "#0BA16B" : "#00AB6B";
            mainSeries.state.candleStyle.borderDownColor = theme === "dark" ? "#D74342" : "#EE4A49";
        });
    }
    return chartLayout;
};
var prepareLayoutBeforeLoad = function(rawLayout, symbol) {
    var skipOverwriteAxises = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var layout = validateLayout(rawLayout);
    var themeFromServer = layout.charts[0].theme;
    var _tmp;
    _tmp = layout.charts[0].panes.map(function(_param) {
        var sources = _param.sources, /** TV v22 down */ rightAxisState = _param.rightAxisState, /** TV v22 up */ rightAxisesState = _param.rightAxisesState, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_param, [
            "sources",
            "rightAxisState",
            "rightAxisesState"
        ]);
        var newPanes = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, rest), {
            sources: sources.map(function(source) {
                var newSource = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, source);
                newSource = injectSymbolToMainSeries(newSource, symbol);
                newSource = fixHiddenExchangeAndInterval(newSource);
                newSource = resolveOldStudy(newSource);
                return newSource;
            })
        });
        if (rightAxisState) {
            if (!skipOverwriteAxises) rightAxisState.m_priceRange = null;
            newPanes.rightAxisState = rightAxisState;
        }
        if (rightAxisesState) {
            var ref, ref1;
            if (!skipOverwriteAxises && (rightAxisesState === null || rightAxisesState === void 0 ? void 0 : (ref = rightAxisesState[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.state) === null || ref1 === void 0 ? void 0 : ref1.m_priceRange)) {
                rightAxisesState[0].state.m_priceRange = null;
            }
            newPanes.rightAxisesState = rightAxisesState;
        }
        return newPanes;
    }), layout.charts[0].panes = _tmp, _tmp;
    return {
        layout: layout,
        theme: themeFromServer
    };
};
var injectThemeToSavedLayout = function(layout, theme, isDesktop) {
    var newLayout = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, layout);
    try {
        if (!theme || !layout.charts || !layout.charts[0]) return layout;
        newLayout.charts[0].theme = theme;
        if (isDesktop) {
            newLayout.charts[0].theme = "dark";
            newLayout.charts.forEach(function(x, index) {
                x.theme = "dark";
                if (x.chartProperties.paneProperties.background === "#ffffff") {
                    x.chartProperties.paneProperties.background = "#1F1F1F";
                    x.chartProperties.scalesProperties.textColor = "#B2B5BE";
                    x.chartProperties.paneProperties.separatorColor = "#2A2E39";
                    x.chartProperties.paneProperties.separatorColor = "#2A2E39";
                    x.chartProperties.paneProperties.vertGridProperties.color = "rgba(46, 46, 46, 0.2)";
                    x.chartProperties.paneProperties.horzGridProperties.color = "rgba(46, 46, 46, 0.2)";
                }
                if (checkIfDefaultCandle(newLayout, index)) {
                    x.panes[0].sources[0].state.candleStyle.upColor = "#0BA16B";
                    x.panes[0].sources[0].state.candleStyle.downColor = "#D74342";
                    x.panes[0].sources[0].state.candleStyle.wickUpColor = "#0BA16B";
                    x.panes[0].sources[0].state.candleStyle.wickDownColor = "#D74342";
                    x.panes[0].sources[0].state.candleStyle.borderColor = "#0BA16B";
                    x.panes[0].sources[0].state.candleStyle.borderUpColor = "#0BA16B";
                    x.panes[0].sources[0].state.candleStyle.borderDownColor = "#D74342";
                    x.panes[0].sources[0].state.statusViewStyle.showExchange = true;
                    x.panes[0].sources[0].state.statusViewStyle.showInterval = true;
                }
            });
        }
        return newLayout;
    } catch (error) {
        (0,utils_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(error, {
            event: "injectThemeToSavedLayout",
            place: "TradingView/utils"
        });
        return newLayout;
    }
};
var fixV26StudyDrawing = function(layout) {
    var newLayout = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, layout);
    try {
        if (!layout.charts || !layout.charts[0]) return layout;
        newLayout.charts[0].panes.forEach(function(pane) {
            if (pane.sources[0].type === "Study") {
                if (!pane.sources[0].state.shortId) {
                    pane.sources[0].state.shortId = pane.sources[0].metaInfo.shortId;
                }
            }
        });
        return newLayout;
    } catch (error) {
        (0,utils_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(error, {
            event: "fixV26StudyDrawing",
            place: "TradingView/utils"
        });
        return newLayout;
    }
};
var getStudyParam = function(tvWidget, indicator) {
    var inputData = {};
    var overrides = {};
    var options = {};
    var indicatorName = indicator.desc || indicator.name.toLowerCase();
    var lockStudy = false;
    var isOverlay = indicatorName.includes("underlay") || indicatorName.includes("overlay");
    if (indicator.inputData) {
        inputData = typeof indicator.inputData === "function" ? indicator.inputData(tvWidget) : indicator.inputData;
    }
    if (indicator.overrides) overrides = indicator.overrides;
    if (indicator.options) options = indicator.options;
    return [
        indicatorName,
        isOverlay,
        lockStudy,
        inputData,
        overrides,
        options
    ];
};
var getTVDocument = function(parent) {
    if (!document) return null;
    // const selector = '#tv_chart_container > iframe';
    var tvElement = (parent || document).querySelector("iframe");
    if (!tvElement) return null;
    // @ts-ignore
    var tvDocument = tvElement.contentDocument;
    return tvDocument;
};
var getTVWindow = function() {
    if (!document) return null;
    var tvElement = document.querySelector("iframe");
    if (!tvElement) return null;
    var tvWindow = tvElement.contentWindow;
    return tvWindow;
};
var selectTVElementByQuery = function(query, parent) {
    var tvDoc = getTVDocument(parent);
    if (!tvDoc) return null;
    return tvDoc.querySelector(query);
};
var getTVResolution = function(tvWidgetKey) {
    var ref;
    if (!(window === null || window === void 0 ? void 0 : (ref = window.tvWidget) === null || ref === void 0 ? void 0 : ref[tvWidgetKey])) return "";
    return window.tvWidget[tvWidgetKey].activeChart().resolution();
};
var isTVIntraday = function(tvWidgetKey) {
    var ref;
    if (!(window === null || window === void 0 ? void 0 : (ref = window.tvWidget) === null || ref === void 0 ? void 0 : ref[tvWidgetKey])) return false;
    var resolutionInNumber = Number(getTVResolution(tvWidgetKey));
    return !Number.isNaN(resolutionInNumber);
};
var saveClientTheme = function(clientTheme) {
    if (!window) return;
    try {
        window.localStorage.setItem("tvTheme", clientTheme);
        window.localStorage.setItem("stradingview.current_theme.name", clientTheme);
    // eslint-disable-next-line no-empty
    } catch (error) {
        (0,utils_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(error, {
            event: "saveClientTheme",
            place: "TradingView/utils"
        });
    }
};
var overrideDesktopDarkMode = function(tvWidget, theme) {
    if (!tvWidget || theme === "light") return;
    tvWidget.applyOverrides({
        "paneProperties.backgroundType": "solid",
        "paneProperties.background": "#1F1F1F",
        "paneProperties.vertGridProperties.color": "rgba(46, 46, 46, 0.2)",
        "paneProperties.horzGridProperties.color": "rgba(46, 46, 46, 0.2)",
        "scalesProperties.textColor": "#B2B5BE",
        "paneProperties.separatorColor": "#2A2E39"
    });
};
var overrideDefaultTheme = function(tvWidget, theme) {
    if (!tvWidget) return;
    if (theme === "light") {
        tvWidget.applyOverrides({
            "paneProperties.vertGridProperties.color": "rgba(237, 237, 237, 0.3)",
            "paneProperties.horzGridProperties.color": "rgba(237, 237, 237, 0.3)"
        });
        return;
    }
    tvWidget.applyOverrides({
        "paneProperties.vertGridProperties.color": "rgba(46, 46, 46, 0.2)",
        "paneProperties.horzGridProperties.color": "rgba(46, 46, 46, 0.2)"
    });
};
var overrideSavedDataToDesktopDarkMode = function(chartLayout) {
    var overrideLayout = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, chartLayout);
    var toOverride = [];
    if (chartLayout) {
        overrideLayout.theme = "dark";
        overrideLayout.layout.charts.forEach(function(x, index) {
            var temp = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, x);
            if (x.chartProperties.paneProperties.background.toLowerCase() === "#fff" || x.chartProperties.paneProperties.background.toLowerCase() === "#ffffff" || x.chartProperties.paneProperties.background.toLowerCase() === "#131722") {
                temp.chartProperties.paneProperties.backgroundType = "solid";
                temp.chartProperties.paneProperties.background = "#1F1F1F";
                temp.chartProperties.scalesProperties.textColor = "#B2B5BE";
                temp.chartProperties.paneProperties.separatorColor = "#2A2E39";
                temp.chartProperties.paneProperties.vertGridProperties.color = "rgba(46, 46, 46, 0.2)";
                temp.chartProperties.paneProperties.horzGridProperties.color = "rgba(46, 46, 46, 0.2)";
            }
            if (chartLayout === null || chartLayout === void 0 ? void 0 : chartLayout.savedStateMetaInfo) {
                if (checkIfDefaultCandle(chartLayout === null || chartLayout === void 0 ? void 0 : chartLayout.layout, index)) {
                    temp.panes[0].sources[0].state.candleStyle.upColor = "#0BA16B";
                    temp.panes[0].sources[0].state.candleStyle.downColor = "#D74342";
                    temp.panes[0].sources[0].state.candleStyle.wickUpColor = "#0BA16B";
                    temp.panes[0].sources[0].state.candleStyle.wickDownColor = "#D74342";
                    temp.panes[0].sources[0].state.candleStyle.borderColor = "#0BA16B";
                    temp.panes[0].sources[0].state.candleStyle.borderUpColor = "#0BA16B";
                    temp.panes[0].sources[0].state.candleStyle.borderDownColor = "#D74342";
                    temp.panes[0].sources[0].state.statusViewStyle.showExchange = true;
                    temp.panes[0].sources[0].state.statusViewStyle.showInterval = true;
                }
            }
            toOverride.push(temp);
        });
        var newLayout = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, chartLayout), {
            charts: toOverride
        });
        return newLayout;
    }
    return overrideLayout;
};
var getLanguageFromURL = function() {
    var regex = new RegExp("[\\?&]lang=([^&#]*)");
    var results = regex.exec(window.location.search);
    return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, " "));
};
var optionalArray = function(state, value) {
    return state ? value : [];
};
var isSideToolbarOpen = function() {
    var userSettings = _chartbit_store__WEBPACK_IMPORTED_MODULE_6__/* .useChartbitStore.getState */ .E.getState().userSettings;
    if (false) {}
    var userSettingToolbarVisible = userSettings["ChartDrawingToolbarWidget.visible"];
    var isDrawingToolVisible = userSettingToolbarVisible === null || userSettingToolbarVisible === undefined ? true : userSettingToolbarVisible === "true";
    return isDrawingToolVisible;
};
var isWidgetbarMinimized = function() {
    if (false) {}
    var widgetBarLayoutSettings = JSON.parse(window.localStorage.getItem("stradingview.widgetbar.layout-settings"));
    if (!widgetBarLayoutSettings) return true;
    var isMinimized = !!widgetBarLayoutSettings.settings.minimized;
    return isMinimized;
};
var getWidgetBarAPI = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(tvWidget) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", tvWidget.widgetbar());
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getWidgetBarAPI(tvWidget) {
        return _ref.apply(this, arguments);
    };
}();
var getDataFromTicker = function(tickerParams) {
    var ticker = tickerParams === null || tickerParams === void 0 ? void 0 : tickerParams.toUpperCase();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(ticker.indexOf(":") > -1 ? ticker.split(":") : [
        undefined,
        ticker
    ], 2), exchange = ref[0], symbolWithStudy = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(symbolWithStudy.split("#"), 2), symbol = ref1[0], formula = ref1[1];
    return {
        symbol: symbol,
        exchange: exchange,
        formula: formula
    };
};
var getChartSymbol = function(tvWidget, index, widgetKey) {
    var ref;
    var tv = tvWidget || window.tvWidget[widgetKey];
    if (!tv) return "";
    var chart = typeof index === "undefined" ? tv.activeChart() : tv.chart(index);
    if (!chart) return "";
    return ((ref = chart.symbolExt()) === null || ref === void 0 ? void 0 : ref.symbol) || getDataFromTicker(chart.symbol()).symbol;
};
var getUnix = function(isoStr) {
    return new Date(isoStr).getTime() / 1000;
};
var fixDefaultSymbol = function(innerContent, isForceBarsPrev) {
    var ref, ref1, ref2, ref3;
    var cloned = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, innerContent);
    if (cloned && (cloned === null || cloned === void 0 ? void 0 : (ref = cloned.charts) === null || ref === void 0 ? void 0 : ref.length) && (cloned === null || cloned === void 0 ? void 0 : (ref1 = cloned.charts) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.panes) === null || ref3 === void 0 ? void 0 : ref3.length)) {
        var ref4;
        var panes = cloned.charts[0].panes;
        var settingData = _chartbit_store__WEBPACK_IMPORTED_MODULE_6__/* .useChartbitStore.getState */ .E.getState().userSettings;
        var setBulkUserSetting = _chartbit_store__WEBPACK_IMPORTED_MODULE_6__/* .useChartbitStore.getState */ .E.getState().setBulkUserSetting;
        try {
            var chartProperties = JSON.parse(settingData.chartproperties);
            if (chartProperties) {
                cloned.charts[0].chartProperties.tradingProperties = chartProperties === null || chartProperties === void 0 ? void 0 : chartProperties.tradingProperties;
            }
        } catch (err) {
            cloned.charts[0].chartProperties.tradingProperties = {
                positionPL: {
                    visibility: true,
                    display: 2
                }
            };
        }
        panes.forEach(function(pane) {
            for(var i = 0; i < pane.sources.length; i += 1){
                var source = pane.sources[i];
                var type = source.type;
                var isMainSeries = type && type.toUpperCase() === "MAINSERIES";
                if (!isMainSeries) return;
                // Migrated layout don't have symbol
                // So we set default to IHSG to prevent breaking
                if (!source.state.symbol) {
                    source.state.symbol = "IHSG";
                }
            }
        });
        cloned === null || cloned === void 0 ? void 0 : (ref4 = cloned.charts) === null || ref4 === void 0 ? void 0 : ref4.forEach(function(item, index) {
            if (item.timeScale.m_rightOffset === 10) {
                cloned.charts[index].timeScale.m_rightOffset = 35;
            }
        });
        // Handle chart cannot loaded to empty session properties
        cloned.charts.forEach(function(item, index) {
            var ref, ref1, ref2;
            if (!((ref = cloned.charts[index]) === null || ref === void 0 ? void 0 : (ref1 = ref.sessions) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.properties) === null || ref2 === void 0 ? void 0 : ref2.graphics)) {
                cloned.charts[index].sessions.properties = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, cloned.charts[index].sessions.properties), {
                    graphics: {
                        backgrounds: {
                            outOfSession: {
                                color: "#2962FF",
                                transparency: 92,
                                visible: false
                            },
                            preMarket: {
                                color: "#FF9800",
                                transparency: 92,
                                visible: false
                            },
                            postMarket: {
                                color: "#2962FF",
                                transparency: 92,
                                visible: false
                            }
                        },
                        vertlines: {
                            sessBreaks: {
                                color: "#4985e7",
                                style: 2,
                                visible: false,
                                width: 1
                            }
                        }
                    }
                });
            }
        });
        // Handle custom setting
        if (!!isForceBarsPrev) {
            if (settingData === null || settingData === void 0 ? void 0 : settingData.chartbitCustomSetting) {
                var customSetting = JSON.parse(settingData === null || settingData === void 0 ? void 0 : settingData.chartbitCustomSetting);
                if (customSetting) {
                    var // if (customSetting['candleStyle.barColorsOnPrevClose'] === false) {
                    ref5;
                    cloned === null || cloned === void 0 ? void 0 : (ref5 = cloned.charts) === null || ref5 === void 0 ? void 0 : ref5.forEach(function(item, index) {
                        var ref, ref1, ref2, ref3, ref4, ref5;
                        if ((item === null || item === void 0 ? void 0 : (ref = item.panes) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.sources) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.state) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.candleStyle) === null || ref5 === void 0 ? void 0 : ref5.barColorsOnPrevClose) !== undefined) {
                            cloned.charts[index].panes[0].sources[0].state.candleStyle = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, cloned.charts[index].panes[0].sources[0].state.candleStyle), {
                                barColorsOnPrevClose: false
                            });
                        }
                    });
                    customSetting["candleStyle.barColorsOnPrevClose"] = false;
                    var updatedCustomSetting = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, settingData), {
                        chartbitCustomSetting: JSON.stringify(customSetting)
                    });
                    setBulkUserSetting(updatedCustomSetting);
                // }
                }
            }
        }
    }
    return cloned;
};
/**
 * Compress String with Zip and base64
 */ var compressString = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
        var normalizedData, layoutZip, base64;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    normalizedData = normalizeToSeriesId(data);
                    layoutZip = new (jszip__WEBPACK_IMPORTED_MODULE_3___default())();
                    layoutZip.file("layout.json", normalizedData);
                    _ctx.next = 5;
                    return layoutZip.generateAsync({
                        type: "base64",
                        compression: "DEFLATE",
                        compressionOptions: {
                            level: 9
                        }
                    });
                case 5:
                    base64 = _ctx.sent;
                    return _ctx.abrupt("return", base64);
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function compressString(data) {
        return _ref.apply(this, arguments);
    };
}();
var compressChart = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(chartData, isDesktop) {
        var uncompressedLayoutLimit, chartDataUpdated, _ref, content, parsedContent, innerContent, theme, layout, data, message, base64;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    uncompressedLayoutLimit = 46725732; // 46.7MB
                    chartDataUpdated = chartData.content;
                    // rename Bollinger Bands Custom indicators
                    if (chartDataUpdated) {
                        chartDataUpdated = chartDataUpdated === null || chartDataUpdated === void 0 ? void 0 : chartDataUpdated.replaceAll("Bollinger Bands Custom", "Bollinger Bands");
                    }
                    _ref = JSON.parse(chartDataUpdated), content = _ref.content, parsedContent = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_ref, [
                        "content"
                    ]);
                    innerContent = JSON.parse(content);
                    if (innerContent.charts) {
                        innerContent.charts.forEach(function(item, index) {
                            var ref, ref1, ref2;
                            if ((ref = innerContent.charts[index]) === null || ref === void 0 ? void 0 : (ref1 = ref.sessions) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.properties) === null || ref2 === void 0 ? void 0 : ref2.sessionHighlight) {
                                innerContent.charts[index].sessions.properties = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, innerContent.charts[index].sessions.properties), {
                                    graphics: innerContent.charts[index].sessions.properties.sessionHighlight
                                });
                            }
                        });
                    }
                    theme = isDesktop ? "dark" : getClientTheme();
                    innerContent = injectThemeToSavedLayout(innerContent, theme, isDesktop);
                    layout = {
                        id: chartData.id,
                        name: chartData.name,
                        resolution: chartData.resolution,
                        symbol: chartData.symbol,
                        content: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, parsedContent), {
                            theme: theme,
                            content: innerContent
                        })
                    };
                    data = JSON.stringify(layout);
                    if (!(data.length > uncompressedLayoutLimit)) {
                        _ctx.next = 14;
                        break;
                    }
                    message = 'Gagal menyimpan, layout "'.concat(chartData.name, '" telah melewati batas ukuran, harap menghapus beberapa drawing untuk melanjutkan');
                    (0,global_AlertMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                        content: message,
                        alertType: "plain-default",
                        messageType: "error",
                        hasCloseIcon: false
                    });
                    throw Error(message);
                case 14:
                    _ctx.next = 16;
                    return compressString(data);
                case 16:
                    base64 = _ctx.sent;
                    return _ctx.abrupt("return", base64);
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function compressChart(chartData, isDesktop) {
        return _ref.apply(this, arguments);
    };
}();
var decompressChart = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(base64) {
        var layoutZip, layoutString, resultNormalize, layout;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return jszip__WEBPACK_IMPORTED_MODULE_3___default().loadAsync(base64, {
                        base64: true
                    });
                case 2:
                    layoutZip = _ctx.sent;
                    _ctx.next = 5;
                    return layoutZip.file("layout.json").async("string");
                case 5:
                    layoutString = _ctx.sent;
                    resultNormalize = normalizeToSeriesId(layoutString);
                    layout = JSON.parse(resultNormalize);
                    return _ctx.abrupt("return", layout);
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function decompressChart(base64) {
        return _ref.apply(this, arguments);
    };
}();
/*
 * Temporary Hide Drawing Template Save as Dropdown
 * https://github.com/tradingview/charting_library/issues/7937
 */ var hideDrawingTemplateSaveMenu = function() {
    var tvDoc = getTVDocument();
    if (!(tvDoc === null || tvDoc === void 0 ? void 0 : tvDoc.body)) return;
    tvDoc.body.classList.add("chartbit-old");
};
// need to override to change the frame of chart bit when overriding from desktop happens
// can not utilize changeTheme cause will reset
// all of the candle color etc that has been customized by user
var overrideHtmlClass = function(param) {
    var dataTheme = param.dataTheme, source = param.source;
    var ref;
    var doc = (ref = document.getElementsByTagName("iframe")[0]) === null || ref === void 0 ? void 0 : ref.contentDocument;
    if (!doc) return;
    var isiDoc = doc.getElementsByTagName("html")[0].classList;
    if (dataTheme === "dark") {
        isiDoc.remove("theme-light");
        isiDoc.add("theme-dark");
    // onChangeThemeChartbit('dark');
    }
    if (dataTheme === "light") {
        isiDoc.remove("theme-dark");
        isiDoc.add("theme-light");
    // onChangeThemeChartbit('dark');
    }
};
var checkIfDefaultLightMode = function(data) {
    return data.layout.charts[0].chartProperties.paneProperties.background === "#ffffff";
};
var checkThemeToOverride = function(data, clientTheme) {
    if (clientTheme !== data.theme) {
        if (data.layout.charts[0].chartProperties.paneProperties.background === "#ffffff") {
            return "light";
        }
        if (data.layout.charts[0].chartProperties.paneProperties.background.toLowerCase() === "#1f1f1f") {
            return "dark";
        }
    }
    return data.theme;
};
var checkIfDefaultCandle = function(layout) {
    var index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (layout) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var style = (ref3 = layout === null || layout === void 0 ? void 0 : (ref = layout.charts) === null || ref === void 0 ? void 0 : (ref1 = ref[index]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.panes) === null || ref2 === void 0 ? void 0 : ref2[0].sources) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.state) === null || ref5 === void 0 ? void 0 : ref5.candleStyle;
        return (style === null || style === void 0 ? void 0 : style.upColor) === "#089981" && (style === null || style === void 0 ? void 0 : style.downColor) === "#F23645" || (style === null || style === void 0 ? void 0 : style.upColor) === "#009900" && (style === null || style === void 0 ? void 0 : style.downColor) === "#B80E0C" || (style === null || style === void 0 ? void 0 : style.upColor) === "#53b987" && (style === null || style === void 0 ? void 0 : style.downColor) === "#eb4d5c" || (style === null || style === void 0 ? void 0 : style.upColor) === "#00AB6B" && (style === null || style === void 0 ? void 0 : style.downColor) === "#EE4A49" || (style === null || style === void 0 ? void 0 : style.upColor) === "#0BA16B" && (style === null || style === void 0 ? void 0 : style.downColor) === "#D74342";
    }
    return false;
};
var checkTextColor = function(theme, apiTextColor, apiBG) {
    var overrideText = apiTextColor;
    var overrideBg = apiBG;
    if (theme === "light" && apiTextColor === "#B2B5BE") {
        overrideText = "#131722";
    }
    if (theme === "dark" && apiTextColor === "#131722") {
        overrideText = "#B2B5BE";
    }
    if (theme === "dark" && (apiBG.toLowerCase() === "#fff" || apiBG.toLowerCase() === "#ffffff")) {
        overrideBg = "#1f1f1f";
    }
    if (theme === "light" && apiBG.toLowerCase() === "#1f1f1f") {
        overrideBg = "#fff";
    }
    return {
        overrideText: overrideText,
        overrideBg: overrideBg
    };
};
var isTVReady = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(tvWidgetKey) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                        var ref;
                        var tv = window === null || window === void 0 ? void 0 : (ref = window.tvWidget) === null || ref === void 0 ? void 0 : ref[tvWidgetKey];
                        if (!tv) reject(Error("TradingView Not Found"));
                        tv.onChartReady(function() {
                            return resolve(true);
                        });
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function isTVReady(tvWidgetKey) {
        return _ref.apply(this, arguments);
    };
}();
// Remove Exchange from symbol
var normalizeSymbol = function(symbol) {
    return (symbol === null || symbol === void 0 ? void 0 : symbol.includes(":")) ? symbol === null || symbol === void 0 ? void 0 : symbol.split(":")[1] : symbol;
};
var normalizeDrawingSourceSymbol = function(data) {
    var formatted = (0,immer__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP)(data, function(draft) {
        var ref, ref1;
        draft.symbol = normalizeSymbol(draft === null || draft === void 0 ? void 0 : draft.symbol);
        if (draft === null || draft === void 0 ? void 0 : (ref = draft.state) === null || ref === void 0 ? void 0 : (ref1 = ref.state) === null || ref1 === void 0 ? void 0 : ref1.symbol) {
            var ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
            draft.state.state.symbol = (draft === null || draft === void 0 ? void 0 : (ref2 = draft.state) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.state) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.symbol) === null || ref4 === void 0 ? void 0 : ref4.includes(":")) ? draft === null || draft === void 0 ? void 0 : (ref5 = draft.state) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.state) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.symbol) === null || ref7 === void 0 ? void 0 : ref7.split(":")[1] : draft === null || draft === void 0 ? void 0 : (ref8 = draft.state) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.state) === null || ref9 === void 0 ? void 0 : ref9.symbol;
        }
    });
    return formatted;
};
var normalizeDrawingGroupSymbol = function(data) {
    var formatted = (0,immer__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP)(data, function(draft) {
        draft.symbol = normalizeSymbol(draft === null || draft === void 0 ? void 0 : draft.symbol);
    });
    return formatted;
};
var getLocalUserSetting = function(prefix) {
    var items = {};
    // Iterate over all keys in localStorage
    // eslint-disable-next-line no-plusplus
    for(var i = 0; i < localStorage.length; i++){
        var key = localStorage.key(i);
        // Check if the key starts with the given prefix
        if (key.startsWith(prefix)) {
            // Get the value associated with the key
            var value = localStorage.getItem(key);
            items[key.replace("".concat(prefix, "."), "")] = value;
        }
    }
    return items;
};
var preProsesFailedLoadSetting = function(userSetting) {
    var data = userSetting;
    if (!data.chartproperties) {
        data.chartproperties = JSON.stringify({
            tradingProperties: {
                positionPL: {
                    display: 2,
                    visibility: true
                }
            }
        });
    }
    data.chartbitCustomSetting = "{}";
    return data;
};
var injectCustomSetting = function(userSetting) {
    var customSetting = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, userSetting);
    var parsedCustomSetting = JSON.parse(customSetting === null || customSetting === void 0 ? void 0 : customSetting.chartbitCustomSetting);
    if ((parsedCustomSetting === null || parsedCustomSetting === void 0 ? void 0 : parsedCustomSetting["candleStyle.barColorsOnPrevClose"]) === undefined) {
        var parsedUserSetting = JSON.parse(customSetting["chartproperties.mainSeriesProperties"]);
        parsedUserSetting.candleStyle.barColorsOnPrevClose = true;
        customSetting["chartproperties.mainSeriesProperties"] = JSON.stringify(parsedUserSetting);
        customSetting.chartbitCustomSetting = JSON.stringify((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, parsedCustomSetting), {
            "candleStyle.barColorsOnPrevClose": false
        }));
    }
    return customSetting;
};
// merge preexisting user setting from local storage with one from api
var mergeLocalAndApi = function(param) {
    var localUserSetting = param.localUserSetting, userSettingFromServer = param.userSettingFromServer;
    var merged = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, userSettingFromServer, localUserSetting);
    try {
        for(var keyFromServer in userSettingFromServer){
            for(var keyLocal in localUserSetting){
                if (keyFromServer === keyLocal && userSettingFromServer[keyFromServer] !== localUserSetting[keyLocal]) {
                    if (Array.isArray(JSON.parse(localUserSetting[keyLocal]))) {
                        // put together if array
                        var concat = JSON.parse(localUserSetting[keyLocal]).concat(JSON.parse(userSettingFromServer[keyFromServer]));
                        merged[keyFromServer] = JSON.stringify(concat);
                    } else {
                        // replace with local if not array
                        merged[keyLocal] = localUserSetting[keyLocal];
                    }
                }
            }
        }
    } catch (error) {
        return userSettingFromServer;
    }
    if ((merged === null || merged === void 0 ? void 0 : merged.chartproperties) && (merged === null || merged === void 0 ? void 0 : merged.chartproperties) !== "") {
        var ref, ref1, ref2;
        var theme = merged === null || merged === void 0 ? void 0 : merged["current_theme.name"];
        var chartProperties = JSON.parse(merged.chartproperties);
        if (theme && (chartProperties === null || chartProperties === void 0 ? void 0 : (ref = chartProperties.mainSeriesProperties) === null || ref === void 0 ? void 0 : ref.candleStyle)) {
            chartProperties.mainSeriesProperties.candleStyle.upColor = theme === "dark" ? "#0BA16B" : "#00AB6B";
            chartProperties.mainSeriesProperties.candleStyle.downColor = theme === "dark" ? "#D74342" : "#EE4A49";
            chartProperties.mainSeriesProperties.candleStyle.wickUpColor = theme === "dark" ? "#0BA16B" : "#00AB6B";
            chartProperties.mainSeriesProperties.candleStyle.wickDownColor = theme === "dark" ? "#D74342" : "#EE4A49";
            chartProperties.mainSeriesProperties.candleStyle.borderColor = theme === "dark" ? "#0BA16B" : "#00AB6B";
            chartProperties.mainSeriesProperties.candleStyle.borderUpColor = theme === "dark" ? "#0BA16B" : "#00AB6B";
            chartProperties.mainSeriesProperties.candleStyle.borderDownColor = theme === "dark" ? "#D74342" : "#EE4A49";
        }
        // PREVENT POSITION PL TICKS LOADED
        if (chartProperties && (chartProperties === null || chartProperties === void 0 ? void 0 : (ref1 = chartProperties.tradingProperties) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.positionPL) === null || ref2 === void 0 ? void 0 : ref2.display) === 1) {
            chartProperties.positionPL.display = 2;
        }
        if (!(chartProperties === null || chartProperties === void 0 ? void 0 : chartProperties.tradingProperties)) {
            chartProperties.tradingProperties = {
                positionPL: {
                    display: 2,
                    visibility: true
                }
            };
        }
        merged.chartproperties = JSON.stringify(chartProperties);
    }
    // HIDE BUY SELL BUTTON
    var tradingChartSetting = merged === null || merged === void 0 ? void 0 : merged["trading.chart.proterty"];
    if (tradingChartSetting) {
        var tradingChartProperties = JSON.parse(tradingChartSetting);
        tradingChartProperties.showSellBuyButtons = 0;
        merged["trading.chart.proterty"] = JSON.stringify(tradingChartProperties);
    } else {
        merged["trading.chart.proterty"] = JSON.stringify({
            showSellBuyButtons: 0,
            noConfirmEnabled: 0,
            qweqrq: 0,
            showPricesWithZeroVolume: 1,
            showSpread: 1,
            orderExecutedSoundParams: '{"enabled":0,"name":"alert/alarm_clock"}'
        });
    }
    if (!(merged === null || merged === void 0 ? void 0 : merged.chartbitCustomSetting)) {
        merged.chartbitCustomSetting = "{}";
    }
    for(var i in merged){
        localStorage.setItem("stradingview.".concat(i), merged[i]);
    }
    return merged;
};
var normalizeToSeriesId = function(data) {
    var cleanData = data;
    /*
    This id is hardcoded id from template config, that founded on
    web and desktop chartbit implementation previouly. Because the id has been saved
    on database, we need a function to replace it with _seriesId as the standard.
    Reference file :
    - Web
      file : src/features/chartbit/config/template.ts
      has D4LkIE value on template Dark, Light,
    - Desktop
      file: chartbit/__components/Modal/TemplateModal/__contants/defaultTemplate.ts
      has D4LkIE value on template Dark, Light,
      has 7a6YCE value on Bandarmology
  */ var ids = [
        "D4LkIE",
        "7a6YCE"
    ];
    ids.forEach(function(id) {
        cleanData = cleanData.replace(new RegExp(id, "g"), "_seriesId");
    });
    return cleanData;
};
var mapSymbolOnChart = function(tvWidget) {
    var chartCount = tvWidget.chartsCount();
    var symbolMaps = {};
    // eslint-disable-next-line no-plusplus
    for(var i = 0; i < chartCount; i++){
        symbolMaps[i] = tvWidget.chart(i).symbol();
    }
    return symbolMaps;
};
var roundPriceByFraction = function(price, type) {
    var fraction = 1;
    var tradeables = [
        constants_trading__WEBPACK_IMPORTED_MODULE_7__/* .STOCK_TYPE.saham */ .L2.saham,
        constants_trading__WEBPACK_IMPORTED_MODULE_7__/* .STOCK_TYPE.waran */ .L2.waran,
        constants_trading__WEBPACK_IMPORTED_MODULE_7__/* .STOCK_TYPE.right */ .L2.right, 
    ];
    if (tradeables.includes(type.toLowerCase())) {
        if (price < 200) {
            fraction = 1;
        } else if (price < 500) {
            fraction = 2;
        } else if (price < 2000) {
            fraction = 5;
        } else if (price < 5000) {
            fraction = 10;
        } else {
            fraction = 25;
        }
    }
    return Math.round(price / fraction) * fraction;
};
var overrideCandleColorOnLoad = function(layout, theme) {
    var ref, ref1;
    if (((ref = layout === null || layout === void 0 ? void 0 : layout.charts[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.panes) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && checkIfDefaultCandle(layout)) {
        layout.charts[0].panes[0].sources[0].state.candleStyle.upColor = theme === "dark" ? "#0BA16B" : "#00AB6B";
        layout.charts[0].panes[0].sources[0].state.candleStyle.downColor = theme === "dark" ? "#D74342" : "#EE4A49";
        layout.charts[0].panes[0].sources[0].state.candleStyle.wickUpColor = theme === "dark" ? "#0BA16B" : "#00AB6B";
        layout.charts[0].panes[0].sources[0].state.candleStyle.wickDownColor = theme === "dark" ? "#D74342" : "#EE4A49";
        layout.charts[0].panes[0].sources[0].state.candleStyle.borderColor = theme === "dark" ? "#0BA16B" : "#00AB6B";
        layout.charts[0].panes[0].sources[0].state.candleStyle.borderUpColor = theme === "dark" ? "#0BA16B" : "#00AB6B";
        layout.charts[0].panes[0].sources[0].state.candleStyle.borderDownColor = theme === "dark" ? "#D74342" : "#EE4A49";
        layout.charts[0].panes[0].sources[0].state.statusViewStyle.showExchange = true;
        layout.charts[0].panes[0].sources[0].state.statusViewStyle.showInterval = true;
    }
    return layout;
};
var manipulateContextMenu = function(menuItems, newPrice) {
    var newItems = menuItems;
    // REMOVE TRADE ACTION FROM CONTEXT MENU
    var indexTrade = newItems.findIndex(// @ts-ignore
    function(item) {
        var ref;
        return (item === null || item === void 0 ? void 0 : (ref = item._options) === null || ref === void 0 ? void 0 : ref.actionId) === "Trading.TradeFromChart";
    });
    if (indexTrade > -1) {
        newItems.splice(indexTrade, 2);
    }
    // RENAME DRAW HORIZONTAL TEXT
    var indexDrawHorizontal = newItems.findIndex(function(item) {
        var // @ts-ignore
        ref;
        return (item === null || item === void 0 ? void 0 : (ref = item._options) === null || ref === void 0 ? void 0 : ref.actionId) === "Chart.Crosshair.PlusButton.DrawHorizontalLine";
    });
    if (indexDrawHorizontal > -1) {
        var newLabel = "Draw Horizontal Line @".concat(numeral__WEBPACK_IMPORTED_MODULE_4___default()(newPrice).format("0,0"));
        // @ts-ignore
        newItems[indexDrawHorizontal]._options.label = newLabel;
    }
    // RENAME SYMBOL INFO
    var indexSymbolInfo = newItems.findIndex(function(item) {
        var // @ts-ignore
        ref;
        return (item === null || item === void 0 ? void 0 : (ref = item._options) === null || ref === void 0 ? void 0 : ref.actionId) === "Chart.Dialogs.ShowSymbolInfo";
    });
    if (indexSymbolInfo > -1) {
        // @ts-ignore
        newItems[indexSymbolInfo]._options.label = "Stock Info";
    }
    return newItems;
};
var injectDefaultRightOffset = function(tvWidget) {
    var chartCount = tvWidget.chartsCount();
    for(var i = 0; i < chartCount; i += 1){
        tvWidget.chart(i).getTimeScale().setRightOffset(5);
    }
};


/***/ }),

/***/ 32713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ useChartbitStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14671);
/* harmony import */ var lib_api_company__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1349);
/* harmony import */ var lib_api_chartbit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47514);








// eslint-disable-next-line import/no-cycle

var chartbitState = {
    changes: {
        haveChanges: false,
        modalCallback: null,
        layoutIdToLoad: null
    },
    currentLayoutId: null,
    myInvestment: {
        visible: false
    },
    createdLayoutId: null,
    activeModalUnsaved: null,
    widgetKey: null,
    isOpenNewLayout: false,
    showOverlay: true,
    userSettings: {},
    currentContent: {},
    lastActiveWidgetKey: null,
    symbolMaps: {},
    labelMenu: {
        visible: false,
        data: null
    },
    companyDetail: {},
    quoteData: {},
    loadingThemeChanges: false
};
var chartbitActions = function(set, get) {
    return {
        closeUnsavedModal: function() {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.changes.modalCallback = null;
                    draft.activeModalUnsaved = null;
                });
            });
        },
        openUnsavedModal: function(widgetKey) {
            return new Promise(function(resolve) {
                var cb = function(value) {
                    resolve(value);
                    get().closeUnsavedModal();
                };
                set(function(state) {
                    return (0,immer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(state, function(draft) {
                        draft.activeModalUnsaved = widgetKey;
                        draft.changes.modalCallback = cb;
                    });
                });
            });
        },
        setHaveChanges: function(value) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.changes.haveChanges = value;
                });
            });
        },
        setVisibleMyInvestment: function(value) {
            set({
                myInvestment: {
                    visible: value
                }
            });
        },
        setCurrentLayoutId: function(value) {
            set({
                currentLayoutId: value
            });
        },
        setCreatedLayoutId: function(value) {
            set({
                createdLayoutId: value
            });
        },
        setWidgetKey: function(value) {
            set({
                widgetKey: value
            });
        },
        setIsOpenNewLayout: function(value) {
            set({
                isOpenNewLayout: value
            });
        },
        setShowOverlay: function(value) {
            set({
                showOverlay: value
            });
        },
        setUserSetting: function(param) {
            var key = param.key, value = param.value;
            return new Promise(function(res) {
                var current = get().userSettings;
                var newSetting = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, current), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, key, value));
                set({
                    userSettings: newSetting
                });
                res(newSetting);
            });
        },
        setBulkUserSetting: function(setting) {
            set({
                userSettings: setting
            });
        },
        setCurrentContent: function(value) {
            set({
                currentContent: value
            });
        },
        setLastActiveWidgetKey: function(value) {
            set({
                lastActiveWidgetKey: value
            });
        },
        setSymbolMaps: function(index, symbol) {
            set({
                symbolMaps: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, get().symbolMaps), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, index, symbol))
            });
        },
        createSymbolMaps: function(item) {
            set({
                symbolMaps: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, get().symbolMaps, item)
            });
        },
        setLabelMenu: function(visible, data) {
            set({
                labelMenu: {
                    visible: visible,
                    data: data
                }
            });
        },
        fetchCompanyDetail: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(symbol) {
                var ref, res, companyData;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            if (!(get().companyDetail[symbol] && Date.now() - get().companyDetail[symbol].time < 1 * 60 * 60)) {
                                _ctx.next = 4;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 4:
                            _ctx.next = 6;
                            return lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getCompanyInfo */ .Z.getCompanyInfo(symbol);
                        case 6:
                            res = _ctx.sent;
                            companyData = res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.data;
                            if (companyData) {
                                set({
                                    companyDetail: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, get().companyDetail), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, symbol, {
                                        time: Date.now(),
                                        data: companyData
                                    }))
                                });
                            }
                            _ctx.next = 13;
                            break;
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](0);
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        11
                    ]
                ]);
            }));
            return function(symbol) {
                return _ref.apply(this, arguments);
            };
        }(),
        fetchQuoteData: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(symbol) {
                var currTime, savedQuote, response, _data, data, error;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            currTime = new Date().getTime();
                            savedQuote = get().quoteData[symbol];
                            if (!(savedQuote && currTime - (savedQuote === null || savedQuote === void 0 ? void 0 : savedQuote.time) < 1000)) {
                                _ctx.next = 6;
                                break;
                            }
                            if (!(savedQuote === null || savedQuote === void 0 ? void 0 : savedQuote.data)) {
                                _ctx.next = 5;
                                break;
                            }
                            return _ctx.abrupt("return", savedQuote.data);
                        case 5:
                            return _ctx.abrupt("return", null);
                        case 6:
                            set({
                                quoteData: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, get().quoteData), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, symbol, {
                                    data: null,
                                    time: currTime
                                }))
                            });
                            _ctx.next = 9;
                            return lib_api_chartbit__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getQuote */ .Z.getQuote(symbol);
                        case 9:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 12;
                                break;
                            }
                            throw new Error("Attempt to get quote failed");
                        case 12:
                            _data = response.data, data = _data.data, error = _data.error;
                            if (!error) {
                                _ctx.next = 15;
                                break;
                            }
                            throw new Error("Attempt to get quote failed");
                        case 15:
                            set({
                                quoteData: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, get().quoteData), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, symbol, {
                                    data: response.data.data,
                                    time: currTime
                                }))
                            });
                            return _ctx.abrupt("return", data);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(symbol) {
                return _ref.apply(this, arguments);
            };
        }(),
        setLoadingThemeChange: function(loading) {
            set({
                loadingThemeChanges: loading
            });
        }
    };
};
var useChartbitStore = (0,zustand__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(function(set, get, store, storeMutation) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, chartbitState, chartbitActions(set, get, store, storeMutation));
});


/***/ }),

/***/ 66483:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var templates = [
    {
        key: "light",
        name: "Light",
        template: {
            layout: "s",
            charts: [
                {
                    theme: "Light",
                    panes: [
                        {
                            sources: [
                                {
                                    type: "MainSeries",
                                    id: "_seriesId",
                                    state: {
                                        style: 1,
                                        esdShowDividends: true,
                                        esdShowSplits: true,
                                        esdShowEarnings: true,
                                        esdShowBreaks: false,
                                        esdBreaksStyle: {
                                            color: "rgba( 235, 77, 92, 1)",
                                            style: 2,
                                            width: 1
                                        },
                                        esdFlagSize: 2,
                                        showCountdown: false,
                                        showInDataWindow: true,
                                        visible: true,
                                        showPriceLine: true,
                                        priceLineWidth: 1,
                                        priceLineColor: "",
                                        baseLineColor: "#B2B5BE",
                                        showPrevClosePriceLine: false,
                                        prevClosePriceLineWidth: 1,
                                        prevClosePriceLineColor: "rgba( 85, 85, 85, 1)",
                                        minTick: "default",
                                        extendedHours: false,
                                        sessVis: false,
                                        statusViewStyle: {
                                            fontSize: 17,
                                            showExchange: true,
                                            showInterval: true,
                                            showSymbolAsDescription: false
                                        },
                                        candleStyle: {
                                            upColor: "#00AB6B",
                                            downColor: "#EE4A49",
                                            drawWick: true,
                                            drawBorder: true,
                                            borderColor: "#00AB6B",
                                            borderUpColor: "#00AB6B",
                                            borderDownColor: "#EE4A49",
                                            wickColor: "#737375",
                                            wickUpColor: "#00AB6B",
                                            wickDownColor: "#EE4A49",
                                            barColorsOnPrevClose: false
                                        },
                                        hollowCandleStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            drawWick: true,
                                            drawBorder: true,
                                            borderColor: "#378658",
                                            borderUpColor: "#53b987",
                                            borderDownColor: "#eb4d5c",
                                            wickColor: "#737375",
                                            wickUpColor: "#a9dcc3",
                                            wickDownColor: "#f5a6ae"
                                        },
                                        haStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            drawWick: true,
                                            drawBorder: true,
                                            borderColor: "#378658",
                                            borderUpColor: "#53b987",
                                            borderDownColor: "#eb4d5c",
                                            wickColor: "#737375",
                                            wickUpColor: "#53b987",
                                            wickDownColor: "#eb4d5c",
                                            showRealLastPrice: false,
                                            barColorsOnPrevClose: false,
                                            inputs: {},
                                            inputInfo: {}
                                        },
                                        barStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            barColorsOnPrevClose: false,
                                            dontDrawOpen: false
                                        },
                                        lineStyle: {
                                            color: "#0303F7",
                                            linestyle: 0,
                                            linewidth: 1,
                                            priceSource: "close",
                                            styleType: 2
                                        },
                                        areaStyle: {
                                            color1: "rgba(96, 96, 144, 0.5)",
                                            color2: "rgba(1, 246, 245, 0.5)",
                                            linecolor: "#0094FF",
                                            linestyle: 0,
                                            linewidth: 1,
                                            priceSource: "close",
                                            transparency: 50
                                        },
                                        renkoStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            borderUpColor: "#53b987",
                                            borderDownColor: "#eb4d5c",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            borderUpColorProjection: "#a9dcc3",
                                            borderDownColorProjection: "#f5a6ae",
                                            wickUpColor: "#a9dcc3",
                                            wickDownColor: "#f5a6ae",
                                            inputs: {
                                                source: "close",
                                                boxSize: 3,
                                                style: "ATR",
                                                atrLength: 14,
                                                wicks: true
                                            },
                                            inputInfo: {
                                                source: {
                                                    name: "Source"
                                                },
                                                boxSize: {
                                                    name: "Box size"
                                                },
                                                style: {
                                                    name: "Style"
                                                },
                                                atrLength: {
                                                    name: "ATR Length"
                                                },
                                                wicks: {
                                                    name: "Wicks"
                                                }
                                            }
                                        },
                                        pbStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            borderUpColor: "#53b987",
                                            borderDownColor: "#eb4d5c",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            borderUpColorProjection: "#a9dcc3",
                                            borderDownColorProjection: "#f5a6ae",
                                            inputs: {
                                                source: "close",
                                                lb: 3
                                            },
                                            inputInfo: {
                                                source: {
                                                    name: "Source"
                                                },
                                                lb: {
                                                    name: "Number of line"
                                                }
                                            }
                                        },
                                        kagiStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            inputs: {
                                                source: "close",
                                                style: "ATR",
                                                atrLength: 14,
                                                reversalAmount: 1
                                            },
                                            inputInfo: {
                                                source: {
                                                    name: "Source"
                                                },
                                                style: {
                                                    name: "Style"
                                                },
                                                atrLength: {
                                                    name: "ATR Length"
                                                },
                                                reversalAmount: {
                                                    name: "Reversal amount"
                                                }
                                            }
                                        },
                                        pnfStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            inputs: {
                                                sources: "Close",
                                                reversalAmount: 3,
                                                boxSize: 1,
                                                style: "ATR",
                                                atrLength: 14
                                            },
                                            inputInfo: {
                                                sources: {
                                                    name: "Source"
                                                },
                                                boxSize: {
                                                    name: "Box size"
                                                },
                                                reversalAmount: {
                                                    name: "Reversal amount"
                                                },
                                                style: {
                                                    name: "Style"
                                                },
                                                atrLength: {
                                                    name: "ATR Length"
                                                }
                                            }
                                        },
                                        baselineStyle: {
                                            baselineColor: "rgba( 117, 134, 150, 1)",
                                            topFillColor1: "rgba( 83, 185, 135, 0.1)",
                                            topFillColor2: "rgba( 83, 185, 135, 0.1)",
                                            bottomFillColor1: "rgba( 235, 77, 92, 0.1)",
                                            bottomFillColor2: "rgba( 235, 77, 92, 0.1)",
                                            topLineColor: "rgba( 83, 185, 135, 1)",
                                            bottomLineColor: "rgba( 235, 77, 92, 1)",
                                            topLineWidth: 1,
                                            bottomLineWidth: 1,
                                            priceSource: "close",
                                            transparency: 50,
                                            baseLevelPercentage: 50
                                        },
                                        rangeStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            inputs: {
                                                range: 10,
                                                phantomBars: false
                                            },
                                            inputInfo: {
                                                range: {
                                                    name: "Range"
                                                },
                                                phantomBars: {
                                                    name: "Phantom Bars"
                                                }
                                            }
                                        },
                                        symbol: "IHSG",
                                        shortName: "IHSG",
                                        timeframe: "",
                                        onWidget: false,
                                        interval: "D",
                                        priceAxisProperties: {
                                            autoScale: true,
                                            autoScaleDisabled: false,
                                            lockScale: false,
                                            percentage: false,
                                            percentageDisabled: false,
                                            log: false,
                                            logDisabled: false,
                                            alignLabels: false,
                                            indexedTo100: false
                                        },
                                        showSessions: false
                                    },
                                    zorder: -1,
                                    haStyle: {
                                        studyId: "BarSetHeikenAshi@tv-basicstudies-60"
                                    },
                                    renkoStyle: {
                                        studyId: "BarSetRenko@tv-prostudies-15"
                                    },
                                    pbStyle: {
                                        studyId: "BarSetPriceBreak@tv-prostudies-15"
                                    },
                                    kagiStyle: {
                                        studyId: "BarSetKagi@tv-prostudies-15"
                                    },
                                    pnfStyle: {
                                        studyId: "BarSetPnF@tv-prostudies-15"
                                    },
                                    rangeStyle: {
                                        studyId: "BarSetRange@tv-basicstudies-72"
                                    }
                                },
                                {
                                    type: "study_Sessions",
                                    id: "VP10po",
                                    state: {
                                        graphics: {
                                            vertlines: {
                                                sessBreaks: {
                                                    color: "#4985e7",
                                                    style: 2,
                                                    visible: false,
                                                    width: 1,
                                                    name: "Session Break"
                                                }
                                            }
                                        },
                                        linkedToSeries: true,
                                        precision: "default",
                                        inputs: {},
                                        styles: {},
                                        palettes: {},
                                        bands: {},
                                        area: {},
                                        showInDataWindow: true,
                                        visible: true,
                                        showStudyArguments: true,
                                        plots: {},
                                        _metainfoVersion: 44,
                                        description: "Sessions",
                                        id: "Sessions@tv-basicstudies",
                                        is_hidden_study: true,
                                        is_price_study: true,
                                        name: "Sessions@tv-basicstudies",
                                        shortDescription: "Sessions",
                                        description_localized: "Sessions",
                                        shortId: "Sessions",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Sessions@tv-basicstudies-1",
                                        productId: "tv-basicstudies"
                                    },
                                    zorder: -2,
                                    metaInfo: {
                                        palettes: {},
                                        inputs: [],
                                        plots: [],
                                        graphics: {
                                            vertlines: {
                                                sessBreaks: {
                                                    name: "Session Break"
                                                }
                                            }
                                        },
                                        defaults: {
                                            graphics: {
                                                vertlines: {
                                                    sessBreaks: {
                                                        color: "#4985e7",
                                                        style: 2,
                                                        visible: false,
                                                        width: 1
                                                    }
                                                }
                                            },
                                            linkedToSeries: true,
                                            precision: 4
                                        },
                                        _metainfoVersion: 44,
                                        description: "Sessions",
                                        id: "Sessions@tv-basicstudies-1",
                                        is_hidden_study: true,
                                        is_price_study: true,
                                        name: "Sessions@tv-basicstudies",
                                        shortDescription: "Sessions",
                                        description_localized: "Sessions",
                                        shortId: "Sessions",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Sessions@tv-basicstudies-1",
                                        productId: "tv-basicstudies"
                                    },
                                    ownerSource: "_seriesId"
                                }, 
                            ],
                            leftAxisState: {
                                m_priceRange: {
                                    m_maxValue: 0.5,
                                    m_minValue: -0.5
                                },
                                m_isAutoScale: true,
                                m_isPercentage: false,
                                m_isIndexedTo100: false,
                                m_isLog: false,
                                m_isLockScale: false,
                                m_height: 949,
                                m_topMargin: 0.17,
                                m_bottomMargin: 0.15
                            },
                            leftAxisSources: [],
                            rightAxisState: {
                                m_priceRange: {
                                    m_maxValue: 6636.33,
                                    m_minValue: 5623.84
                                },
                                m_isAutoScale: true,
                                m_isPercentage: false,
                                m_isIndexedTo100: false,
                                m_isLog: false,
                                m_isLockScale: false,
                                m_height: 949,
                                m_topMargin: 0.17,
                                m_bottomMargin: 0.15
                            },
                            rightAxisSources: [
                                "_seriesId",
                                "VP10po"
                            ],
                            overlayPriceScales: {},
                            stretchFactor: 4484.635413319781,
                            mainSourceId: "_seriesId"
                        }, 
                    ],
                    timeScale: {
                        m_barSpacing: 6,
                        m_rightOffset: 35
                    },
                    chartProperties: {
                        paneProperties: {
                            background: "#ffffff",
                            gridProperties: {
                                color: "#e1ecf2",
                                style: 0
                            },
                            vertGridProperties: {
                                color: "rgba(225, 236, 242, 0.27)",
                                style: 0
                            },
                            horzGridProperties: {
                                color: "rgba(225, 236, 242, 0.27)",
                                style: 0
                            },
                            crossHairProperties: {
                                color: "rgba(117, 134, 150, 1)",
                                style: 2,
                                transparency: 0,
                                width: 1
                            },
                            topMargin: 17,
                            bottomMargin: 15,
                            leftAxisProperties: {
                                autoScale: true,
                                autoScaleDisabled: false,
                                lockScale: false,
                                percentage: false,
                                percentageDisabled: false,
                                indexedTo100: false,
                                log: false,
                                logDisabled: false,
                                alignLabels: true
                            },
                            rightAxisProperties: {
                                autoScale: true,
                                autoScaleDisabled: false,
                                lockScale: false,
                                percentage: false,
                                percentageDisabled: false,
                                log: false,
                                logDisabled: false,
                                alignLabels: true
                            },
                            legendProperties: {
                                showStudyArguments: true,
                                showStudyTitles: true,
                                showStudyValues: false,
                                showSeriesTitle: true,
                                showSeriesOHLC: true,
                                showLegend: false,
                                showBarChange: true,
                                showOnlyPriceSource: true
                            }
                        },
                        scalesProperties: {
                            showLeftScale: false,
                            showRightScale: true,
                            backgroundColor: "#ffffff",
                            lineColor: "#555",
                            textColor: "#555",
                            fontSize: 11,
                            scaleSeriesOnly: false,
                            showSeriesLastValue: true,
                            showSeriesPrevCloseValue: false,
                            showStudyLastValue: true,
                            showSymbolLabels: false,
                            showStudyPlotLabels: false,
                            barSpacing: 6
                        },
                        chartEventsSourceProperties: {
                            visible: true,
                            futureOnly: true,
                            breaks: {
                                color: "rgba(85, 85, 85, 1)",
                                visible: false,
                                style: 2,
                                width: 1
                            }
                        }
                    },
                    version: 2,
                    timezone: "Etc/UTC"
                }, 
            ]
        }
    },
    {
        key: "dark",
        name: "Dark",
        template: {
            layout: "s",
            charts: [
                {
                    theme: "Dark",
                    panes: [
                        {
                            sources: [
                                {
                                    type: "MainSeries",
                                    id: "_seriesId",
                                    state: {
                                        style: 1,
                                        esdShowDividends: true,
                                        esdShowSplits: true,
                                        esdShowEarnings: true,
                                        esdShowBreaks: false,
                                        esdBreaksStyle: {
                                            color: "rgba( 235, 77, 92, 1)",
                                            style: 2,
                                            width: 1
                                        },
                                        esdFlagSize: 2,
                                        showCountdown: false,
                                        showInDataWindow: true,
                                        visible: true,
                                        showPriceLine: true,
                                        priceLineWidth: 1,
                                        priceLineColor: "",
                                        baseLineColor: "#5d606b",
                                        showPrevClosePriceLine: false,
                                        prevClosePriceLineWidth: 1,
                                        prevClosePriceLineColor: "rgba( 85, 85, 85, 1)",
                                        minTick: "default",
                                        extendedHours: false,
                                        sessVis: false,
                                        statusViewStyle: {
                                            fontSize: 17,
                                            showExchange: true,
                                            showInterval: true,
                                            showSymbolAsDescription: false
                                        },
                                        candleStyle: {
                                            upColor: "#0BA16B",
                                            downColor: "#D74342",
                                            drawWick: true,
                                            drawBorder: true,
                                            borderColor: "#0BA16B",
                                            borderUpColor: "#0BA16B",
                                            borderDownColor: "#D74342",
                                            wickColor: "#B5B5B8",
                                            wickUpColor: "#0BA16B",
                                            wickDownColor: "#D74342",
                                            barColorsOnPrevClose: false
                                        },
                                        hollowCandleStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            drawWick: true,
                                            drawBorder: true,
                                            borderColor: "#378658",
                                            borderUpColor: "#53b987",
                                            borderDownColor: "#eb4d5c",
                                            wickColor: "#B5B5B8",
                                            wickUpColor: "#336854",
                                            wickDownColor: "#7f323f"
                                        },
                                        haStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            drawWick: true,
                                            drawBorder: true,
                                            borderColor: "#378658",
                                            borderUpColor: "#53b987",
                                            borderDownColor: "#eb4d5c",
                                            wickColor: "#B5B5B8",
                                            wickUpColor: "#53b987",
                                            wickDownColor: "#eb4d5c",
                                            showRealLastPrice: false,
                                            barColorsOnPrevClose: false,
                                            inputs: {},
                                            inputInfo: {}
                                        },
                                        barStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            barColorsOnPrevClose: false,
                                            dontDrawOpen: false
                                        },
                                        lineStyle: {
                                            color: "#6FB8F7",
                                            linestyle: 0,
                                            linewidth: 1,
                                            priceSource: "close",
                                            styleType: 2
                                        },
                                        areaStyle: {
                                            color1: "#606090",
                                            color2: "#01F6F5",
                                            linecolor: "#0094FF",
                                            linestyle: 0,
                                            linewidth: 1,
                                            priceSource: "close",
                                            transparency: 50
                                        },
                                        renkoStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            borderUpColor: "#53b987",
                                            borderDownColor: "#eb4d5c",
                                            upColorProjection: "#336854",
                                            downColorProjection: "#7f323f",
                                            borderUpColorProjection: "#336854",
                                            borderDownColorProjection: "#7f323f",
                                            wickUpColor: "#336854",
                                            wickDownColor: "#7f323f",
                                            inputs: {
                                                source: "close",
                                                boxSize: 3,
                                                style: "ATR",
                                                atrLength: 14,
                                                wicks: true
                                            },
                                            inputInfo: {
                                                source: {
                                                    name: "Source"
                                                },
                                                boxSize: {
                                                    name: "Box size"
                                                },
                                                style: {
                                                    name: "Style"
                                                },
                                                atrLength: {
                                                    name: "ATR Length"
                                                },
                                                wicks: {
                                                    name: "Wicks"
                                                }
                                            }
                                        },
                                        pbStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            borderUpColor: "#53b987",
                                            borderDownColor: "#eb4d5c",
                                            upColorProjection: "#336854",
                                            downColorProjection: "#7f323f",
                                            borderUpColorProjection: "#336854",
                                            borderDownColorProjection: "#7f323f",
                                            inputs: {
                                                source: "close",
                                                lb: 3
                                            },
                                            inputInfo: {
                                                source: {
                                                    name: "Source"
                                                },
                                                lb: {
                                                    name: "Number of line"
                                                }
                                            }
                                        },
                                        kagiStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            upColorProjection: "#336854",
                                            downColorProjection: "#7f323f",
                                            inputs: {
                                                source: "close",
                                                style: "ATR",
                                                atrLength: 14,
                                                reversalAmount: 1
                                            },
                                            inputInfo: {
                                                source: {
                                                    name: "Source"
                                                },
                                                style: {
                                                    name: "Style"
                                                },
                                                atrLength: {
                                                    name: "ATR Length"
                                                },
                                                reversalAmount: {
                                                    name: "Reversal amount"
                                                }
                                            }
                                        },
                                        pnfStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            upColorProjection: "#336854",
                                            downColorProjection: "#7f323f",
                                            inputs: {
                                                sources: "Close",
                                                reversalAmount: 3,
                                                boxSize: 1,
                                                style: "ATR",
                                                atrLength: 14
                                            },
                                            inputInfo: {
                                                sources: {
                                                    name: "Source"
                                                },
                                                boxSize: {
                                                    name: "Box size"
                                                },
                                                reversalAmount: {
                                                    name: "Reversal amount"
                                                },
                                                style: {
                                                    name: "Style"
                                                },
                                                atrLength: {
                                                    name: "ATR Length"
                                                }
                                            }
                                        },
                                        baselineStyle: {
                                            baselineColor: "rgba( 117, 134, 150, 1)",
                                            topFillColor1: "rgba( 83, 185, 135, 0.1)",
                                            topFillColor2: "rgba( 83, 185, 135, 0.1)",
                                            bottomFillColor1: "rgba( 235, 77, 92, 0.1)",
                                            bottomFillColor2: "rgba( 235, 77, 92, 0.1)",
                                            topLineColor: "rgba( 83, 185, 135, 1)",
                                            bottomLineColor: "rgba( 235, 77, 92, 1)",
                                            topLineWidth: 1,
                                            bottomLineWidth: 1,
                                            priceSource: "close",
                                            transparency: 50,
                                            baseLevelPercentage: 50
                                        },
                                        rangeStyle: {
                                            upColor: "#53b987",
                                            downColor: "#eb4d5c",
                                            upColorProjection: "#336854",
                                            downColorProjection: "#7f323f",
                                            inputs: {
                                                range: 10,
                                                phantomBars: false
                                            },
                                            inputInfo: {
                                                range: {
                                                    name: "Range"
                                                },
                                                phantomBars: {
                                                    name: "Phantom Bars"
                                                }
                                            }
                                        },
                                        symbol: "BBCA",
                                        shortName: "BBCA",
                                        timeframe: "",
                                        onWidget: false,
                                        interval: "D",
                                        priceAxisProperties: {
                                            autoScale: true,
                                            autoScaleDisabled: false,
                                            lockScale: false,
                                            percentage: false,
                                            percentageDisabled: false,
                                            log: false,
                                            logDisabled: false,
                                            alignLabels: false,
                                            indexedTo100: false
                                        },
                                        showSessions: false
                                    },
                                    zorder: -1,
                                    haStyle: {
                                        studyId: "BarSetHeikenAshi@tv-basicstudies-60"
                                    },
                                    renkoStyle: {
                                        studyId: "BarSetRenko@tv-prostudies-15"
                                    },
                                    pbStyle: {
                                        studyId: "BarSetPriceBreak@tv-prostudies-15"
                                    },
                                    kagiStyle: {
                                        studyId: "BarSetKagi@tv-prostudies-15"
                                    },
                                    pnfStyle: {
                                        studyId: "BarSetPnF@tv-prostudies-15"
                                    },
                                    rangeStyle: {
                                        studyId: "BarSetRange@tv-basicstudies-72"
                                    }
                                },
                                {
                                    type: "study_Sessions",
                                    id: "VP10po",
                                    state: {
                                        graphics: {
                                            vertlines: {
                                                sessBreaks: {
                                                    color: "#4985e7",
                                                    style: 2,
                                                    visible: false,
                                                    width: 1,
                                                    name: "Session Break"
                                                }
                                            }
                                        },
                                        linkedToSeries: true,
                                        precision: "default",
                                        inputs: {},
                                        styles: {},
                                        palettes: {},
                                        bands: {},
                                        area: {},
                                        showInDataWindow: true,
                                        visible: true,
                                        showStudyArguments: true,
                                        plots: {},
                                        _metainfoVersion: 44,
                                        description: "Sessions",
                                        id: "Sessions@tv-basicstudies",
                                        is_hidden_study: true,
                                        is_price_study: true,
                                        name: "Sessions@tv-basicstudies",
                                        shortDescription: "Sessions",
                                        description_localized: "Sessions",
                                        shortId: "Sessions",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Sessions@tv-basicstudies-1",
                                        productId: "tv-basicstudies"
                                    },
                                    zorder: -2,
                                    metaInfo: {
                                        palettes: {},
                                        inputs: [],
                                        plots: [],
                                        graphics: {
                                            vertlines: {
                                                sessBreaks: {
                                                    name: "Session Break"
                                                }
                                            }
                                        },
                                        defaults: {
                                            graphics: {
                                                vertlines: {
                                                    sessBreaks: {
                                                        color: "#4985e7",
                                                        style: 2,
                                                        visible: false,
                                                        width: 1
                                                    }
                                                }
                                            },
                                            linkedToSeries: true,
                                            precision: 4
                                        },
                                        _metainfoVersion: 44,
                                        description: "Sessions",
                                        id: "Sessions@tv-basicstudies-1",
                                        is_hidden_study: true,
                                        is_price_study: true,
                                        name: "Sessions@tv-basicstudies",
                                        shortDescription: "Sessions",
                                        description_localized: "Sessions",
                                        shortId: "Sessions",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Sessions@tv-basicstudies-1",
                                        productId: "tv-basicstudies"
                                    },
                                    ownerSource: "_seriesId"
                                },
                                {
                                    type: "LineToolABCD",
                                    id: "44EV8q",
                                    state: {
                                        intervalsVisibilities: {
                                            seconds: true,
                                            secondsFrom: 1,
                                            secondsTo: 59,
                                            minutes: true,
                                            minutesFrom: 1,
                                            minutesTo: 59,
                                            hours: true,
                                            hoursFrom: 1,
                                            hoursTo: 24,
                                            days: true,
                                            daysFrom: 1,
                                            daysTo: 366,
                                            weeks: true,
                                            months: true,
                                            ranges: true
                                        },
                                        clonable: true,
                                        color: "rgba( 0, 155, 0, 1)",
                                        textcolor: "rgba( 255, 255, 255, 1)",
                                        font: "Verdana",
                                        fontsize: 12,
                                        bold: false,
                                        italic: false,
                                        linewidth: 2,
                                        frozen: false,
                                        visible: true,
                                        symbol: "BBCA",
                                        interval: "D",
                                        lastUpdateTime: 0,
                                        _isActualInterval: true,
                                        fixedSize: true
                                    },
                                    points: [
                                        {
                                            time_t: 1577379600,
                                            offset: 0,
                                            price: 33529.98191418593
                                        },
                                        {
                                            time_t: 1577379600,
                                            offset: 0,
                                            price: 33529.98191418593
                                        },
                                        {
                                            time_t: 1575824400,
                                            offset: 0,
                                            price: 34666.94557625146
                                        },
                                        {
                                            time_t: 1577898000,
                                            offset: 0,
                                            price: 34901.28159820389
                                        }, 
                                    ],
                                    zorder: 4,
                                    linkKey: "lvBmAe9gwb3J",
                                    ownerSource: "_seriesId"
                                }, 
                            ],
                            leftAxisState: {
                                m_priceRange: {
                                    m_maxValue: 0.5,
                                    m_minValue: -0.5
                                },
                                m_isAutoScale: true,
                                m_isPercentage: false,
                                m_isIndexedTo100: false,
                                m_isLog: false,
                                m_isLockScale: false,
                                m_height: 877,
                                m_topMargin: 0.17,
                                m_bottomMargin: 0.15
                            },
                            leftAxisSources: [],
                            rightAxisState: {
                                m_priceRange: {
                                    m_maxValue: 35300,
                                    m_minValue: 25700
                                },
                                m_isAutoScale: true,
                                m_isPercentage: false,
                                m_isIndexedTo100: false,
                                m_isLog: false,
                                m_isLockScale: false,
                                m_height: 877,
                                m_topMargin: 0.17,
                                m_bottomMargin: 0.15
                            },
                            rightAxisSources: [
                                "_seriesId",
                                "VP10po"
                            ],
                            overlayPriceScales: {
                                "44EV8q": {
                                    m_priceRange: {
                                        m_maxValue: 35300,
                                        m_minValue: 25700
                                    },
                                    m_isAutoScale: true,
                                    m_isPercentage: false,
                                    m_isIndexedTo100: false,
                                    m_isLog: false,
                                    m_isLockScale: false,
                                    m_height: 877,
                                    m_topMargin: 0.17,
                                    m_bottomMargin: 0.15
                                }
                            },
                            stretchFactor: 4484.635413319781,
                            mainSourceId: "_seriesId"
                        }, 
                    ],
                    timeScale: {
                        m_barSpacing: 6,
                        m_rightOffset: 35
                    },
                    chartProperties: {
                        paneProperties: {
                            background: "#131722",
                            gridProperties: {
                                color: "#363c4e",
                                style: 0
                            },
                            vertGridProperties: {
                                color: "#363c4e",
                                style: 0
                            },
                            horzGridProperties: {
                                color: "#363c4e",
                                style: 0
                            },
                            crossHairProperties: {
                                color: "#758696",
                                style: 2,
                                transparency: 0,
                                width: 1
                            },
                            topMargin: 17,
                            bottomMargin: 15,
                            leftAxisProperties: {
                                autoScale: true,
                                autoScaleDisabled: false,
                                lockScale: false,
                                percentage: false,
                                percentageDisabled: false,
                                indexedTo100: false,
                                log: false,
                                logDisabled: false,
                                alignLabels: true
                            },
                            rightAxisProperties: {
                                autoScale: true,
                                autoScaleDisabled: false,
                                lockScale: false,
                                percentage: false,
                                percentageDisabled: false,
                                log: false,
                                logDisabled: false,
                                alignLabels: true
                            },
                            legendProperties: {
                                showStudyArguments: true,
                                showStudyTitles: true,
                                showStudyValues: false,
                                showSeriesTitle: true,
                                showSeriesOHLC: true,
                                showLegend: false,
                                showBarChange: true,
                                showOnlyPriceSource: true
                            }
                        },
                        scalesProperties: {
                            showLeftScale: false,
                            showRightScale: true,
                            backgroundColor: "#ffffff",
                            lineColor: "#787878",
                            textColor: "#D9D9D9",
                            fontSize: 11,
                            scaleSeriesOnly: false,
                            showSeriesLastValue: true,
                            showSeriesPrevCloseValue: false,
                            showStudyLastValue: true,
                            showSymbolLabels: false,
                            showStudyPlotLabels: false,
                            barSpacing: 6
                        },
                        chartEventsSourceProperties: {
                            visible: true,
                            futureOnly: true,
                            breaks: {
                                color: "rgba(85, 85, 85, 1)",
                                visible: false,
                                style: 2,
                                width: 1
                            }
                        }
                    },
                    version: 2,
                    timezone: "Etc/UTC"
                }, 
            ]
        }
    },
    {
        key: "default",
        name: "Default",
        template: {
            layout: "s",
            charts: [
                {
                    panes: [
                        {
                            sources: [
                                {
                                    type: "MainSeries",
                                    id: "_seriesId",
                                    zorder: 0,
                                    haStyle: {
                                        studyId: "BarSetHeikenAshi@tv-basicstudies-60"
                                    },
                                    renkoStyle: {
                                        studyId: "BarSetRenko@tv-prostudies-64"
                                    },
                                    pbStyle: {
                                        studyId: "BarSetPriceBreak@tv-prostudies-34"
                                    },
                                    kagiStyle: {
                                        studyId: "BarSetKagi@tv-prostudies-34"
                                    },
                                    pnfStyle: {
                                        studyId: "BarSetPnF@tv-prostudies-34"
                                    },
                                    rangeStyle: {
                                        studyId: "BarSetRange@tv-basicstudies-72"
                                    },
                                    formattingDeps: {
                                        format: "price",
                                        pricescale: 100,
                                        minmov: 1
                                    },
                                    state: {
                                        style: 1,
                                        esdShowDividends: true,
                                        esdShowSplits: true,
                                        esdShowEarnings: true,
                                        esdShowBreaks: false,
                                        esdFlagSize: 2,
                                        showContinuousContractSwitches: true,
                                        showContinuousContractSwitchesBreaks: false,
                                        showFuturesContractExpiration: true,
                                        showLastNews: true,
                                        showCountdown: false,
                                        bidAsk: {
                                            visible: false,
                                            lineStyle: 1,
                                            lineWidth: 1,
                                            bidLineColor: "#2962FF",
                                            askLineColor: "#F7525F"
                                        },
                                        prePostMarket: {
                                            visible: true,
                                            lineStyle: 1,
                                            lineWidth: 1,
                                            preMarketColor: "#FB8C00",
                                            postMarketColor: "#2962FF"
                                        },
                                        highLowAvgPrice: {
                                            highLowPriceLinesVisible: false,
                                            highLowPriceLabelsVisible: false,
                                            averageClosePriceLineVisible: false,
                                            averageClosePriceLabelVisible: false,
                                            highLowPriceLinesColor: "",
                                            highLowPriceLinesWidth: 1,
                                            averagePriceLineColor: "",
                                            averagePriceLineWidth: 1
                                        },
                                        visible: true,
                                        showPriceLine: true,
                                        priceLineWidth: 1,
                                        priceLineColor: "",
                                        baseLineColor: "#B2B5BE",
                                        showPrevClosePriceLine: false,
                                        prevClosePriceLineWidth: 1,
                                        prevClosePriceLineColor: "#555555",
                                        minTick: "default",
                                        dividendsAdjustment: null,
                                        backAdjustment: false,
                                        settlementAsClose: true,
                                        sessionId: "regular",
                                        sessVis: false,
                                        statusViewStyle: {
                                            fontSize: 16,
                                            showExchange: true,
                                            showInterval: true,
                                            symbolTextSource: "description",
                                            showSymbolAsDescription: false
                                        },
                                        candleStyle: {
                                            upColor: "#00AB6B",
                                            downColor: "#EE4A49",
                                            drawWick: true,
                                            drawBorder: true,
                                            borderColor: "#00AB6B",
                                            borderUpColor: "#00AB6B",
                                            borderDownColor: "#EE4A49",
                                            wickColor: "#737375",
                                            wickUpColor: "#00AB6B",
                                            wickDownColor: "#EE4A49",
                                            barColorsOnPrevClose: false,
                                            drawBody: true
                                        },
                                        hollowCandleStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            drawWick: true,
                                            drawBorder: true,
                                            borderColor: "#378658",
                                            borderUpColor: "#089981",
                                            borderDownColor: "#F23645",
                                            wickColor: "#737375",
                                            wickUpColor: "#089981",
                                            wickDownColor: "#F23645",
                                            drawBody: true
                                        },
                                        haStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            drawWick: true,
                                            drawBorder: true,
                                            borderColor: "#378658",
                                            borderUpColor: "#089981",
                                            borderDownColor: "#F23645",
                                            wickColor: "#737375",
                                            wickUpColor: "#089981",
                                            wickDownColor: "#F23645",
                                            showRealLastPrice: false,
                                            barColorsOnPrevClose: false,
                                            inputs: {},
                                            inputInfo: {},
                                            drawBody: true
                                        },
                                        barStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            barColorsOnPrevClose: false,
                                            dontDrawOpen: false,
                                            thinBars: true
                                        },
                                        hiloStyle: {
                                            color: "#2962FF",
                                            showBorders: true,
                                            borderColor: "#2962FF",
                                            showLabels: true,
                                            labelColor: "#2962FF",
                                            drawBody: true,
                                            fontSize: 7
                                        },
                                        columnStyle: {
                                            upColor: "rgba(8, 153, 129, 0.5)",
                                            downColor: "rgba(242, 54, 69, 0.5)",
                                            barColorsOnPrevClose: true,
                                            priceSource: "close"
                                        },
                                        lineStyle: {
                                            color: "#2962FF",
                                            linestyle: 0,
                                            linewidth: 2,
                                            priceSource: "close"
                                        },
                                        lineWithMarkersStyle: {
                                            color: "#2962FF",
                                            linestyle: 0,
                                            linewidth: 2,
                                            priceSource: "close"
                                        },
                                        steplineStyle: {
                                            color: "#2962FF",
                                            linestyle: 0,
                                            linewidth: 2,
                                            priceSource: "close"
                                        },
                                        areaStyle: {
                                            color1: "rgba(41, 98, 255, 0.28)",
                                            color2: "#2962FF",
                                            linecolor: "#2962FF",
                                            linestyle: 0,
                                            linewidth: 1,
                                            priceSource: "close",
                                            transparency: 100
                                        },
                                        hlcAreaStyle: {
                                            highLineColor: "#089981",
                                            highLineStyle: 0,
                                            highLineWidth: 2,
                                            lowLineColor: "#F23645",
                                            lowLineStyle: 0,
                                            lowLineWidth: 2,
                                            closeLineColor: "#868993",
                                            closeLineStyle: 0,
                                            closeLineWidth: 2,
                                            highCloseFillColor: "rgba(8, 153, 129, 0.2)",
                                            closeLowFillColor: "rgba(242, 54, 69, 0.2)"
                                        },
                                        renkoStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            borderUpColor: "#089981",
                                            borderDownColor: "#F23645",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            borderUpColorProjection: "#a9dcc3",
                                            borderDownColorProjection: "#f5a6ae",
                                            wickUpColor: "#089981",
                                            wickDownColor: "#F23645",
                                            inputs: {
                                                source: "close",
                                                sources: "Close",
                                                boxSize: 3,
                                                style: "ATR",
                                                atrLength: 14,
                                                wicks: true
                                            },
                                            inputInfo: {
                                                source: {
                                                    name: "Source"
                                                },
                                                sources: {
                                                    name: "Source"
                                                },
                                                boxSize: {
                                                    name: "Box size"
                                                },
                                                style: {
                                                    name: "Style"
                                                },
                                                atrLength: {
                                                    name: "ATR length"
                                                },
                                                wicks: {
                                                    name: "Wicks"
                                                }
                                            }
                                        },
                                        pbStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            borderUpColor: "#089981",
                                            borderDownColor: "#F23645",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            borderUpColorProjection: "#a9dcc3",
                                            borderDownColorProjection: "#f5a6ae",
                                            inputs: {
                                                source: "close",
                                                lb: 3
                                            },
                                            inputInfo: {
                                                source: {
                                                    name: "Source"
                                                },
                                                lb: {
                                                    name: "Number of line"
                                                }
                                            }
                                        },
                                        kagiStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            inputs: {
                                                source: "close",
                                                style: "ATR",
                                                atrLength: 14,
                                                reversalAmount: 1
                                            },
                                            inputInfo: {
                                                source: {
                                                    name: "Source"
                                                },
                                                style: {
                                                    name: "Style"
                                                },
                                                atrLength: {
                                                    name: "ATR length"
                                                },
                                                reversalAmount: {
                                                    name: "Reversal amount"
                                                }
                                            }
                                        },
                                        pnfStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            inputs: {
                                                sources: "Close",
                                                reversalAmount: 3,
                                                boxSize: 1,
                                                style: "ATR",
                                                atrLength: 14,
                                                oneStepBackBuilding: false
                                            },
                                            inputInfo: {
                                                sources: {
                                                    name: "Source"
                                                },
                                                boxSize: {
                                                    name: "Box size"
                                                },
                                                reversalAmount: {
                                                    name: "Reversal amount"
                                                },
                                                style: {
                                                    name: "Style"
                                                },
                                                atrLength: {
                                                    name: "ATR length"
                                                },
                                                oneStepBackBuilding: {
                                                    name: "One step back building"
                                                }
                                            }
                                        },
                                        baselineStyle: {
                                            baselineColor: "#758696",
                                            topFillColor1: "rgba(8, 153, 129, 0.28)",
                                            topFillColor2: "rgba(8, 153, 129, 0.05)",
                                            bottomFillColor1: "rgba(242, 54, 69, 0.05)",
                                            bottomFillColor2: "rgba(242, 54, 69, 0.28)",
                                            topLineColor: "#089981",
                                            bottomLineColor: "#F23645",
                                            topLineWidth: 1,
                                            bottomLineWidth: 1,
                                            priceSource: "close",
                                            transparency: 50,
                                            baseLevelPercentage: 50
                                        },
                                        rangeStyle: {
                                            barStyle: 0,
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            thinBars: true,
                                            candlesUpColor: "#089981",
                                            candlesDownColor: "#F23645",
                                            candlesBorderUpColor: "#089981",
                                            candlesBorderDownColor: "#F23645",
                                            candlesWickUpColor: "#089981",
                                            candlesWickDownColor: "#F23645",
                                            inputs: {
                                                range: 10,
                                                phantomBars: false
                                            },
                                            inputInfo: {
                                                range: {
                                                    name: "Range"
                                                },
                                                phantomBars: {
                                                    name: "Phantom bars"
                                                }
                                            }
                                        },
                                        symbol: "IHSG",
                                        shortName: "IHSG",
                                        timeframe: "",
                                        onWidget: false,
                                        interval: "D",
                                        unitId: null,
                                        showInDataWindow: true,
                                        showSessions: false,
                                        shortname: "",
                                        currencyId: null,
                                        priceAxisProperties: {
                                            autoScale: true,
                                            autoScaleDisabled: false,
                                            lockScale: false,
                                            percentage: false,
                                            percentageDisabled: false,
                                            log: false,
                                            logDisabled: false,
                                            alignLabels: true,
                                            isInverted: false,
                                            indexedTo100: false
                                        }
                                    }
                                },
                                {
                                    type: "Study",
                                    id: "P1a4zR",
                                    state: {
                                        styles: {
                                            plot_0: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 2,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 11,
                                                color: "#D04EB1",
                                                title: "plot_0"
                                            },
                                            smoothedMA: {
                                                display: 0,
                                                linestyle: 0,
                                                linewidth: 1,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 0,
                                                color: "#0496ff",
                                                title: "smoothedMA"
                                            }
                                        },
                                        inputs: {
                                            symbol: "",
                                            length: 50,
                                            source: "close",
                                            offset: 0,
                                            smoothingLine: "SMA",
                                            smoothingLength: 9
                                        },
                                        precision: "default",
                                        bands: {},
                                        graphics: {},
                                        ohlcPlots: {},
                                        palettes: {},
                                        filledAreasStyle: {},
                                        filledAreas: {},
                                        visible: true,
                                        showLegendValues: true,
                                        showLabelsOnPriceScale: true,
                                        parentSources: {},
                                        intervalsVisibilities: {
                                            ticks: true,
                                            seconds: true,
                                            secondsFrom: 1,
                                            secondsTo: 59,
                                            minutes: true,
                                            minutesFrom: 1,
                                            minutesTo: 59,
                                            hours: true,
                                            hoursFrom: 1,
                                            hoursTo: 24,
                                            days: true,
                                            daysFrom: 1,
                                            daysTo: 366,
                                            weeks: true,
                                            weeksFrom: 1,
                                            weeksTo: 52,
                                            months: true,
                                            monthsFrom: 1,
                                            monthsTo: 12,
                                            ranges: true
                                        }
                                    },
                                    zorder: -10000,
                                    ownFirstValue: null,
                                    metaInfo: {
                                        palettes: {},
                                        inputs: [
                                            {
                                                id: "symbol",
                                                name: "Other Symbol",
                                                defval: "",
                                                type: "symbol",
                                                optional: true,
                                                isHidden: false,
                                                display: 15
                                            },
                                            {
                                                id: "length",
                                                name: "Length",
                                                defval: 9,
                                                type: "integer",
                                                min: 1,
                                                max: 10000,
                                                display: 15
                                            },
                                            {
                                                id: "source",
                                                name: "Source",
                                                defval: "close",
                                                type: "source",
                                                options: [
                                                    "open",
                                                    "high",
                                                    "low",
                                                    "close",
                                                    "hl2",
                                                    "hlc3",
                                                    "ohlc4", 
                                                ],
                                                display: 15
                                            },
                                            {
                                                id: "offset",
                                                name: "Offset",
                                                defval: 0,
                                                type: "integer",
                                                min: -10000,
                                                max: 10000,
                                                display: 15
                                            },
                                            {
                                                id: "smoothingLine",
                                                name: "Smoothing Line",
                                                defval: "SMA",
                                                type: "text",
                                                options: [
                                                    "SMA",
                                                    "EMA",
                                                    "WMA"
                                                ],
                                                display: 15
                                            },
                                            {
                                                id: "smoothingLength",
                                                name: "Smoothing Length",
                                                defval: 9,
                                                type: "integer",
                                                min: 1,
                                                max: 10000,
                                                display: 15
                                            }, 
                                        ],
                                        plots: [
                                            {
                                                id: "plot_0",
                                                type: "line"
                                            },
                                            {
                                                id: "smoothedMA",
                                                type: "line"
                                            }, 
                                        ],
                                        graphics: {},
                                        defaults: {
                                            styles: {
                                                plot_0: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 1,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 0,
                                                    color: "#2196F3"
                                                },
                                                smoothedMA: {
                                                    display: 0,
                                                    linestyle: 0,
                                                    linewidth: 1,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 0
                                                }
                                            },
                                            inputs: {
                                                symbol: "",
                                                length: 9,
                                                source: "close",
                                                offset: 0,
                                                smoothingLine: "SMA",
                                                smoothingLength: 9
                                            }
                                        },
                                        _metainfoVersion: 53,
                                        isTVScript: false,
                                        isTVScriptStub: false,
                                        is_hidden_study: false,
                                        styles: {
                                            plot_0: {
                                                title: "Plot",
                                                histogramBase: 0,
                                                joinPoints: false
                                            },
                                            smoothedMA: {
                                                title: "Smoothed MA",
                                                histogramBase: 0,
                                                joinPoints: false
                                            }
                                        },
                                        description: "Moving Average",
                                        shortDescription: "MA",
                                        is_price_study: true,
                                        id: "Moving Average@tv-basicstudies-1",
                                        scriptIdPart: "",
                                        name: "Moving Average",
                                        format: {
                                            type: "inherit"
                                        },
                                        symbolSource: {
                                            type: "symbolInputSymbolSource",
                                            inputId: "symbol"
                                        },
                                        description_localized: "Moving Average",
                                        shortId: "Moving Average",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Moving Average@tv-basicstudies-1",
                                        productId: "tv-basicstudies",
                                        _serverMetaInfoVersion: 52
                                    }
                                },
                                {
                                    type: "Study",
                                    id: "3soaUC",
                                    state: {
                                        styles: {
                                            plot_0: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 2,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 11,
                                                color: "#7CA7EB",
                                                title: "plot_0"
                                            },
                                            smoothedMA: {
                                                display: 0,
                                                linestyle: 0,
                                                linewidth: 1,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 0,
                                                color: "#044bff",
                                                title: "smoothedMA"
                                            }
                                        },
                                        inputs: {
                                            symbol: "",
                                            length: 100,
                                            source: "close",
                                            offset: 0,
                                            smoothingLine: "SMA",
                                            smoothingLength: 9
                                        },
                                        precision: "default",
                                        bands: {},
                                        graphics: {},
                                        ohlcPlots: {},
                                        palettes: {},
                                        filledAreasStyle: {},
                                        filledAreas: {},
                                        visible: true,
                                        showLegendValues: true,
                                        showLabelsOnPriceScale: true,
                                        parentSources: {},
                                        intervalsVisibilities: {
                                            ticks: true,
                                            seconds: true,
                                            secondsFrom: 1,
                                            secondsTo: 59,
                                            minutes: true,
                                            minutesFrom: 1,
                                            minutesTo: 59,
                                            hours: true,
                                            hoursFrom: 1,
                                            hoursTo: 24,
                                            days: true,
                                            daysFrom: 1,
                                            daysTo: 366,
                                            weeks: true,
                                            weeksFrom: 1,
                                            weeksTo: 52,
                                            months: true,
                                            monthsFrom: 1,
                                            monthsTo: 12,
                                            ranges: true
                                        }
                                    },
                                    zorder: -20000,
                                    ownFirstValue: null,
                                    metaInfo: {
                                        palettes: {},
                                        inputs: [
                                            {
                                                id: "symbol",
                                                name: "Other Symbol",
                                                defval: "",
                                                type: "symbol",
                                                optional: true,
                                                isHidden: false,
                                                display: 15
                                            },
                                            {
                                                id: "length",
                                                name: "Length",
                                                defval: 9,
                                                type: "integer",
                                                min: 1,
                                                max: 10000,
                                                display: 15
                                            },
                                            {
                                                id: "source",
                                                name: "Source",
                                                defval: "close",
                                                type: "source",
                                                options: [
                                                    "open",
                                                    "high",
                                                    "low",
                                                    "close",
                                                    "hl2",
                                                    "hlc3",
                                                    "ohlc4", 
                                                ],
                                                display: 15
                                            },
                                            {
                                                id: "offset",
                                                name: "Offset",
                                                defval: 0,
                                                type: "integer",
                                                min: -10000,
                                                max: 10000,
                                                display: 15
                                            },
                                            {
                                                id: "smoothingLine",
                                                name: "Smoothing Line",
                                                defval: "SMA",
                                                type: "text",
                                                options: [
                                                    "SMA",
                                                    "EMA",
                                                    "WMA"
                                                ],
                                                display: 15
                                            },
                                            {
                                                id: "smoothingLength",
                                                name: "Smoothing Length",
                                                defval: 9,
                                                type: "integer",
                                                min: 1,
                                                max: 10000,
                                                display: 15
                                            }, 
                                        ],
                                        plots: [
                                            {
                                                id: "plot_0",
                                                type: "line"
                                            },
                                            {
                                                id: "smoothedMA",
                                                type: "line"
                                            }, 
                                        ],
                                        graphics: {},
                                        defaults: {
                                            styles: {
                                                plot_0: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 1,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 0,
                                                    color: "#2196F3"
                                                },
                                                smoothedMA: {
                                                    display: 0,
                                                    linestyle: 0,
                                                    linewidth: 1,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 0
                                                }
                                            },
                                            inputs: {
                                                symbol: "",
                                                length: 9,
                                                source: "close",
                                                offset: 0,
                                                smoothingLine: "SMA",
                                                smoothingLength: 9
                                            }
                                        },
                                        _metainfoVersion: 53,
                                        isTVScript: false,
                                        isTVScriptStub: false,
                                        is_hidden_study: false,
                                        styles: {
                                            plot_0: {
                                                title: "Plot",
                                                histogramBase: 0,
                                                joinPoints: false
                                            },
                                            smoothedMA: {
                                                title: "Smoothed MA",
                                                histogramBase: 0,
                                                joinPoints: false
                                            }
                                        },
                                        description: "Moving Average",
                                        shortDescription: "MA",
                                        is_price_study: true,
                                        id: "Moving Average@tv-basicstudies-1",
                                        scriptIdPart: "",
                                        name: "Moving Average",
                                        format: {
                                            type: "inherit"
                                        },
                                        symbolSource: {
                                            type: "symbolInputSymbolSource",
                                            inputId: "symbol"
                                        },
                                        description_localized: "Moving Average",
                                        shortId: "Moving Average",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Moving Average@tv-basicstudies-1",
                                        productId: "tv-basicstudies",
                                        _serverMetaInfoVersion: 52
                                    }
                                },
                                {
                                    type: "Study",
                                    id: "8F3HDM",
                                    state: {
                                        styles: {
                                            plot_0: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 2,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 11,
                                                color: "#3AA36D",
                                                title: "plot_0"
                                            },
                                            smoothedMA: {
                                                display: 0,
                                                linestyle: 0,
                                                linewidth: 1,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 0,
                                                color: "#0904ff",
                                                title: "smoothedMA"
                                            }
                                        },
                                        inputs: {
                                            symbol: "",
                                            length: 200,
                                            source: "close",
                                            offset: 0,
                                            smoothingLine: "SMA",
                                            smoothingLength: 9
                                        },
                                        precision: "default",
                                        bands: {},
                                        graphics: {},
                                        ohlcPlots: {},
                                        palettes: {},
                                        filledAreasStyle: {},
                                        filledAreas: {},
                                        visible: true,
                                        showLegendValues: true,
                                        showLabelsOnPriceScale: true,
                                        parentSources: {},
                                        intervalsVisibilities: {
                                            ticks: true,
                                            seconds: true,
                                            secondsFrom: 1,
                                            secondsTo: 59,
                                            minutes: true,
                                            minutesFrom: 1,
                                            minutesTo: 59,
                                            hours: true,
                                            hoursFrom: 1,
                                            hoursTo: 24,
                                            days: true,
                                            daysFrom: 1,
                                            daysTo: 366,
                                            weeks: true,
                                            weeksFrom: 1,
                                            weeksTo: 52,
                                            months: true,
                                            monthsFrom: 1,
                                            monthsTo: 12,
                                            ranges: true
                                        }
                                    },
                                    zorder: -30000,
                                    ownFirstValue: null,
                                    metaInfo: {
                                        palettes: {},
                                        inputs: [
                                            {
                                                id: "symbol",
                                                name: "Other Symbol",
                                                defval: "",
                                                type: "symbol",
                                                optional: true,
                                                isHidden: false,
                                                display: 15
                                            },
                                            {
                                                id: "length",
                                                name: "Length",
                                                defval: 9,
                                                type: "integer",
                                                min: 1,
                                                max: 10000,
                                                display: 15
                                            },
                                            {
                                                id: "source",
                                                name: "Source",
                                                defval: "close",
                                                type: "source",
                                                options: [
                                                    "open",
                                                    "high",
                                                    "low",
                                                    "close",
                                                    "hl2",
                                                    "hlc3",
                                                    "ohlc4", 
                                                ],
                                                display: 15
                                            },
                                            {
                                                id: "offset",
                                                name: "Offset",
                                                defval: 0,
                                                type: "integer",
                                                min: -10000,
                                                max: 10000,
                                                display: 15
                                            },
                                            {
                                                id: "smoothingLine",
                                                name: "Smoothing Line",
                                                defval: "SMA",
                                                type: "text",
                                                options: [
                                                    "SMA",
                                                    "EMA",
                                                    "WMA"
                                                ],
                                                display: 15
                                            },
                                            {
                                                id: "smoothingLength",
                                                name: "Smoothing Length",
                                                defval: 9,
                                                type: "integer",
                                                min: 1,
                                                max: 10000,
                                                display: 15
                                            }, 
                                        ],
                                        plots: [
                                            {
                                                id: "plot_0",
                                                type: "line"
                                            },
                                            {
                                                id: "smoothedMA",
                                                type: "line"
                                            }, 
                                        ],
                                        graphics: {},
                                        defaults: {
                                            styles: {
                                                plot_0: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 1,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 0,
                                                    color: "#2196F3"
                                                },
                                                smoothedMA: {
                                                    display: 0,
                                                    linestyle: 0,
                                                    linewidth: 1,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 0
                                                }
                                            },
                                            inputs: {
                                                symbol: "",
                                                length: 9,
                                                source: "close",
                                                offset: 0,
                                                smoothingLine: "SMA",
                                                smoothingLength: 9
                                            }
                                        },
                                        _metainfoVersion: 53,
                                        isTVScript: false,
                                        isTVScriptStub: false,
                                        is_hidden_study: false,
                                        styles: {
                                            plot_0: {
                                                title: "Plot",
                                                histogramBase: 0,
                                                joinPoints: false
                                            },
                                            smoothedMA: {
                                                title: "Smoothed MA",
                                                histogramBase: 0,
                                                joinPoints: false
                                            }
                                        },
                                        description: "Moving Average",
                                        shortDescription: "MA",
                                        is_price_study: true,
                                        id: "Moving Average@tv-basicstudies-1",
                                        scriptIdPart: "",
                                        name: "Moving Average",
                                        format: {
                                            type: "inherit"
                                        },
                                        symbolSource: {
                                            type: "symbolInputSymbolSource",
                                            inputId: "symbol"
                                        },
                                        description_localized: "Moving Average",
                                        shortId: "Moving Average",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Moving Average@tv-basicstudies-1",
                                        productId: "tv-basicstudies",
                                        _serverMetaInfoVersion: 52
                                    }
                                }, 
                            ],
                            mainSourceId: "_seriesId",
                            stretchFactor: 4331.438645097106,
                            leftAxisesState: [],
                            rightAxisesState: [
                                {
                                    state: {
                                        id: "EZXBZ45NPMO6",
                                        m_priceRange: null,
                                        m_isAutoScale: true,
                                        m_isPercentage: false,
                                        m_isIndexedTo100: false,
                                        m_isLog: false,
                                        m_isLockScale: false,
                                        m_isInverted: false,
                                        m_topMargin: 0.17,
                                        m_bottomMargin: 0.15,
                                        alignLabels: true,
                                        logFormula: {
                                            logicalOffset: 4,
                                            coordOffset: 0.0001
                                        }
                                    },
                                    sources: [
                                        "_seriesId",
                                        "P1a4zR",
                                        "3soaUC",
                                        "8F3HDM"
                                    ]
                                }, 
                            ],
                            overlayPriceScales: {},
                            priceScaleRatio: null
                        },
                        {
                            sources: [
                                {
                                    type: "Study",
                                    id: "poq8Ua",
                                    state: {
                                        styles: {
                                            vol: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 1,
                                                plottype: 5,
                                                trackPrice: false,
                                                transparency: 0,
                                                color: "#000080",
                                                title: "vol"
                                            },
                                            vol_ma: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 2,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 30,
                                                color: "#0496ff",
                                                title: "vol_ma"
                                            }
                                        },
                                        precision: "default",
                                        palettes: {
                                            volumePalette: {
                                                colors: {
                                                    0: {
                                                        color: "rgba(235, 77, 92, 0.50)",
                                                        width: 1,
                                                        style: 0
                                                    },
                                                    1: {
                                                        color: "rgba(83, 185, 135, 0.50)",
                                                        width: 1,
                                                        style: 0
                                                    }
                                                }
                                            }
                                        },
                                        inputs: {
                                            showMA: true,
                                            maLength: 20
                                        },
                                        bands: {},
                                        graphics: {},
                                        ohlcPlots: {},
                                        filledAreasStyle: {},
                                        filledAreas: {},
                                        visible: true,
                                        showLegendValues: true,
                                        showLabelsOnPriceScale: true,
                                        parentSources: {},
                                        intervalsVisibilities: {
                                            ticks: true,
                                            seconds: true,
                                            secondsFrom: 1,
                                            secondsTo: 59,
                                            minutes: true,
                                            minutesFrom: 1,
                                            minutesTo: 59,
                                            hours: true,
                                            hoursFrom: 1,
                                            hoursTo: 24,
                                            days: true,
                                            daysFrom: 1,
                                            daysTo: 366,
                                            weeks: true,
                                            weeksFrom: 1,
                                            weeksTo: 52,
                                            months: true,
                                            monthsFrom: 1,
                                            monthsTo: 12,
                                            ranges: true
                                        }
                                    },
                                    zorder: -10000,
                                    ownFirstValue: null,
                                    metaInfo: {
                                        palettes: {
                                            volumePalette: {
                                                colors: [
                                                    {
                                                        name: "Falling"
                                                    },
                                                    {
                                                        name: "Growing"
                                                    }
                                                ]
                                            }
                                        },
                                        inputs: [
                                            {
                                                id: "showMA",
                                                name: "show MA",
                                                defval: true,
                                                type: "bool",
                                                display: 0
                                            },
                                            {
                                                id: "maLength",
                                                name: "MA Length",
                                                defval: 20,
                                                type: "integer",
                                                min: 1,
                                                max: 2000,
                                                display: 15
                                            }, 
                                        ],
                                        plots: [
                                            {
                                                id: "vol",
                                                type: "line"
                                            },
                                            {
                                                id: "volumePalette",
                                                palette: "volumePalette",
                                                target: "vol",
                                                type: "colorer"
                                            },
                                            {
                                                id: "vol_ma",
                                                type: "line"
                                            }, 
                                        ],
                                        graphics: {},
                                        defaults: {
                                            styles: {
                                                vol: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 1,
                                                    plottype: 5,
                                                    trackPrice: false,
                                                    transparency: 0,
                                                    color: "#000080"
                                                },
                                                vol_ma: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 2,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 30,
                                                    color: "#0496FF"
                                                }
                                            },
                                            precision: 0,
                                            palettes: {
                                                volumePalette: {
                                                    colors: {
                                                        0: {
                                                            color: "rgba(235, 77, 92, 0.50)",
                                                            width: 1,
                                                            style: 0
                                                        },
                                                        1: {
                                                            color: "rgba(83, 185, 135, 0.50)",
                                                            width: 1,
                                                            style: 0
                                                        }
                                                    }
                                                }
                                            },
                                            inputs: {
                                                showMA: true,
                                                maLength: 20
                                            }
                                        },
                                        _metainfoVersion: 53,
                                        id: "Volume_@tv-basicstudies-1",
                                        is_hidden_study: false,
                                        description: "Volume_",
                                        shortDescription: "Volume",
                                        is_price_study: false,
                                        format: {
                                            type: "volume",
                                            precision: 3
                                        },
                                        styles: {
                                            vol: {
                                                title: "Volume_",
                                                histogramBase: 0
                                            },
                                            vol_ma: {
                                                title: "Volume MA",
                                                histogramBase: 0
                                            }
                                        },
                                        description_localized: "Volume_",
                                        shortId: "Volume_",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Volume_@tv-basicstudies-1",
                                        productId: "tv-basicstudies",
                                        _serverMetaInfoVersion: 51
                                    }
                                }, 
                            ],
                            mainSourceId: "poq8Ua",
                            stretchFactor: 761.6340921567289,
                            leftAxisesState: [],
                            rightAxisesState: [
                                {
                                    state: {
                                        id: "Nt7ZxxUJbdwF",
                                        m_priceRange: null,
                                        m_isAutoScale: true,
                                        m_isPercentage: false,
                                        m_isIndexedTo100: false,
                                        m_isLog: false,
                                        m_isLockScale: false,
                                        m_isInverted: false,
                                        m_topMargin: 0.17,
                                        m_bottomMargin: 0.15,
                                        alignLabels: true,
                                        logFormula: {
                                            logicalOffset: 4,
                                            coordOffset: 0.0001
                                        }
                                    },
                                    sources: [
                                        "poq8Ua"
                                    ]
                                }, 
                            ],
                            overlayPriceScales: {},
                            priceScaleRatio: null
                        },
                        {
                            sources: [
                                {
                                    type: "Study",
                                    id: "1hnSfV",
                                    state: {
                                        styles: {
                                            plot_0: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 1,
                                                plottype: 1,
                                                trackPrice: false,
                                                transparency: 50,
                                                color: "#FF0000",
                                                title: "plot_0"
                                            },
                                            plot_1: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 2,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 11,
                                                color: "#0E4DC9",
                                                title: "plot_1"
                                            },
                                            plot_2: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 2,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 11,
                                                color: "#A41919",
                                                title: "plot_2"
                                            }
                                        },
                                        palettes: {
                                            palette_0: {
                                                colors: {
                                                    0: {
                                                        color: "#22AB94",
                                                        width: 1,
                                                        style: 0
                                                    },
                                                    1: {
                                                        color: "#ACE5DC",
                                                        width: 1,
                                                        style: 0
                                                    },
                                                    2: {
                                                        color: "#FCCBCD",
                                                        width: 1,
                                                        style: 0
                                                    },
                                                    3: {
                                                        color: "#FF5252",
                                                        width: 1,
                                                        style: 0
                                                    }
                                                }
                                            }
                                        },
                                        inputs: {
                                            in_0: 12,
                                            in_1: 26,
                                            in_3: "close",
                                            in_2: 9
                                        },
                                        precision: 2,
                                        bands: {},
                                        graphics: {},
                                        ohlcPlots: {},
                                        filledAreasStyle: {},
                                        filledAreas: {},
                                        visible: true,
                                        showLegendValues: true,
                                        showLabelsOnPriceScale: true,
                                        parentSources: {},
                                        intervalsVisibilities: {
                                            ticks: true,
                                            seconds: true,
                                            secondsFrom: 1,
                                            secondsTo: 59,
                                            minutes: true,
                                            minutesFrom: 1,
                                            minutesTo: 59,
                                            hours: true,
                                            hoursFrom: 1,
                                            hoursTo: 24,
                                            days: true,
                                            daysFrom: 1,
                                            daysTo: 366,
                                            weeks: true,
                                            weeksFrom: 1,
                                            weeksTo: 52,
                                            months: true,
                                            monthsFrom: 1,
                                            monthsTo: 12,
                                            ranges: true
                                        }
                                    },
                                    zorder: -10000,
                                    ownFirstValue: null,
                                    metaInfo: {
                                        palettes: {
                                            palette_0: {
                                                colors: {
                                                    0: {
                                                        name: "Color 0"
                                                    },
                                                    1: {
                                                        name: "Color 1"
                                                    },
                                                    2: {
                                                        name: "Color 2"
                                                    },
                                                    3: {
                                                        name: "Color 3"
                                                    }
                                                }
                                            }
                                        },
                                        inputs: [
                                            {
                                                id: "in_0",
                                                name: "fastLength",
                                                defval: 12,
                                                type: "integer",
                                                min: 1,
                                                max: 2000,
                                                display: 15
                                            },
                                            {
                                                id: "in_1",
                                                name: "slowLength",
                                                defval: 26,
                                                type: "integer",
                                                min: 1,
                                                max: 2000,
                                                display: 15
                                            },
                                            {
                                                id: "in_3",
                                                name: "Source",
                                                defval: "close",
                                                type: "source",
                                                options: [
                                                    "open",
                                                    "high",
                                                    "low",
                                                    "close",
                                                    "hl2",
                                                    "hlc3",
                                                    "ohlc4", 
                                                ],
                                                display: 15
                                            },
                                            {
                                                id: "in_2",
                                                name: "signalLength",
                                                defval: 9,
                                                type: "integer",
                                                min: 1,
                                                max: 50,
                                                display: 15
                                            }, 
                                        ],
                                        plots: [
                                            {
                                                id: "plot_0",
                                                type: "line"
                                            },
                                            {
                                                id: "plot_1",
                                                type: "line"
                                            },
                                            {
                                                id: "plot_2",
                                                type: "line"
                                            },
                                            {
                                                id: "plot_3",
                                                palette: "palette_0",
                                                target: "plot_0",
                                                type: "colorer"
                                            }, 
                                        ],
                                        graphics: {},
                                        defaults: {
                                            styles: {
                                                plot_0: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 1,
                                                    plottype: 5,
                                                    trackPrice: false,
                                                    transparency: 0,
                                                    color: "#FF5252"
                                                },
                                                plot_1: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 1,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 0,
                                                    color: "#2196F3"
                                                },
                                                plot_2: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 1,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 0,
                                                    color: "#FF6D00"
                                                }
                                            },
                                            palettes: {
                                                palette_0: {
                                                    colors: {
                                                        0: {
                                                            color: "#22AB94",
                                                            width: 1,
                                                            style: 0
                                                        },
                                                        1: {
                                                            color: "#ACE5DC",
                                                            width: 1,
                                                            style: 0
                                                        },
                                                        2: {
                                                            color: "#FCCBCD",
                                                            width: 1,
                                                            style: 0
                                                        },
                                                        3: {
                                                            color: "#FF5252",
                                                            width: 1,
                                                            style: 0
                                                        }
                                                    }
                                                }
                                            },
                                            inputs: {
                                                in_0: 12,
                                                in_1: 26,
                                                in_3: "close",
                                                in_2: 9
                                            }
                                        },
                                        _metainfoVersion: 53,
                                        isTVScript: false,
                                        isTVScriptStub: false,
                                        is_hidden_study: false,
                                        styles: {
                                            plot_0: {
                                                title: "Histogram",
                                                histogramBase: 0,
                                                joinPoints: false
                                            },
                                            plot_1: {
                                                title: "MACD",
                                                histogramBase: 0,
                                                joinPoints: false
                                            },
                                            plot_2: {
                                                title: "Signal",
                                                histogramBase: 0,
                                                joinPoints: false
                                            }
                                        },
                                        description: "MACD",
                                        shortDescription: "MACD",
                                        is_price_study: false,
                                        id: "Moving Average Convergence/Divergence@tv-basicstudies-1",
                                        scriptIdPart: "",
                                        name: "MACD",
                                        format: {
                                            type: "inherit"
                                        },
                                        description_localized: "MACD",
                                        shortId: "Moving Average Convergence/Divergence",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Moving Average Convergence/Divergence@tv-basicstudies-1",
                                        productId: "tv-basicstudies",
                                        _serverMetaInfoVersion: 52
                                    }
                                }, 
                            ],
                            mainSourceId: "1hnSfV",
                            stretchFactor: 543.2406327462922,
                            leftAxisesState: [],
                            rightAxisesState: [
                                {
                                    state: {
                                        id: "S6NM5pHUafj7",
                                        m_priceRange: null,
                                        m_isAutoScale: true,
                                        m_isPercentage: false,
                                        m_isIndexedTo100: false,
                                        m_isLog: false,
                                        m_isLockScale: false,
                                        m_isInverted: false,
                                        m_topMargin: 0.17,
                                        m_bottomMargin: 0.15,
                                        alignLabels: true,
                                        logFormula: {
                                            logicalOffset: 4,
                                            coordOffset: 0.0001
                                        }
                                    },
                                    sources: [
                                        "1hnSfV"
                                    ]
                                }, 
                            ],
                            overlayPriceScales: {},
                            priceScaleRatio: null
                        },
                        {
                            sources: [
                                {
                                    type: "Study",
                                    id: "19Hbga",
                                    state: {
                                        styles: {
                                            plot_0: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 2,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 11,
                                                color: "#465ADB",
                                                title: "plot_0"
                                            },
                                            plot_1: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 2,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 11,
                                                color: "#A41919",
                                                title: "plot_1"
                                            },
                                            bands: {
                                                0: {
                                                    color: "rgba(152, 152, 152, 0.70)"
                                                },
                                                1: {
                                                    color: "rgba(152, 152, 152, 0.70)"
                                                }
                                            }
                                        },
                                        bands: {
                                            0: {
                                                color: "#787B86",
                                                linestyle: 2,
                                                linewidth: 1,
                                                visible: true,
                                                value: 80
                                            },
                                            1: {
                                                color: "#787B86",
                                                linestyle: 2,
                                                linewidth: 1,
                                                visible: true,
                                                value: 20
                                            }
                                        },
                                        filledAreasStyle: {
                                            fill_0: {
                                                color: "#2196F3",
                                                transparency: 90,
                                                visible: false
                                            }
                                        },
                                        inputs: {
                                            in_0: 15,
                                            in_1: 1,
                                            in_2: 3
                                        },
                                        precision: 1,
                                        graphics: {},
                                        ohlcPlots: {},
                                        palettes: {},
                                        filledAreas: {},
                                        visible: true,
                                        showLegendValues: true,
                                        showLabelsOnPriceScale: true,
                                        parentSources: {},
                                        intervalsVisibilities: {
                                            ticks: true,
                                            seconds: true,
                                            secondsFrom: 1,
                                            secondsTo: 59,
                                            minutes: true,
                                            minutesFrom: 1,
                                            minutesTo: 59,
                                            hours: true,
                                            hoursFrom: 1,
                                            hoursTo: 24,
                                            days: true,
                                            daysFrom: 1,
                                            daysTo: 366,
                                            weeks: true,
                                            weeksFrom: 1,
                                            weeksTo: 52,
                                            months: true,
                                            monthsFrom: 1,
                                            monthsTo: 12,
                                            ranges: true
                                        }
                                    },
                                    zorder: -10000,
                                    ownFirstValue: null,
                                    metaInfo: {
                                        palettes: {},
                                        inputs: [
                                            {
                                                id: "in_0",
                                                name: "K",
                                                defval: 14,
                                                type: "integer",
                                                min: 1,
                                                max: 10000,
                                                display: 15
                                            },
                                            {
                                                id: "in_1",
                                                name: "D",
                                                defval: 1,
                                                type: "integer",
                                                min: 1,
                                                max: 10000,
                                                display: 15
                                            },
                                            {
                                                id: "in_2",
                                                name: "smooth",
                                                defval: 3,
                                                type: "integer",
                                                min: 1,
                                                max: 10000,
                                                display: 15
                                            }, 
                                        ],
                                        plots: [
                                            {
                                                id: "plot_0",
                                                type: "line"
                                            },
                                            {
                                                id: "plot_1",
                                                type: "line"
                                            }, 
                                        ],
                                        graphics: {},
                                        defaults: {
                                            styles: {
                                                plot_0: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 1,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 0,
                                                    color: "#2196F3"
                                                },
                                                plot_1: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 1,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 0,
                                                    color: "#FF6D00"
                                                }
                                            },
                                            bands: [
                                                {
                                                    color: "#787B86",
                                                    linestyle: 2,
                                                    linewidth: 1,
                                                    visible: true,
                                                    value: 80
                                                },
                                                {
                                                    color: "#787B86",
                                                    linestyle: 2,
                                                    linewidth: 1,
                                                    visible: true,
                                                    value: 20
                                                }, 
                                            ],
                                            filledAreasStyle: {
                                                fill_0: {
                                                    color: "#2196F3",
                                                    transparency: 90,
                                                    visible: true
                                                }
                                            },
                                            inputs: {
                                                in_0: 14,
                                                in_1: 1,
                                                in_2: 3
                                            }
                                        },
                                        _metainfoVersion: 53,
                                        isTVScript: false,
                                        isTVScriptStub: false,
                                        is_hidden_study: false,
                                        styles: {
                                            plot_0: {
                                                title: "%K",
                                                histogramBase: 0,
                                                joinPoints: false,
                                                zorder: 1.1
                                            },
                                            plot_1: {
                                                title: "%D",
                                                histogramBase: 0,
                                                joinPoints: false,
                                                zorder: 1.11
                                            }
                                        },
                                        description: "Stochastic",
                                        shortDescription: "Stoch",
                                        is_price_study: false,
                                        bands: [
                                            {
                                                id: "hline_0",
                                                name: "UpperLimit",
                                                zorder: -1.1
                                            },
                                            {
                                                id: "hline_1",
                                                name: "LowerLimit",
                                                zorder: -1.11
                                            }, 
                                        ],
                                        filledAreas: [
                                            {
                                                id: "fill_0",
                                                objAId: "hline_0",
                                                objBId: "hline_1",
                                                type: "hline_hline",
                                                title: "Hlines Background",
                                                zorder: -2
                                            }, 
                                        ],
                                        id: "Stochastic@tv-basicstudies-1",
                                        scriptIdPart: "",
                                        name: "Stochastic",
                                        format: {
                                            precision: 2,
                                            type: "price"
                                        },
                                        usePlotsZOrder: true,
                                        description_localized: "Stochastic",
                                        shortId: "Stochastic",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Stochastic@tv-basicstudies-1",
                                        productId: "tv-basicstudies",
                                        _serverMetaInfoVersion: 52
                                    }
                                }, 
                            ],
                            mainSourceId: "19Hbga",
                            stretchFactor: 601.4492753623188,
                            leftAxisesState: [],
                            rightAxisesState: [
                                {
                                    state: {
                                        id: "Otfvntv5MuNa",
                                        m_priceRange: null,
                                        m_isAutoScale: true,
                                        m_isPercentage: false,
                                        m_isIndexedTo100: false,
                                        m_isLog: false,
                                        m_isLockScale: false,
                                        m_isInverted: false,
                                        m_topMargin: 0.17,
                                        m_bottomMargin: 0.15,
                                        alignLabels: true,
                                        logFormula: {
                                            logicalOffset: 4,
                                            coordOffset: 0.0001
                                        }
                                    },
                                    sources: [
                                        "19Hbga"
                                    ]
                                }, 
                            ],
                            overlayPriceScales: {},
                            priceScaleRatio: null
                        },
                        {
                            sources: [
                                {
                                    type: "Study",
                                    id: "xRlWww",
                                    state: {
                                        styles: {
                                            plot_0: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 2,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 11,
                                                color: "#1CBECB",
                                                title: "plot_0"
                                            },
                                            smoothedMA: {
                                                display: 0,
                                                linestyle: 0,
                                                linewidth: 1,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 0,
                                                color: "#0496ff",
                                                title: "smoothedMA"
                                            },
                                            bands: {
                                                0: {
                                                    color: "rgba(152, 152, 152, 0.70)"
                                                },
                                                1: {
                                                    color: "rgba(152, 152, 152, 0.70)"
                                                }
                                            }
                                        },
                                        bands: {
                                            0: {
                                                color: "#787B86",
                                                linestyle: 2,
                                                linewidth: 1,
                                                visible: true,
                                                value: 70,
                                                zorder: -1.1
                                            },
                                            1: {
                                                color: "#787B86",
                                                linestyle: 2,
                                                linewidth: 1,
                                                visible: true,
                                                value: 50,
                                                zorder: -1.11
                                            },
                                            2: {
                                                color: "#787B86",
                                                linestyle: 2,
                                                linewidth: 1,
                                                visible: true,
                                                value: 30,
                                                zorder: -1.111
                                            }
                                        },
                                        filledAreasStyle: {
                                            fill_0: {
                                                color: "#7E57C2",
                                                transparency: 90,
                                                visible: false
                                            }
                                        },
                                        inputs: {
                                            length: 14,
                                            smoothingLine: "SMA",
                                            smoothingLength: 14
                                        },
                                        precision: 1,
                                        graphics: {},
                                        ohlcPlots: {},
                                        palettes: {},
                                        filledAreas: {},
                                        visible: true,
                                        showLegendValues: true,
                                        showLabelsOnPriceScale: true,
                                        parentSources: {},
                                        intervalsVisibilities: {
                                            ticks: true,
                                            seconds: true,
                                            secondsFrom: 1,
                                            secondsTo: 59,
                                            minutes: true,
                                            minutesFrom: 1,
                                            minutesTo: 59,
                                            hours: true,
                                            hoursFrom: 1,
                                            hoursTo: 24,
                                            days: true,
                                            daysFrom: 1,
                                            daysTo: 366,
                                            weeks: true,
                                            weeksFrom: 1,
                                            weeksTo: 52,
                                            months: true,
                                            monthsFrom: 1,
                                            monthsTo: 12,
                                            ranges: true
                                        }
                                    },
                                    zorder: -10000,
                                    ownFirstValue: null,
                                    metaInfo: {
                                        palettes: {},
                                        inputs: [
                                            {
                                                id: "length",
                                                name: "Length",
                                                defval: 14,
                                                type: "integer",
                                                min: 1,
                                                max: 2000,
                                                display: 15
                                            },
                                            {
                                                id: "smoothingLine",
                                                name: "Smoothing Line",
                                                defval: "SMA",
                                                type: "text",
                                                options: [
                                                    "SMA",
                                                    "EMA",
                                                    "WMA"
                                                ],
                                                display: 15
                                            },
                                            {
                                                id: "smoothingLength",
                                                name: "Smoothing Length",
                                                defval: 14,
                                                type: "integer",
                                                min: 1,
                                                max: 10000,
                                                display: 15
                                            }, 
                                        ],
                                        plots: [
                                            {
                                                id: "plot_0",
                                                type: "line"
                                            },
                                            {
                                                id: "smoothedMA",
                                                type: "line"
                                            }, 
                                        ],
                                        graphics: {},
                                        defaults: {
                                            styles: {
                                                plot_0: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 1,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 0,
                                                    color: "#7E57C2"
                                                },
                                                smoothedMA: {
                                                    display: 0,
                                                    linestyle: 0,
                                                    linewidth: 1,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 0
                                                }
                                            },
                                            bands: [
                                                {
                                                    color: "#787B86",
                                                    linestyle: 2,
                                                    linewidth: 1,
                                                    visible: true,
                                                    value: 70,
                                                    zorder: -1.1
                                                },
                                                {
                                                    color: "#787B86",
                                                    linestyle: 2,
                                                    linewidth: 1,
                                                    visible: true,
                                                    value: 50,
                                                    zorder: -1.11
                                                },
                                                {
                                                    color: "#787B86",
                                                    linestyle: 2,
                                                    linewidth: 1,
                                                    visible: true,
                                                    value: 30,
                                                    zorder: -1.111
                                                }, 
                                            ],
                                            filledAreasStyle: {
                                                fill_0: {
                                                    color: "#7E57C2",
                                                    transparency: 90,
                                                    visible: true
                                                }
                                            },
                                            inputs: {
                                                length: 14,
                                                smoothingLine: "SMA",
                                                smoothingLength: 14
                                            }
                                        },
                                        _metainfoVersion: 53,
                                        isTVScript: false,
                                        isTVScriptStub: false,
                                        is_hidden_study: false,
                                        styles: {
                                            plot_0: {
                                                title: "Plot",
                                                histogramBase: 0,
                                                joinPoints: false,
                                                zorder: 1
                                            },
                                            smoothedMA: {
                                                title: "Smoothed MA",
                                                histogramBase: 0,
                                                joinPoints: false,
                                                zorder: 2
                                            },
                                            "Relative Strength Index@tv-basicstudies": {
                                                title: "Smoothed MA",
                                                histogramBase: 0,
                                                joinPoints: false
                                            }
                                        },
                                        description: "Relative Strength Index",
                                        shortDescription: "RSI",
                                        is_price_study: false,
                                        bands: [
                                            {
                                                id: "hline_0",
                                                name: "UpperLimit",
                                                zorder: -1.1
                                            },
                                            {
                                                id: "hline_2",
                                                name: "MiddleLimit",
                                                zorder: -1.11
                                            },
                                            {
                                                id: "hline_1",
                                                name: "LowerLimit",
                                                zorder: -1.111
                                            }, 
                                        ],
                                        filledAreas: [
                                            {
                                                id: "fill_0",
                                                objAId: "hline_0",
                                                objBId: "hline_1",
                                                type: "hline_hline",
                                                title: "Hlines Background",
                                                zorder: -2
                                            }, 
                                        ],
                                        id: "Relative Strength Index@tv-basicstudies-1",
                                        scriptIdPart: "",
                                        name: "Relative Strength Index",
                                        format: {
                                            precision: 2,
                                            type: "price"
                                        },
                                        usePlotsZOrder: true,
                                        description_localized: "Relative Strength Index",
                                        shortId: "Relative Strength Index",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Relative Strength Index@tv-basicstudies-1",
                                        productId: "tv-basicstudies",
                                        _serverMetaInfoVersion: 52
                                    }
                                }, 
                            ],
                            mainSourceId: "xRlWww",
                            stretchFactor: 608.695652173913,
                            leftAxisesState: [],
                            rightAxisesState: [
                                {
                                    state: {
                                        id: "h7jqfpa3lHVy",
                                        m_priceRange: null,
                                        m_isAutoScale: true,
                                        m_isPercentage: false,
                                        m_isIndexedTo100: false,
                                        m_isLog: false,
                                        m_isLockScale: false,
                                        m_isInverted: false,
                                        m_topMargin: 0.17,
                                        m_bottomMargin: 0.15,
                                        alignLabels: true,
                                        logFormula: {
                                            logicalOffset: 4,
                                            coordOffset: 0.0001
                                        }
                                    },
                                    sources: [
                                        "xRlWww"
                                    ]
                                }, 
                            ],
                            overlayPriceScales: {},
                            priceScaleRatio: null
                        }, 
                    ],
                    timeScale: {
                        m_barSpacing: 5.869312088008223,
                        m_rightOffset: 35,
                        rightOffsetPercentage: 5,
                        usePercentageRightOffset: false
                    },
                    chartProperties: {
                        paneProperties: {
                            backgroundType: "solid",
                            background: "#ffffff",
                            backgroundGradientStartColor: "#ffffff",
                            backgroundGradientEndColor: "#ffffff",
                            gridLinesMode: "both",
                            vertGridProperties: {
                                color: "rgba(237, 237, 237, 0.3)"
                            },
                            horzGridProperties: {
                                color: "rgba(237, 237, 237, 0.3)"
                            },
                            crossHairProperties: {
                                color: "#9598A1",
                                style: 2,
                                transparency: 0,
                                width: 1,
                                "color:": "#9598A1"
                            },
                            topMargin: 17,
                            bottomMargin: 15,
                            axisProperties: {
                                autoScale: true,
                                autoScaleDisabled: false,
                                lockScale: false,
                                percentage: false,
                                percentageDisabled: false,
                                indexedTo100: false,
                                log: false,
                                logDisabled: false,
                                alignLabels: true,
                                isInverted: false
                            },
                            legendProperties: {
                                showStudyArguments: true,
                                showStudyTitles: true,
                                showStudyValues: false,
                                showSeriesTitle: true,
                                showSeriesOHLC: true,
                                showLegend: true,
                                showBarChange: true,
                                showVolume: false,
                                showBackground: true,
                                showPriceSource: true,
                                backgroundTransparency: 50,
                                showLogo: true,
                                wrapText: false,
                                showOnlyPriceSource: true
                            },
                            separatorColor: "#E0E3EB",
                            gridProperties: {
                                color: "#e1ecf2",
                                style: 0
                            },
                            leftAxisProperties: {
                                autoScale: true,
                                autoScaleDisabled: false,
                                lockScale: false,
                                percentage: false,
                                percentageDisabled: false,
                                indexedTo100: false,
                                log: false,
                                logDisabled: false,
                                alignLabels: true
                            },
                            rightAxisProperties: {
                                autoScale: true,
                                autoScaleDisabled: false,
                                lockScale: false,
                                percentage: false,
                                percentageDisabled: false,
                                log: false,
                                logDisabled: false,
                                alignLabels: true,
                                indexedTo100: false
                            },
                            rightOffset: null
                        },
                        scalesProperties: {
                            backgroundColor: "#ffffff",
                            lineColor: "rgba(42, 46, 57, 0)",
                            textColor: "#131722",
                            fontSize: 12,
                            scaleSeriesOnly: false,
                            showSeriesLastValue: true,
                            seriesLastValueMode: 1,
                            showSeriesPrevCloseValue: false,
                            showStudyLastValue: true,
                            showSymbolLabels: false,
                            showStudyPlotLabels: false,
                            showBidAskLabels: false,
                            showPrePostMarketPriceLabel: true,
                            showFundamentalNameLabel: false,
                            showFundamentalLastValue: true,
                            barSpacing: 6,
                            axisHighlightColor: "rgba(41, 98, 255, 0.25)",
                            axisLineToolLabelBackgroundColorCommon: "#2962FF",
                            axisLineToolLabelBackgroundColorActive: "#143EB3",
                            showPriceScaleCrosshairLabel: true,
                            showTimeScaleCrosshairLabel: true,
                            crosshairLabelBgColorLight: "#131722",
                            crosshairLabelBgColorDark: "#363A45",
                            showCurrency: true,
                            showUnit: true,
                            showLeftScale: false,
                            showRightScale: true
                        },
                        chartEventsSourceProperties: {
                            visible: true,
                            futureOnly: true,
                            breaks: {
                                color: "rgba(85, 85, 85, 1)",
                                visible: false,
                                style: 2,
                                width: 1
                            }
                        },
                        tradingProperties: {
                            showPositions: true,
                            positionPL: {
                                visibility: true,
                                display: 2
                            },
                            bracketsPL: {
                                visibility: true,
                                display: 0
                            },
                            showOrders: true,
                            showExecutions: true,
                            showExecutionsLabels: false,
                            showReverse: true,
                            horizontalAlignment: 2,
                            extendLeft: true,
                            lineLength: 5,
                            lineWidth: 1,
                            lineStyle: 0
                        },
                        priceScaleSelectionStrategyName: "auto"
                    },
                    sessions: {
                        properties: {
                            graphics: {
                                backgrounds: {
                                    outOfSession: {
                                        color: "#2962FF",
                                        transparency: 92,
                                        visible: false
                                    },
                                    preMarket: {
                                        color: "#FF9800",
                                        transparency: 92,
                                        visible: false
                                    },
                                    postMarket: {
                                        color: "#2962FF",
                                        transparency: 92,
                                        visible: false
                                    }
                                },
                                vertlines: {
                                    sessBreaks: {
                                        color: "#4985e7",
                                        style: 2,
                                        visible: false,
                                        width: 1
                                    }
                                }
                            }
                        }
                    },
                    version: 3,
                    timezone: "Asia/Jakarta",
                    shouldBeSavedEvenIfHidden: true,
                    linkingGroup: null,
                    lineToolsGroups: {
                        groups: []
                    },
                    chartId: "1",
                    theme: "light"
                }, 
            ],
            symbolLock: 0,
            intervalLock: 0,
            trackTimeLock: 0,
            dateRangeLock: 0,
            crosshairLock: 1,
            layoutsSizes: {
                s: [
                    {
                        percent: 1
                    }
                ]
            }
        }
    },
    {
        key: "foreign_flow",
        name: "Foreign Flow",
        template: {
            layout: "s",
            charts: [
                {
                    panes: [
                        {
                            sources: [
                                {
                                    type: "MainSeries",
                                    id: "_seriesId",
                                    zorder: 0,
                                    haStyle: {
                                        studyId: "BarSetHeikenAshi@tv-basicstudies-60"
                                    },
                                    renkoStyle: {
                                        studyId: "BarSetRenko@tv-prostudies-64"
                                    },
                                    pbStyle: {
                                        studyId: "BarSetPriceBreak@tv-prostudies-34"
                                    },
                                    kagiStyle: {
                                        studyId: "BarSetKagi@tv-prostudies-34"
                                    },
                                    pnfStyle: {
                                        studyId: "BarSetPnF@tv-prostudies-34"
                                    },
                                    rangeStyle: {
                                        studyId: "BarSetRange@tv-basicstudies-72"
                                    },
                                    formattingDeps: {
                                        format: "price",
                                        pricescale: 1,
                                        minmov: 1
                                    },
                                    state: {
                                        style: 1,
                                        esdShowDividends: true,
                                        esdShowSplits: true,
                                        esdShowEarnings: true,
                                        esdShowBreaks: false,
                                        esdFlagSize: 2,
                                        showContinuousContractSwitches: true,
                                        showContinuousContractSwitchesBreaks: false,
                                        showFuturesContractExpiration: true,
                                        showLastNews: true,
                                        showCountdown: false,
                                        bidAsk: {
                                            visible: false,
                                            lineStyle: 1,
                                            lineWidth: 1,
                                            bidLineColor: "#2962FF",
                                            askLineColor: "#F7525F"
                                        },
                                        prePostMarket: {
                                            visible: true,
                                            lineStyle: 1,
                                            lineWidth: 1,
                                            preMarketColor: "#FB8C00",
                                            postMarketColor: "#2962FF"
                                        },
                                        highLowAvgPrice: {
                                            highLowPriceLinesVisible: false,
                                            highLowPriceLabelsVisible: false,
                                            averageClosePriceLineVisible: false,
                                            averageClosePriceLabelVisible: false,
                                            highLowPriceLinesColor: "",
                                            highLowPriceLinesWidth: 1,
                                            averagePriceLineColor: "",
                                            averagePriceLineWidth: 1
                                        },
                                        visible: true,
                                        showPriceLine: true,
                                        priceLineWidth: 1,
                                        priceLineColor: "",
                                        baseLineColor: "#B2B5BE",
                                        showPrevClosePriceLine: false,
                                        prevClosePriceLineWidth: 1,
                                        prevClosePriceLineColor: "#555555",
                                        minTick: "default",
                                        dividendsAdjustment: null,
                                        backAdjustment: false,
                                        settlementAsClose: true,
                                        sessionId: "regular",
                                        sessVis: false,
                                        statusViewStyle: {
                                            fontSize: 16,
                                            showExchange: true,
                                            showInterval: true,
                                            symbolTextSource: "description",
                                            showSymbolAsDescription: false
                                        },
                                        candleStyle: {
                                            upColor: "#00AB6B",
                                            downColor: "#EE4A49",
                                            drawWick: true,
                                            drawBorder: true,
                                            borderColor: "#00AB6B",
                                            borderUpColor: "#00AB6B",
                                            borderDownColor: "#EE4A49",
                                            wickColor: "#737375",
                                            wickUpColor: "#00AB6B",
                                            wickDownColor: "#EE4A49",
                                            barColorsOnPrevClose: false,
                                            drawBody: true
                                        },
                                        hollowCandleStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            drawWick: true,
                                            drawBorder: true,
                                            borderColor: "#378658",
                                            borderUpColor: "#089981",
                                            borderDownColor: "#F23645",
                                            wickColor: "#737375",
                                            wickUpColor: "#089981",
                                            wickDownColor: "#F23645",
                                            drawBody: true
                                        },
                                        haStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            drawWick: true,
                                            drawBorder: true,
                                            borderColor: "#378658",
                                            borderUpColor: "#089981",
                                            borderDownColor: "#F23645",
                                            wickColor: "#737375",
                                            wickUpColor: "#089981",
                                            wickDownColor: "#F23645",
                                            showRealLastPrice: false,
                                            barColorsOnPrevClose: false,
                                            inputs: {},
                                            inputInfo: {},
                                            drawBody: true
                                        },
                                        barStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            barColorsOnPrevClose: false,
                                            dontDrawOpen: false,
                                            thinBars: true
                                        },
                                        hiloStyle: {
                                            color: "#2962FF",
                                            showBorders: true,
                                            borderColor: "#2962FF",
                                            showLabels: true,
                                            labelColor: "#2962FF",
                                            drawBody: true,
                                            fontSize: 7
                                        },
                                        columnStyle: {
                                            upColor: "rgba(8, 153, 129, 0.5)",
                                            downColor: "rgba(242, 54, 69, 0.5)",
                                            barColorsOnPrevClose: true,
                                            priceSource: "close"
                                        },
                                        lineStyle: {
                                            color: "#2962FF",
                                            linestyle: 0,
                                            linewidth: 2,
                                            priceSource: "close"
                                        },
                                        lineWithMarkersStyle: {
                                            color: "#2962FF",
                                            linestyle: 0,
                                            linewidth: 2,
                                            priceSource: "close"
                                        },
                                        steplineStyle: {
                                            color: "#2962FF",
                                            linestyle: 0,
                                            linewidth: 2,
                                            priceSource: "close"
                                        },
                                        areaStyle: {
                                            color1: "rgba(41, 98, 255, 0.28)",
                                            color2: "#2962FF",
                                            linecolor: "#2962FF",
                                            linestyle: 0,
                                            linewidth: 1,
                                            priceSource: "close",
                                            transparency: 100
                                        },
                                        hlcAreaStyle: {
                                            highLineColor: "#089981",
                                            highLineStyle: 0,
                                            highLineWidth: 2,
                                            lowLineColor: "#F23645",
                                            lowLineStyle: 0,
                                            lowLineWidth: 2,
                                            closeLineColor: "#868993",
                                            closeLineStyle: 0,
                                            closeLineWidth: 2,
                                            highCloseFillColor: "rgba(8, 153, 129, 0.2)",
                                            closeLowFillColor: "rgba(242, 54, 69, 0.2)"
                                        },
                                        renkoStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            borderUpColor: "#089981",
                                            borderDownColor: "#F23645",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            borderUpColorProjection: "#a9dcc3",
                                            borderDownColorProjection: "#f5a6ae",
                                            wickUpColor: "#089981",
                                            wickDownColor: "#F23645",
                                            inputs: {
                                                source: "close",
                                                sources: "Close",
                                                boxSize: 3,
                                                style: "ATR",
                                                atrLength: 14,
                                                wicks: true
                                            },
                                            inputInfo: {
                                                source: {
                                                    name: "Source"
                                                },
                                                sources: {
                                                    name: "Source"
                                                },
                                                boxSize: {
                                                    name: "Box size"
                                                },
                                                style: {
                                                    name: "Style"
                                                },
                                                atrLength: {
                                                    name: "ATR length"
                                                },
                                                wicks: {
                                                    name: "Wicks"
                                                }
                                            }
                                        },
                                        pbStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            borderUpColor: "#089981",
                                            borderDownColor: "#F23645",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            borderUpColorProjection: "#a9dcc3",
                                            borderDownColorProjection: "#f5a6ae",
                                            inputs: {
                                                source: "close",
                                                lb: 3
                                            },
                                            inputInfo: {
                                                source: {
                                                    name: "Source"
                                                },
                                                lb: {
                                                    name: "Number of line"
                                                }
                                            }
                                        },
                                        kagiStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            inputs: {
                                                source: "close",
                                                style: "ATR",
                                                atrLength: 14,
                                                reversalAmount: 1
                                            },
                                            inputInfo: {
                                                source: {
                                                    name: "Source"
                                                },
                                                style: {
                                                    name: "Style"
                                                },
                                                atrLength: {
                                                    name: "ATR length"
                                                },
                                                reversalAmount: {
                                                    name: "Reversal amount"
                                                }
                                            }
                                        },
                                        pnfStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            inputs: {
                                                sources: "Close",
                                                reversalAmount: 3,
                                                boxSize: 1,
                                                style: "ATR",
                                                atrLength: 14,
                                                oneStepBackBuilding: false
                                            },
                                            inputInfo: {
                                                sources: {
                                                    name: "Source"
                                                },
                                                boxSize: {
                                                    name: "Box size"
                                                },
                                                reversalAmount: {
                                                    name: "Reversal amount"
                                                },
                                                style: {
                                                    name: "Style"
                                                },
                                                atrLength: {
                                                    name: "ATR length"
                                                },
                                                oneStepBackBuilding: {
                                                    name: "One step back building"
                                                }
                                            }
                                        },
                                        baselineStyle: {
                                            baselineColor: "#758696",
                                            topFillColor1: "rgba(8, 153, 129, 0.28)",
                                            topFillColor2: "rgba(8, 153, 129, 0.05)",
                                            bottomFillColor1: "rgba(242, 54, 69, 0.05)",
                                            bottomFillColor2: "rgba(242, 54, 69, 0.28)",
                                            topLineColor: "#089981",
                                            bottomLineColor: "#F23645",
                                            topLineWidth: 1,
                                            bottomLineWidth: 1,
                                            priceSource: "close",
                                            transparency: 50,
                                            baseLevelPercentage: 50
                                        },
                                        rangeStyle: {
                                            barStyle: 0,
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            thinBars: true,
                                            candlesUpColor: "#089981",
                                            candlesDownColor: "#F23645",
                                            candlesBorderUpColor: "#089981",
                                            candlesBorderDownColor: "#F23645",
                                            candlesWickUpColor: "#089981",
                                            candlesWickDownColor: "#F23645",
                                            inputs: {
                                                range: 10,
                                                phantomBars: false
                                            },
                                            inputInfo: {
                                                range: {
                                                    name: "Range"
                                                },
                                                phantomBars: {
                                                    name: "Phantom bars"
                                                }
                                            }
                                        },
                                        showInDataWindow: true,
                                        symbol: "BBCA",
                                        shortName: "BBCA",
                                        timeframe: "",
                                        onWidget: false,
                                        interval: "D",
                                        unitId: null,
                                        showSessions: false,
                                        shortname: "",
                                        currencyId: null,
                                        priceAxisProperties: {
                                            autoScale: true,
                                            autoScaleDisabled: false,
                                            lockScale: false,
                                            percentage: false,
                                            percentageDisabled: false,
                                            log: false,
                                            logDisabled: false,
                                            alignLabels: true,
                                            isInverted: false,
                                            indexedTo100: false
                                        }
                                    }
                                },
                                {
                                    type: "Study",
                                    id: "z5XxkQ",
                                    state: {
                                        styles: {
                                            plot_0: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 2,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 11,
                                                color: "#5F72EC",
                                                title: "plot_0"
                                            }
                                        },
                                        precision: "default",
                                        inputs: {},
                                        bands: {},
                                        graphics: {},
                                        ohlcPlots: {},
                                        palettes: {},
                                        filledAreasStyle: {},
                                        filledAreas: {},
                                        visible: true,
                                        showLegendValues: true,
                                        showLabelsOnPriceScale: true,
                                        parentSources: {},
                                        intervalsVisibilities: {
                                            ticks: true,
                                            seconds: true,
                                            secondsFrom: 1,
                                            secondsTo: 59,
                                            minutes: true,
                                            minutesFrom: 1,
                                            minutesTo: 59,
                                            hours: true,
                                            hoursFrom: 1,
                                            hoursTo: 24,
                                            days: true,
                                            daysFrom: 1,
                                            daysTo: 366,
                                            weeks: true,
                                            weeksFrom: 1,
                                            weeksTo: 52,
                                            months: true,
                                            monthsFrom: 1,
                                            monthsTo: 12,
                                            ranges: true
                                        }
                                    },
                                    zorder: -10000,
                                    ownFirstValue: null,
                                    metaInfo: {
                                        palettes: {},
                                        inputs: [],
                                        plots: [
                                            {
                                                id: "plot_0",
                                                type: "line"
                                            }
                                        ],
                                        graphics: {},
                                        defaults: {
                                            styles: {
                                                plot_0: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 2,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 11,
                                                    color: "#5F72EC"
                                                }
                                            },
                                            precision: 0,
                                            inputs: {}
                                        },
                                        _metainfoVersion: 53,
                                        id: "Foreign Flow Underlay@tv-basicstudies-1",
                                        name: "Foreign Flow Underlay",
                                        description: "Foreign Flow Underlay",
                                        shortDescription: "Foreign Flow Underlay",
                                        is_hidden_study: false,
                                        is_price_study: true,
                                        isCustomIndicator: true,
                                        format: {
                                            type: "volume",
                                            precision: 3
                                        },
                                        styles: {
                                            plot_0: {
                                                title: "Foreign Flow Underlay value",
                                                histogramBase: 0
                                            }
                                        },
                                        description_localized: "Foreign Flow Underlay",
                                        shortId: "Foreign Flow Underlay",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Foreign Flow Underlay@tv-basicstudies-1",
                                        productId: "tv-basicstudies",
                                        _serverMetaInfoVersion: 51
                                    }
                                }, 
                            ],
                            mainSourceId: "_seriesId",
                            stretchFactor: 3084.82420537963,
                            leftAxisesState: [],
                            rightAxisesState: [
                                {
                                    state: {
                                        id: "WZB8dP50LJ7p",
                                        m_priceRange: null,
                                        m_isAutoScale: true,
                                        m_isPercentage: false,
                                        m_isIndexedTo100: false,
                                        m_isLog: false,
                                        m_isLockScale: false,
                                        m_isInverted: false,
                                        m_topMargin: 0.17,
                                        m_bottomMargin: 0.15,
                                        alignLabels: true,
                                        logFormula: {
                                            logicalOffset: 4,
                                            coordOffset: 0.0001
                                        }
                                    },
                                    sources: [
                                        "_seriesId"
                                    ]
                                }, 
                            ],
                            overlayPriceScales: {
                                z5XxkQ: {
                                    id: "duRWXItYdRlD",
                                    m_priceRange: null,
                                    m_isAutoScale: true,
                                    m_isPercentage: false,
                                    m_isIndexedTo100: false,
                                    m_isLog: false,
                                    m_isLockScale: false,
                                    m_isInverted: false,
                                    m_topMargin: 0.17,
                                    m_bottomMargin: 0.15,
                                    alignLabels: true,
                                    logFormula: {
                                        logicalOffset: 4,
                                        coordOffset: 0.0001
                                    }
                                }
                            },
                            priceScaleRatio: null
                        },
                        {
                            sources: [
                                {
                                    type: "Study",
                                    id: "1wSsej",
                                    state: {
                                        styles: {
                                            vol: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 1,
                                                plottype: 5,
                                                trackPrice: false,
                                                transparency: 0,
                                                color: "#000080",
                                                title: "vol"
                                            },
                                            vol_ma: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 2,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 30,
                                                color: "#0496ff",
                                                title: "vol_ma"
                                            }
                                        },
                                        precision: "default",
                                        palettes: {
                                            volumePalette: {
                                                colors: {
                                                    0: {
                                                        color: "rgba(235, 77, 92, 0.50)",
                                                        width: 1,
                                                        style: 0
                                                    },
                                                    1: {
                                                        color: "rgba(83, 185, 135, 0.50)",
                                                        width: 1,
                                                        style: 0
                                                    }
                                                }
                                            }
                                        },
                                        inputs: {
                                            showMA: true,
                                            maLength: 20
                                        },
                                        bands: {},
                                        graphics: {},
                                        ohlcPlots: {},
                                        filledAreasStyle: {},
                                        filledAreas: {},
                                        visible: true,
                                        showLegendValues: true,
                                        showLabelsOnPriceScale: true,
                                        parentSources: {},
                                        intervalsVisibilities: {
                                            ticks: true,
                                            seconds: true,
                                            secondsFrom: 1,
                                            secondsTo: 59,
                                            minutes: true,
                                            minutesFrom: 1,
                                            minutesTo: 59,
                                            hours: true,
                                            hoursFrom: 1,
                                            hoursTo: 24,
                                            days: true,
                                            daysFrom: 1,
                                            daysTo: 366,
                                            weeks: true,
                                            weeksFrom: 1,
                                            weeksTo: 52,
                                            months: true,
                                            monthsFrom: 1,
                                            monthsTo: 12,
                                            ranges: true
                                        }
                                    },
                                    zorder: -10000,
                                    ownFirstValue: null,
                                    metaInfo: {
                                        palettes: {
                                            volumePalette: {
                                                colors: [
                                                    {
                                                        name: "Falling"
                                                    },
                                                    {
                                                        name: "Growing"
                                                    }
                                                ]
                                            }
                                        },
                                        inputs: [
                                            {
                                                id: "showMA",
                                                name: "show MA",
                                                defval: true,
                                                type: "bool",
                                                display: 0
                                            },
                                            {
                                                id: "maLength",
                                                name: "MA Length",
                                                defval: 20,
                                                type: "integer",
                                                min: 1,
                                                max: 2000,
                                                display: 15
                                            }, 
                                        ],
                                        plots: [
                                            {
                                                id: "vol",
                                                type: "line"
                                            },
                                            {
                                                id: "volumePalette",
                                                palette: "volumePalette",
                                                target: "vol",
                                                type: "colorer"
                                            },
                                            {
                                                id: "vol_ma",
                                                type: "line"
                                            }, 
                                        ],
                                        graphics: {},
                                        defaults: {
                                            styles: {
                                                vol: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 1,
                                                    plottype: 5,
                                                    trackPrice: false,
                                                    transparency: 0,
                                                    color: "#000080"
                                                },
                                                vol_ma: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 2,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 30,
                                                    color: "#0496FF"
                                                }
                                            },
                                            precision: 0,
                                            palettes: {
                                                volumePalette: {
                                                    colors: {
                                                        0: {
                                                            color: "rgba(235, 77, 92, 0.50)",
                                                            width: 1,
                                                            style: 0
                                                        },
                                                        1: {
                                                            color: "rgba(83, 185, 135, 0.50)",
                                                            width: 1,
                                                            style: 0
                                                        }
                                                    }
                                                }
                                            },
                                            inputs: {
                                                showMA: true,
                                                maLength: 20
                                            }
                                        },
                                        _metainfoVersion: 53,
                                        id: "Volume_@tv-basicstudies-1",
                                        is_hidden_study: false,
                                        description: "Volume_",
                                        shortDescription: "Volume",
                                        is_price_study: false,
                                        format: {
                                            type: "volume",
                                            precision: 3
                                        },
                                        styles: {
                                            vol: {
                                                title: "Volume_",
                                                histogramBase: 0
                                            },
                                            vol_ma: {
                                                title: "Volume MA",
                                                histogramBase: 0
                                            }
                                        },
                                        description_localized: "Volume_",
                                        shortId: "Volume_",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Volume_@tv-basicstudies-1",
                                        productId: "tv-basicstudies",
                                        _serverMetaInfoVersion: 51
                                    }
                                }, 
                            ],
                            mainSourceId: "1wSsej",
                            stretchFactor: 761.6340921567289,
                            leftAxisesState: [],
                            rightAxisesState: [
                                {
                                    state: {
                                        id: "u9NUxWMF044v",
                                        m_priceRange: null,
                                        m_isAutoScale: true,
                                        m_isPercentage: false,
                                        m_isIndexedTo100: false,
                                        m_isLog: false,
                                        m_isLockScale: false,
                                        m_isInverted: false,
                                        m_topMargin: 0.17,
                                        m_bottomMargin: 0.15,
                                        alignLabels: true,
                                        logFormula: {
                                            logicalOffset: 4,
                                            coordOffset: 0.0001
                                        }
                                    },
                                    sources: [
                                        "1wSsej"
                                    ]
                                }, 
                            ],
                            overlayPriceScales: {},
                            priceScaleRatio: null
                        },
                        {
                            sources: [
                                {
                                    type: "Study",
                                    id: "HJwr9F",
                                    state: {
                                        styles: {
                                            plot_0: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 2,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 11,
                                                color: "#BE5FEC",
                                                title: "plot_0"
                                            }
                                        },
                                        precision: "default",
                                        inputs: {},
                                        bands: {},
                                        graphics: {},
                                        ohlcPlots: {},
                                        palettes: {},
                                        filledAreasStyle: {},
                                        filledAreas: {},
                                        visible: true,
                                        showLegendValues: true,
                                        showLabelsOnPriceScale: true,
                                        parentSources: {},
                                        intervalsVisibilities: {
                                            ticks: true,
                                            seconds: true,
                                            secondsFrom: 1,
                                            secondsTo: 59,
                                            minutes: true,
                                            minutesFrom: 1,
                                            minutesTo: 59,
                                            hours: true,
                                            hoursFrom: 1,
                                            hoursTo: 24,
                                            days: true,
                                            daysFrom: 1,
                                            daysTo: 366,
                                            weeks: true,
                                            weeksFrom: 1,
                                            weeksTo: 52,
                                            months: true,
                                            monthsFrom: 1,
                                            monthsTo: 12,
                                            ranges: true
                                        }
                                    },
                                    zorder: -10000,
                                    ownFirstValue: null,
                                    metaInfo: {
                                        palettes: {},
                                        inputs: [],
                                        plots: [
                                            {
                                                id: "plot_0",
                                                type: "line"
                                            }
                                        ],
                                        graphics: {},
                                        defaults: {
                                            styles: {
                                                plot_0: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 2,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 11,
                                                    color: "#BE5FEC"
                                                }
                                            },
                                            precision: 0,
                                            inputs: {}
                                        },
                                        _metainfoVersion: 53,
                                        id: "Foreign Flow@tv-basicstudies-1",
                                        name: "Foreign Flow",
                                        description: "Foreign Flow",
                                        shortDescription: "Foreign Flow",
                                        is_hidden_study: false,
                                        is_price_study: false,
                                        isCustomIndicator: true,
                                        format: {
                                            type: "volume",
                                            precision: 3
                                        },
                                        styles: {
                                            plot_0: {
                                                title: "Foreign Flow value",
                                                histogramBase: 0
                                            }
                                        },
                                        description_localized: "Foreign Flow",
                                        shortId: "Foreign Flow",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Foreign Flow@tv-basicstudies-1",
                                        productId: "tv-basicstudies",
                                        _serverMetaInfoVersion: 51
                                    }
                                }, 
                            ],
                            mainSourceId: "HJwr9F",
                            stretchFactor: 624.0973825912547,
                            leftAxisesState: [],
                            rightAxisesState: [
                                {
                                    state: {
                                        id: "SGv9ypZYDeGF",
                                        m_priceRange: null,
                                        m_isAutoScale: true,
                                        m_isPercentage: false,
                                        m_isIndexedTo100: false,
                                        m_isLog: false,
                                        m_isLockScale: false,
                                        m_isInverted: false,
                                        m_topMargin: 0.17,
                                        m_bottomMargin: 0.15,
                                        alignLabels: true,
                                        logFormula: {
                                            logicalOffset: 4,
                                            coordOffset: 0.0001
                                        }
                                    },
                                    sources: [
                                        "HJwr9F"
                                    ]
                                }, 
                            ],
                            overlayPriceScales: {},
                            priceScaleRatio: null
                        },
                        {
                            sources: [
                                {
                                    type: "Study",
                                    id: "sEAGzL",
                                    state: {
                                        palettes: {
                                            palette_0: {
                                                colors: {
                                                    0: {
                                                        color: "#B80E0C",
                                                        width: 5,
                                                        style: 0
                                                    },
                                                    1: {
                                                        color: "#009900",
                                                        width: 5,
                                                        style: 0
                                                    }
                                                }
                                            }
                                        },
                                        styles: {
                                            plot_0: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 5,
                                                plottype: 5,
                                                trackPrice: false,
                                                transparency: 30,
                                                color: "#009900",
                                                title: "plot_0"
                                            }
                                        },
                                        precision: "default",
                                        inputs: {},
                                        bands: {},
                                        graphics: {},
                                        ohlcPlots: {},
                                        filledAreasStyle: {},
                                        filledAreas: {},
                                        visible: true,
                                        showLegendValues: true,
                                        showLabelsOnPriceScale: true,
                                        parentSources: {},
                                        intervalsVisibilities: {
                                            ticks: true,
                                            seconds: true,
                                            secondsFrom: 1,
                                            secondsTo: 59,
                                            minutes: true,
                                            minutesFrom: 1,
                                            minutesTo: 59,
                                            hours: true,
                                            hoursFrom: 1,
                                            hoursTo: 24,
                                            days: true,
                                            daysFrom: 1,
                                            daysTo: 366,
                                            weeks: true,
                                            weeksFrom: 1,
                                            weeksTo: 52,
                                            months: true,
                                            monthsFrom: 1,
                                            monthsTo: 12,
                                            ranges: true
                                        }
                                    },
                                    zorder: -10000,
                                    ownFirstValue: null,
                                    metaInfo: {
                                        palettes: {
                                            palette_0: {
                                                colors: [
                                                    {
                                                        name: "Color 0"
                                                    },
                                                    {
                                                        name: "Color 1"
                                                    }
                                                ]
                                            }
                                        },
                                        inputs: [],
                                        plots: [
                                            {
                                                id: "plot_0",
                                                type: "line"
                                            },
                                            {
                                                id: "plot_1",
                                                palette: "palette_0",
                                                target: "plot_0",
                                                type: "colorer"
                                            }, 
                                        ],
                                        graphics: {},
                                        defaults: {
                                            palettes: {
                                                palette_0: {
                                                    colors: [
                                                        {
                                                            color: "#B80E0C",
                                                            width: 5,
                                                            style: 0
                                                        },
                                                        {
                                                            color: "#009900",
                                                            width: 5,
                                                            style: 0
                                                        }, 
                                                    ]
                                                }
                                            },
                                            styles: {
                                                plot_0: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 5,
                                                    plottype: 5,
                                                    trackPrice: false,
                                                    transparency: 30,
                                                    color: "#009900"
                                                }
                                            },
                                            precision: 0,
                                            inputs: {}
                                        },
                                        _metainfoVersion: 53,
                                        id: "Net Foreign Buy / Sell@tv-basicstudies-12",
                                        name: "Net Foreign Buy / Sell",
                                        description: "Net Foreign Buy / Sell",
                                        shortDescription: "Net Foreign Buy / Sell",
                                        is_hidden_study: false,
                                        is_price_study: false,
                                        isCustomIndicator: true,
                                        format: {
                                            type: "volume",
                                            precision: 3
                                        },
                                        styles: {
                                            plot_0: {
                                                title: "Net Foreign Buy / Sell value",
                                                histogramBase: 0,
                                                joinPoints: false
                                            }
                                        },
                                        description_localized: "Net Foreign Buy / Sell",
                                        shortId: "Net Foreign Buy / Sell",
                                        packageId: "tv-basicstudies",
                                        version: "12",
                                        fullId: "Net Foreign Buy / Sell@tv-basicstudies-12",
                                        productId: "tv-basicstudies",
                                        _serverMetaInfoVersion: 51
                                    }
                                }, 
                            ],
                            mainSourceId: "sEAGzL",
                            stretchFactor: 642.5084855766199,
                            leftAxisesState: [],
                            rightAxisesState: [
                                {
                                    state: {
                                        id: "qZdE2NiKmlfh",
                                        m_priceRange: null,
                                        m_isAutoScale: true,
                                        m_isPercentage: false,
                                        m_isIndexedTo100: false,
                                        m_isLog: false,
                                        m_isLockScale: false,
                                        m_isInverted: false,
                                        m_topMargin: 0.17,
                                        m_bottomMargin: 0.15,
                                        alignLabels: true,
                                        logFormula: {
                                            logicalOffset: 4,
                                            coordOffset: 0.0001
                                        }
                                    },
                                    sources: [
                                        "sEAGzL"
                                    ]
                                }, 
                            ],
                            overlayPriceScales: {},
                            priceScaleRatio: null
                        },
                        {
                            sources: [
                                {
                                    type: "Study",
                                    id: "wt9yiH",
                                    state: {
                                        filledAreasStyle: {
                                            strongArea: {
                                                color: "#009900",
                                                transparency: 80,
                                                visible: true
                                            },
                                            weakArea: {
                                                color: "#B80E0C",
                                                transparency: 80,
                                                visible: true
                                            }
                                        },
                                        styles: {
                                            main: {
                                                display: 15,
                                                plottype: 0,
                                                color: "#333333",
                                                linewidth: 2,
                                                transparency: 50,
                                                linestyle: 0,
                                                trackPrice: false,
                                                title: "main"
                                            },
                                            strong: {
                                                display: 15,
                                                plottype: 0,
                                                color: "#b80e0c",
                                                transparency: 80,
                                                linewidth: 1,
                                                linestyle: 0,
                                                trackPrice: false,
                                                title: "strong"
                                            },
                                            weak: {
                                                display: 15,
                                                plottype: 0,
                                                color: "#b80e0c",
                                                transparency: 80,
                                                linewidth: 1,
                                                linestyle: 0,
                                                trackPrice: false,
                                                title: "weak"
                                            }
                                        },
                                        precision: "default",
                                        inputs: {
                                            showZones: true,
                                            period: 50,
                                            strong: 20,
                                            weak: 20
                                        },
                                        bands: {},
                                        graphics: {},
                                        ohlcPlots: {},
                                        palettes: {},
                                        filledAreas: {},
                                        visible: true,
                                        showLegendValues: true,
                                        showLabelsOnPriceScale: true,
                                        parentSources: {},
                                        intervalsVisibilities: {
                                            ticks: true,
                                            seconds: true,
                                            secondsFrom: 1,
                                            secondsTo: 59,
                                            minutes: true,
                                            minutesFrom: 1,
                                            minutesTo: 59,
                                            hours: true,
                                            hoursFrom: 1,
                                            hoursTo: 24,
                                            days: true,
                                            daysFrom: 1,
                                            daysTo: 366,
                                            weeks: true,
                                            weeksFrom: 1,
                                            weeksTo: 52,
                                            months: true,
                                            monthsFrom: 1,
                                            monthsTo: 12,
                                            ranges: true
                                        }
                                    },
                                    zorder: -10000,
                                    ownFirstValue: null,
                                    metaInfo: {
                                        palettes: {},
                                        inputs: [
                                            {
                                                id: "showZones",
                                                name: "Show Zones",
                                                defval: true,
                                                type: "bool",
                                                display: 0
                                            },
                                            {
                                                id: "period",
                                                name: "Period",
                                                defval: 50,
                                                type: "integer",
                                                min: 1,
                                                max: 500,
                                                display: 15
                                            },
                                            {
                                                id: "strong",
                                                name: "Strong",
                                                defval: 20,
                                                type: "integer",
                                                min: 1,
                                                max: 500,
                                                display: 15
                                            },
                                            {
                                                id: "weak",
                                                name: "Weak",
                                                defval: 20,
                                                type: "integer",
                                                min: 1,
                                                max: 500,
                                                display: 15
                                            }, 
                                        ],
                                        plots: [
                                            {
                                                id: "main",
                                                type: "line"
                                            },
                                            {
                                                id: "strong",
                                                type: "line"
                                            },
                                            {
                                                id: "weak",
                                                type: "line"
                                            }, 
                                        ],
                                        graphics: {},
                                        defaults: {
                                            filledAreasStyle: {
                                                strongArea: {
                                                    color: "#009900",
                                                    transparency: 80,
                                                    visible: true
                                                },
                                                weakArea: {
                                                    color: "#B80E0C",
                                                    transparency: 80,
                                                    visible: true
                                                }
                                            },
                                            styles: {
                                                main: {
                                                    display: 15,
                                                    plottype: 0,
                                                    color: "#333333",
                                                    linewidth: 2,
                                                    transparency: 50
                                                },
                                                strong: {
                                                    display: 15,
                                                    plottype: 0,
                                                    color: "#B80E0C",
                                                    transparency: 80,
                                                    linewidth: 1
                                                },
                                                weak: {
                                                    display: 15,
                                                    plottype: 0,
                                                    color: "#B80E0C",
                                                    transparency: 80,
                                                    linewidth: 1
                                                }
                                            },
                                            precision: 2,
                                            inputs: {
                                                showZones: true,
                                                period: 50,
                                                strong: 20,
                                                weak: 20
                                            }
                                        },
                                        _metainfoVersion: 53,
                                        id: "Foreign Strength@tv-basicstudies-1",
                                        name: "Foreign Strength",
                                        description: "Foreign Strength",
                                        shortDescription: "Foreign Strength",
                                        is_price_study: false,
                                        isCustomIndicator: true,
                                        format: {
                                            type: "price",
                                            precision: 2
                                        },
                                        filledAreas: [
                                            {
                                                id: "strongArea",
                                                objAId: "main",
                                                objBId: "strong",
                                                type: "plot_plot",
                                                title: "Strong Background"
                                            },
                                            {
                                                id: "weakArea",
                                                objAId: "main",
                                                objBId: "weak",
                                                type: "plot_plot",
                                                title: "Weak Background"
                                            }, 
                                        ],
                                        styles: {
                                            main: {
                                                title: "Foreign Strength"
                                            },
                                            strong: {
                                                title: "Strong"
                                            },
                                            weak: {
                                                title: "Weak"
                                            }
                                        },
                                        description_localized: "Foreign Strength",
                                        shortId: "Foreign Strength",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Foreign Strength@tv-basicstudies-1",
                                        productId: "tv-basicstudies",
                                        _serverMetaInfoVersion: 51
                                    }
                                }, 
                            ],
                            mainSourceId: "wt9yiH",
                            stretchFactor: 648.5699264524955,
                            leftAxisesState: [],
                            rightAxisesState: [
                                {
                                    state: {
                                        id: "KgncAbvd9mxY",
                                        m_priceRange: null,
                                        m_isAutoScale: true,
                                        m_isPercentage: false,
                                        m_isIndexedTo100: false,
                                        m_isLog: false,
                                        m_isLockScale: false,
                                        m_isInverted: false,
                                        m_topMargin: 0.17,
                                        m_bottomMargin: 0.15,
                                        alignLabels: true,
                                        logFormula: {
                                            logicalOffset: 4,
                                            coordOffset: 0.0001
                                        }
                                    },
                                    sources: [
                                        "wt9yiH"
                                    ]
                                }, 
                            ],
                            overlayPriceScales: {},
                            priceScaleRatio: null
                        }, 
                    ],
                    timeScale: {
                        m_barSpacing: 6,
                        m_rightOffset: 35,
                        rightOffsetPercentage: 5,
                        usePercentageRightOffset: false
                    },
                    chartProperties: {
                        paneProperties: {
                            backgroundType: "solid",
                            background: "#ffffff",
                            backgroundGradientStartColor: "#ffffff",
                            backgroundGradientEndColor: "#ffffff",
                            gridLinesMode: "both",
                            vertGridProperties: {
                                color: "rgba(237, 237, 237, 0.3)"
                            },
                            horzGridProperties: {
                                color: "rgba(237, 237, 237, 0.3)"
                            },
                            crossHairProperties: {
                                color: "#9598A1",
                                style: 2,
                                transparency: 0,
                                width: 1,
                                "color:": "#9598A1"
                            },
                            topMargin: 17,
                            bottomMargin: 15,
                            axisProperties: {
                                autoScale: true,
                                autoScaleDisabled: false,
                                lockScale: false,
                                percentage: false,
                                percentageDisabled: false,
                                indexedTo100: false,
                                log: false,
                                logDisabled: false,
                                alignLabels: true,
                                isInverted: false
                            },
                            legendProperties: {
                                showStudyArguments: true,
                                showStudyTitles: true,
                                showStudyValues: false,
                                showSeriesTitle: true,
                                showSeriesOHLC: true,
                                showLegend: true,
                                showBarChange: true,
                                showVolume: false,
                                showBackground: true,
                                showPriceSource: true,
                                backgroundTransparency: 50,
                                showLogo: true,
                                wrapText: false,
                                showOnlyPriceSource: true
                            },
                            separatorColor: "#E0E3EB",
                            gridProperties: {
                                color: "#e1ecf2",
                                style: 0
                            },
                            leftAxisProperties: {
                                autoScale: true,
                                autoScaleDisabled: false,
                                lockScale: false,
                                percentage: false,
                                percentageDisabled: false,
                                indexedTo100: false,
                                log: false,
                                logDisabled: false,
                                alignLabels: true
                            },
                            rightAxisProperties: {
                                autoScale: true,
                                autoScaleDisabled: false,
                                lockScale: false,
                                percentage: false,
                                percentageDisabled: false,
                                log: false,
                                logDisabled: false,
                                alignLabels: true,
                                indexedTo100: false
                            },
                            rightOffset: null
                        },
                        scalesProperties: {
                            backgroundColor: "#ffffff",
                            lineColor: "rgba(42, 46, 57, 0)",
                            textColor: "#131722",
                            fontSize: 12,
                            scaleSeriesOnly: false,
                            showSeriesLastValue: true,
                            seriesLastValueMode: 1,
                            showSeriesPrevCloseValue: false,
                            showStudyLastValue: true,
                            showSymbolLabels: false,
                            showStudyPlotLabels: false,
                            showBidAskLabels: false,
                            showPrePostMarketPriceLabel: true,
                            showFundamentalNameLabel: false,
                            showFundamentalLastValue: true,
                            barSpacing: 6,
                            axisHighlightColor: "rgba(41, 98, 255, 0.25)",
                            axisLineToolLabelBackgroundColorCommon: "#2962FF",
                            axisLineToolLabelBackgroundColorActive: "#143EB3",
                            showPriceScaleCrosshairLabel: true,
                            showTimeScaleCrosshairLabel: true,
                            crosshairLabelBgColorLight: "#131722",
                            crosshairLabelBgColorDark: "#363A45",
                            showCurrency: true,
                            showUnit: true,
                            showLeftScale: false,
                            showRightScale: true
                        },
                        chartEventsSourceProperties: {
                            visible: true,
                            futureOnly: true,
                            breaks: {
                                color: "rgba(85, 85, 85, 1)",
                                visible: false,
                                style: 2,
                                width: 1
                            }
                        },
                        tradingProperties: {
                            showPositions: true,
                            positionPL: {
                                visibility: true,
                                display: 2
                            },
                            bracketsPL: {
                                visibility: true,
                                display: 0
                            },
                            showOrders: true,
                            showExecutions: true,
                            showExecutionsLabels: false,
                            showReverse: true,
                            horizontalAlignment: 2,
                            extendLeft: true,
                            lineLength: 5,
                            lineWidth: 1,
                            lineStyle: 0
                        },
                        priceScaleSelectionStrategyName: "auto"
                    },
                    sessions: {
                        properties: {
                            graphics: {
                                backgrounds: {
                                    outOfSession: {
                                        color: "#2962FF",
                                        transparency: 92,
                                        visible: false
                                    },
                                    preMarket: {
                                        color: "#FF9800",
                                        transparency: 92,
                                        visible: false
                                    },
                                    postMarket: {
                                        color: "#2962FF",
                                        transparency: 92,
                                        visible: false
                                    }
                                },
                                vertlines: {
                                    sessBreaks: {
                                        color: "#4985e7",
                                        style: 2,
                                        visible: false,
                                        width: 1
                                    }
                                }
                            }
                        }
                    },
                    version: 3,
                    timezone: "Asia/Jakarta",
                    shouldBeSavedEvenIfHidden: true,
                    linkingGroup: null,
                    lineToolsGroups: {
                        groups: []
                    },
                    chartId: "1",
                    theme: "light"
                }, 
            ],
            symbolLock: 0,
            intervalLock: 0,
            trackTimeLock: 0,
            dateRangeLock: 0,
            crosshairLock: 1,
            layoutsSizes: {
                s: [
                    {
                        percent: 1
                    }
                ]
            }
        }
    },
    {
        key: "bandarmology",
        name: "Bandarmology",
        template: {
            layout: "s",
            charts: [
                {
                    panes: [
                        {
                            sources: [
                                {
                                    type: "MainSeries",
                                    id: "_seriesId",
                                    zorder: 0,
                                    haStyle: {
                                        studyId: "BarSetHeikenAshi@tv-basicstudies-60"
                                    },
                                    renkoStyle: {
                                        studyId: "BarSetRenko@tv-prostudies-64"
                                    },
                                    pbStyle: {
                                        studyId: "BarSetPriceBreak@tv-prostudies-34"
                                    },
                                    kagiStyle: {
                                        studyId: "BarSetKagi@tv-prostudies-34"
                                    },
                                    pnfStyle: {
                                        studyId: "BarSetPnF@tv-prostudies-34"
                                    },
                                    rangeStyle: {
                                        studyId: "BarSetRange@tv-basicstudies-72"
                                    },
                                    formattingDeps: {
                                        format: "price",
                                        pricescale: 1,
                                        minmov: 1
                                    },
                                    state: {
                                        style: 1,
                                        esdShowDividends: true,
                                        esdShowSplits: true,
                                        esdShowEarnings: true,
                                        esdShowBreaks: false,
                                        esdFlagSize: 2,
                                        showContinuousContractSwitches: true,
                                        showContinuousContractSwitchesBreaks: false,
                                        showFuturesContractExpiration: true,
                                        showLastNews: true,
                                        showCountdown: false,
                                        bidAsk: {
                                            visible: false,
                                            lineStyle: 1,
                                            lineWidth: 1,
                                            bidLineColor: "#2962FF",
                                            askLineColor: "#F7525F"
                                        },
                                        prePostMarket: {
                                            visible: true,
                                            lineStyle: 1,
                                            lineWidth: 1,
                                            preMarketColor: "#FB8C00",
                                            postMarketColor: "#2962FF"
                                        },
                                        highLowAvgPrice: {
                                            highLowPriceLinesVisible: false,
                                            highLowPriceLabelsVisible: false,
                                            averageClosePriceLineVisible: false,
                                            averageClosePriceLabelVisible: false,
                                            highLowPriceLinesColor: "",
                                            highLowPriceLinesWidth: 1,
                                            averagePriceLineColor: "",
                                            averagePriceLineWidth: 1
                                        },
                                        visible: true,
                                        showPriceLine: true,
                                        priceLineWidth: 1,
                                        priceLineColor: "",
                                        baseLineColor: "#B2B5BE",
                                        showPrevClosePriceLine: false,
                                        prevClosePriceLineWidth: 1,
                                        prevClosePriceLineColor: "#555555",
                                        minTick: "default",
                                        dividendsAdjustment: null,
                                        backAdjustment: false,
                                        settlementAsClose: true,
                                        sessionId: "regular",
                                        sessVis: false,
                                        statusViewStyle: {
                                            fontSize: 16,
                                            showExchange: true,
                                            showInterval: true,
                                            symbolTextSource: "description",
                                            showSymbolAsDescription: false
                                        },
                                        candleStyle: {
                                            upColor: "#00AB6B",
                                            downColor: "#EE4A49",
                                            drawWick: true,
                                            drawBorder: true,
                                            borderColor: "#00AB6B",
                                            borderUpColor: "#00AB6B",
                                            borderDownColor: "#EE4A49",
                                            wickColor: "#737375",
                                            wickUpColor: "#00AB6B",
                                            wickDownColor: "#EE4A49",
                                            barColorsOnPrevClose: false,
                                            drawBody: true
                                        },
                                        hollowCandleStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            drawWick: true,
                                            drawBorder: true,
                                            borderColor: "#378658",
                                            borderUpColor: "#089981",
                                            borderDownColor: "#F23645",
                                            wickColor: "#737375",
                                            wickUpColor: "#089981",
                                            wickDownColor: "#F23645",
                                            drawBody: true
                                        },
                                        haStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            drawWick: true,
                                            drawBorder: true,
                                            borderColor: "#378658",
                                            borderUpColor: "#089981",
                                            borderDownColor: "#F23645",
                                            wickColor: "#737375",
                                            wickUpColor: "#089981",
                                            wickDownColor: "#F23645",
                                            showRealLastPrice: false,
                                            barColorsOnPrevClose: false,
                                            inputs: {},
                                            inputInfo: {},
                                            drawBody: true
                                        },
                                        barStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            barColorsOnPrevClose: false,
                                            dontDrawOpen: false,
                                            thinBars: true
                                        },
                                        hiloStyle: {
                                            color: "#2962FF",
                                            showBorders: true,
                                            borderColor: "#2962FF",
                                            showLabels: true,
                                            labelColor: "#2962FF",
                                            drawBody: true,
                                            fontSize: 7
                                        },
                                        columnStyle: {
                                            upColor: "rgba(8, 153, 129, 0.5)",
                                            downColor: "rgba(242, 54, 69, 0.5)",
                                            barColorsOnPrevClose: true,
                                            priceSource: "close"
                                        },
                                        lineStyle: {
                                            color: "#2962FF",
                                            linestyle: 0,
                                            linewidth: 2,
                                            priceSource: "close"
                                        },
                                        lineWithMarkersStyle: {
                                            color: "#2962FF",
                                            linestyle: 0,
                                            linewidth: 2,
                                            priceSource: "close"
                                        },
                                        steplineStyle: {
                                            color: "#2962FF",
                                            linestyle: 0,
                                            linewidth: 2,
                                            priceSource: "close"
                                        },
                                        areaStyle: {
                                            color1: "rgba(41, 98, 255, 0.28)",
                                            color2: "#2962FF",
                                            linecolor: "#2962FF",
                                            linestyle: 0,
                                            linewidth: 1,
                                            priceSource: "close",
                                            transparency: 100
                                        },
                                        hlcAreaStyle: {
                                            highLineColor: "#089981",
                                            highLineStyle: 0,
                                            highLineWidth: 2,
                                            lowLineColor: "#F23645",
                                            lowLineStyle: 0,
                                            lowLineWidth: 2,
                                            closeLineColor: "#868993",
                                            closeLineStyle: 0,
                                            closeLineWidth: 2,
                                            highCloseFillColor: "rgba(8, 153, 129, 0.2)",
                                            closeLowFillColor: "rgba(242, 54, 69, 0.2)"
                                        },
                                        renkoStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            borderUpColor: "#089981",
                                            borderDownColor: "#F23645",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            borderUpColorProjection: "#a9dcc3",
                                            borderDownColorProjection: "#f5a6ae",
                                            wickUpColor: "#089981",
                                            wickDownColor: "#F23645",
                                            inputs: {
                                                source: "close",
                                                sources: "Close",
                                                boxSize: 3,
                                                style: "ATR",
                                                atrLength: 14,
                                                wicks: true
                                            },
                                            inputInfo: {
                                                source: {
                                                    name: "Source"
                                                },
                                                sources: {
                                                    name: "Source"
                                                },
                                                boxSize: {
                                                    name: "Box size"
                                                },
                                                style: {
                                                    name: "Style"
                                                },
                                                atrLength: {
                                                    name: "ATR length"
                                                },
                                                wicks: {
                                                    name: "Wicks"
                                                }
                                            }
                                        },
                                        pbStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            borderUpColor: "#089981",
                                            borderDownColor: "#F23645",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            borderUpColorProjection: "#a9dcc3",
                                            borderDownColorProjection: "#f5a6ae",
                                            inputs: {
                                                source: "close",
                                                lb: 3
                                            },
                                            inputInfo: {
                                                source: {
                                                    name: "Source"
                                                },
                                                lb: {
                                                    name: "Number of line"
                                                }
                                            }
                                        },
                                        kagiStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            inputs: {
                                                source: "close",
                                                style: "ATR",
                                                atrLength: 14,
                                                reversalAmount: 1
                                            },
                                            inputInfo: {
                                                source: {
                                                    name: "Source"
                                                },
                                                style: {
                                                    name: "Style"
                                                },
                                                atrLength: {
                                                    name: "ATR length"
                                                },
                                                reversalAmount: {
                                                    name: "Reversal amount"
                                                }
                                            }
                                        },
                                        pnfStyle: {
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            inputs: {
                                                sources: "Close",
                                                reversalAmount: 3,
                                                boxSize: 1,
                                                style: "ATR",
                                                atrLength: 14,
                                                oneStepBackBuilding: false
                                            },
                                            inputInfo: {
                                                sources: {
                                                    name: "Source"
                                                },
                                                boxSize: {
                                                    name: "Box size"
                                                },
                                                reversalAmount: {
                                                    name: "Reversal amount"
                                                },
                                                style: {
                                                    name: "Style"
                                                },
                                                atrLength: {
                                                    name: "ATR length"
                                                },
                                                oneStepBackBuilding: {
                                                    name: "One step back building"
                                                }
                                            }
                                        },
                                        baselineStyle: {
                                            baselineColor: "#758696",
                                            topFillColor1: "rgba(8, 153, 129, 0.28)",
                                            topFillColor2: "rgba(8, 153, 129, 0.05)",
                                            bottomFillColor1: "rgba(242, 54, 69, 0.05)",
                                            bottomFillColor2: "rgba(242, 54, 69, 0.28)",
                                            topLineColor: "#089981",
                                            bottomLineColor: "#F23645",
                                            topLineWidth: 1,
                                            bottomLineWidth: 1,
                                            priceSource: "close",
                                            transparency: 50,
                                            baseLevelPercentage: 50
                                        },
                                        rangeStyle: {
                                            barStyle: 0,
                                            upColor: "#089981",
                                            downColor: "#F23645",
                                            upColorProjection: "#a9dcc3",
                                            downColorProjection: "#f5a6ae",
                                            thinBars: true,
                                            candlesUpColor: "#089981",
                                            candlesDownColor: "#F23645",
                                            candlesBorderUpColor: "#089981",
                                            candlesBorderDownColor: "#F23645",
                                            candlesWickUpColor: "#089981",
                                            candlesWickDownColor: "#F23645",
                                            inputs: {
                                                range: 10,
                                                phantomBars: false
                                            },
                                            inputInfo: {
                                                range: {
                                                    name: "Range"
                                                },
                                                phantomBars: {
                                                    name: "Phantom bars"
                                                }
                                            }
                                        },
                                        symbol: "BBCA",
                                        shortName: "BBCA",
                                        timeframe: "",
                                        onWidget: false,
                                        interval: "D",
                                        unitId: null,
                                        showInDataWindow: true,
                                        showSessions: false,
                                        shortname: "",
                                        currencyId: null,
                                        priceAxisProperties: {
                                            autoScale: true,
                                            autoScaleDisabled: false,
                                            lockScale: false,
                                            percentage: false,
                                            percentageDisabled: false,
                                            log: false,
                                            logDisabled: false,
                                            alignLabels: true,
                                            isInverted: false,
                                            indexedTo100: false
                                        }
                                    }
                                }, 
                            ],
                            mainSourceId: "_seriesId",
                            stretchFactor: 4910.315574383505,
                            leftAxisesState: [],
                            rightAxisesState: [
                                {
                                    state: {
                                        id: "fuH0asbqXhZu",
                                        m_priceRange: null,
                                        m_isAutoScale: true,
                                        m_isPercentage: false,
                                        m_isIndexedTo100: false,
                                        m_isLog: false,
                                        m_isLockScale: false,
                                        m_isInverted: false,
                                        m_topMargin: 0.17,
                                        m_bottomMargin: 0.15,
                                        alignLabels: true,
                                        logFormula: {
                                            logicalOffset: 4,
                                            coordOffset: 0.0001
                                        }
                                    },
                                    sources: [
                                        "_seriesId"
                                    ]
                                }, 
                            ],
                            overlayPriceScales: {},
                            priceScaleRatio: null
                        },
                        {
                            sources: [
                                {
                                    type: "Study",
                                    id: "1di27H",
                                    state: {
                                        styles: {
                                            vol: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 1,
                                                plottype: 5,
                                                trackPrice: false,
                                                transparency: 0,
                                                color: "#000080",
                                                title: "vol"
                                            },
                                            vol_ma: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 2,
                                                plottype: 0,
                                                trackPrice: false,
                                                transparency: 30,
                                                color: "#0496ff",
                                                title: "vol_ma"
                                            }
                                        },
                                        precision: "default",
                                        palettes: {
                                            volumePalette: {
                                                colors: {
                                                    0: {
                                                        color: "rgba(235, 77, 92, 0.50)",
                                                        width: 1,
                                                        style: 0
                                                    },
                                                    1: {
                                                        color: "rgba(83, 185, 135, 0.50)",
                                                        width: 1,
                                                        style: 0
                                                    }
                                                }
                                            }
                                        },
                                        inputs: {
                                            showMA: true,
                                            maLength: 20
                                        },
                                        bands: {},
                                        graphics: {},
                                        ohlcPlots: {},
                                        filledAreasStyle: {},
                                        filledAreas: {},
                                        visible: true,
                                        showLegendValues: true,
                                        showLabelsOnPriceScale: true,
                                        parentSources: {},
                                        intervalsVisibilities: {
                                            ticks: true,
                                            seconds: true,
                                            secondsFrom: 1,
                                            secondsTo: 59,
                                            minutes: true,
                                            minutesFrom: 1,
                                            minutesTo: 59,
                                            hours: true,
                                            hoursFrom: 1,
                                            hoursTo: 24,
                                            days: true,
                                            daysFrom: 1,
                                            daysTo: 366,
                                            weeks: true,
                                            weeksFrom: 1,
                                            weeksTo: 52,
                                            months: true,
                                            monthsFrom: 1,
                                            monthsTo: 12,
                                            ranges: true
                                        }
                                    },
                                    zorder: -10000,
                                    ownFirstValue: null,
                                    metaInfo: {
                                        palettes: {
                                            volumePalette: {
                                                colors: [
                                                    {
                                                        name: "Falling"
                                                    },
                                                    {
                                                        name: "Growing"
                                                    }
                                                ]
                                            }
                                        },
                                        inputs: [
                                            {
                                                id: "showMA",
                                                name: "show MA",
                                                defval: true,
                                                type: "bool",
                                                display: 0
                                            },
                                            {
                                                id: "maLength",
                                                name: "MA Length",
                                                defval: 20,
                                                type: "integer",
                                                min: 1,
                                                max: 2000,
                                                display: 15
                                            }, 
                                        ],
                                        plots: [
                                            {
                                                id: "vol",
                                                type: "line"
                                            },
                                            {
                                                id: "volumePalette",
                                                palette: "volumePalette",
                                                target: "vol",
                                                type: "colorer"
                                            },
                                            {
                                                id: "vol_ma",
                                                type: "line"
                                            }, 
                                        ],
                                        graphics: {},
                                        defaults: {
                                            styles: {
                                                vol: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 1,
                                                    plottype: 5,
                                                    trackPrice: false,
                                                    transparency: 0,
                                                    color: "#000080"
                                                },
                                                vol_ma: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 2,
                                                    plottype: 0,
                                                    trackPrice: false,
                                                    transparency: 30,
                                                    color: "#0496FF"
                                                }
                                            },
                                            precision: 0,
                                            palettes: {
                                                volumePalette: {
                                                    colors: {
                                                        0: {
                                                            color: "rgba(235, 77, 92, 0.50)",
                                                            width: 1,
                                                            style: 0
                                                        },
                                                        1: {
                                                            color: "rgba(83, 185, 135, 0.50)",
                                                            width: 1,
                                                            style: 0
                                                        }
                                                    }
                                                }
                                            },
                                            inputs: {
                                                showMA: true,
                                                maLength: 20
                                            }
                                        },
                                        _metainfoVersion: 53,
                                        id: "Volume_@tv-basicstudies-1",
                                        is_hidden_study: false,
                                        description: "Volume_",
                                        shortDescription: "Volume",
                                        is_price_study: false,
                                        format: {
                                            type: "volume",
                                            precision: 3
                                        },
                                        styles: {
                                            vol: {
                                                title: "Volume_",
                                                histogramBase: 0
                                            },
                                            vol_ma: {
                                                title: "Volume MA",
                                                histogramBase: 0
                                            }
                                        },
                                        description_localized: "Volume_",
                                        shortId: "Volume_",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Volume_@tv-basicstudies-1",
                                        productId: "tv-basicstudies",
                                        _serverMetaInfoVersion: 51
                                    }
                                }, 
                            ],
                            mainSourceId: "1di27H",
                            stretchFactor: 761.6340921567289,
                            leftAxisesState: [],
                            rightAxisesState: [
                                {
                                    state: {
                                        id: "OT5Qz68Vr8kM",
                                        m_priceRange: null,
                                        m_isAutoScale: true,
                                        m_isPercentage: false,
                                        m_isIndexedTo100: false,
                                        m_isLog: false,
                                        m_isLockScale: false,
                                        m_isInverted: false,
                                        m_topMargin: 0.17,
                                        m_bottomMargin: 0.15,
                                        alignLabels: true,
                                        logFormula: {
                                            logicalOffset: 4,
                                            coordOffset: 0.0001
                                        }
                                    },
                                    sources: [
                                        "1di27H"
                                    ]
                                }, 
                            ],
                            overlayPriceScales: {},
                            priceScaleRatio: null
                        },
                        {
                            sources: [
                                {
                                    type: "Study",
                                    id: "FRzT2x",
                                    state: {
                                        styles: {
                                            plot_0: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 2,
                                                plottype: 0,
                                                transparency: 40,
                                                color: "#1CBECB",
                                                trackPrice: false,
                                                title: "plot_0"
                                            }
                                        },
                                        precision: "default",
                                        inputs: {},
                                        bands: {},
                                        graphics: {},
                                        ohlcPlots: {},
                                        palettes: {},
                                        filledAreasStyle: {},
                                        filledAreas: {},
                                        visible: true,
                                        showLegendValues: true,
                                        showLabelsOnPriceScale: true,
                                        parentSources: {},
                                        intervalsVisibilities: {
                                            ticks: true,
                                            seconds: true,
                                            secondsFrom: 1,
                                            secondsTo: 59,
                                            minutes: true,
                                            minutesFrom: 1,
                                            minutesTo: 59,
                                            hours: true,
                                            hoursFrom: 1,
                                            hoursTo: 24,
                                            days: true,
                                            daysFrom: 1,
                                            daysTo: 366,
                                            weeks: true,
                                            weeksFrom: 1,
                                            weeksTo: 52,
                                            months: true,
                                            monthsFrom: 1,
                                            monthsTo: 12,
                                            ranges: true
                                        }
                                    },
                                    zorder: -10000,
                                    ownFirstValue: null,
                                    metaInfo: {
                                        palettes: {},
                                        inputs: [],
                                        plots: [
                                            {
                                                id: "plot_0",
                                                type: "line",
                                                palette: "palette_0",
                                                target: "Bandar Value (Rp)"
                                            }, 
                                        ],
                                        graphics: {},
                                        defaults: {
                                            styles: {
                                                plot_0: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 2,
                                                    plottype: 0,
                                                    transparency: 11,
                                                    color: "#465ADB"
                                                }
                                            },
                                            precision: 0,
                                            inputs: {}
                                        },
                                        _metainfoVersion: 53,
                                        id: "Bandar Value (Rp)@tv-basicstudies-1",
                                        name: "Bandar Value (Rp)",
                                        description: "Bandar Value (Rp)",
                                        shortDescription: "Bandar Value (Rp)",
                                        is_hidden_study: false,
                                        is_price_study: false,
                                        isCustomIndicator: true,
                                        format: {
                                            type: "volume",
                                            precision: 3
                                        },
                                        styles: {
                                            plot_0: {
                                                title: "Bandar Value (Rp) value",
                                                histogramBase: 0
                                            }
                                        },
                                        description_localized: "Bandar Value (Rp)",
                                        shortId: "Bandar Value (Rp)",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Bandar Value (Rp)@tv-basicstudies-1",
                                        productId: "tv-basicstudies",
                                        _serverMetaInfoVersion: 51
                                    }
                                }, 
                            ],
                            mainSourceId: "FRzT2x",
                            stretchFactor: 639.1681834955561,
                            leftAxisesState: [],
                            rightAxisesState: [
                                {
                                    state: {
                                        id: "GN2Rji3Lwd0M",
                                        m_priceRange: null,
                                        m_isAutoScale: true,
                                        m_isPercentage: false,
                                        m_isIndexedTo100: false,
                                        m_isLog: false,
                                        m_isLockScale: false,
                                        m_isInverted: false,
                                        m_topMargin: 0.17,
                                        m_bottomMargin: 0.15,
                                        alignLabels: true,
                                        logFormula: {
                                            logicalOffset: 4,
                                            coordOffset: 0.0001
                                        }
                                    },
                                    sources: [
                                        "FRzT2x"
                                    ]
                                }, 
                            ],
                            overlayPriceScales: {},
                            priceScaleRatio: null
                        },
                        {
                            sources: [
                                {
                                    type: "Study",
                                    id: "Tpv9Jx",
                                    state: {
                                        palettes: {
                                            palette_0: {
                                                colors: {
                                                    0: {
                                                        color: "#B80E0C",
                                                        width: 5,
                                                        style: 0
                                                    },
                                                    1: {
                                                        color: "#009900",
                                                        width: 5,
                                                        style: 0
                                                    }
                                                }
                                            }
                                        },
                                        styles: {
                                            plot_0: {
                                                display: 15,
                                                linestyle: 0,
                                                linewidth: 5,
                                                plottype: 5,
                                                trackPrice: false,
                                                transparency: 11,
                                                color: "#009900",
                                                title: "plot_0"
                                            }
                                        },
                                        precision: "default",
                                        inputs: {},
                                        bands: {},
                                        graphics: {},
                                        ohlcPlots: {},
                                        filledAreasStyle: {},
                                        filledAreas: {},
                                        visible: true,
                                        showLegendValues: true,
                                        showLabelsOnPriceScale: true,
                                        parentSources: {},
                                        intervalsVisibilities: {
                                            ticks: true,
                                            seconds: true,
                                            secondsFrom: 1,
                                            secondsTo: 59,
                                            minutes: true,
                                            minutesFrom: 1,
                                            minutesTo: 59,
                                            hours: true,
                                            hoursFrom: 1,
                                            hoursTo: 24,
                                            days: true,
                                            daysFrom: 1,
                                            daysTo: 366,
                                            weeks: true,
                                            weeksFrom: 1,
                                            weeksTo: 52,
                                            months: true,
                                            monthsFrom: 1,
                                            monthsTo: 12,
                                            ranges: true
                                        }
                                    },
                                    zorder: -10000,
                                    ownFirstValue: null,
                                    metaInfo: {
                                        palettes: {
                                            palette_0: {
                                                colors: [
                                                    {
                                                        name: "Color 0"
                                                    },
                                                    {
                                                        name: "Color 1"
                                                    }
                                                ]
                                            }
                                        },
                                        inputs: [],
                                        plots: [
                                            {
                                                id: "plot_0",
                                                type: "line"
                                            },
                                            {
                                                id: "plot_1",
                                                palette: "palette_0",
                                                target: "plot_0",
                                                type: "colorer"
                                            }, 
                                        ],
                                        graphics: {},
                                        defaults: {
                                            palettes: {
                                                palette_0: {
                                                    colors: [
                                                        {
                                                            color: "#B80E0C",
                                                            width: 5,
                                                            style: 0
                                                        },
                                                        {
                                                            color: "#009900",
                                                            width: 5,
                                                            style: 0
                                                        }, 
                                                    ]
                                                }
                                            },
                                            styles: {
                                                plot_0: {
                                                    display: 15,
                                                    linestyle: 0,
                                                    linewidth: 5,
                                                    plottype: 5,
                                                    trackPrice: false,
                                                    transparency: 11,
                                                    color: "#009900"
                                                }
                                            },
                                            precision: 0,
                                            inputs: {}
                                        },
                                        _metainfoVersion: 53,
                                        id: "Bandar Volume@tv-basicstudies-1",
                                        name: "Bandar Volume",
                                        description: "Bandar Volume",
                                        shortDescription: "Bandar Volume",
                                        is_hidden_study: false,
                                        is_price_study: false,
                                        isCustomIndicator: true,
                                        format: {
                                            type: "volume",
                                            precision: 2
                                        },
                                        styles: {
                                            plot_0: {
                                                title: "Bandar Volume value",
                                                histogramBase: 0,
                                                joinPoints: false
                                            }
                                        },
                                        description_localized: "Bandar Volume",
                                        shortId: "Bandar Volume",
                                        packageId: "tv-basicstudies",
                                        version: "1",
                                        fullId: "Bandar Volume@tv-basicstudies-1",
                                        productId: "tv-basicstudies",
                                        _serverMetaInfoVersion: 51
                                    }
                                }, 
                            ],
                            mainSourceId: "Tpv9Jx",
                            stretchFactor: 781.9548872180451,
                            leftAxisesState: [],
                            rightAxisesState: [
                                {
                                    state: {
                                        id: "E3WO8eglD0cw",
                                        m_priceRange: null,
                                        m_isAutoScale: true,
                                        m_isPercentage: false,
                                        m_isIndexedTo100: false,
                                        m_isLog: false,
                                        m_isLockScale: false,
                                        m_isInverted: false,
                                        m_topMargin: 0.17,
                                        m_bottomMargin: 0.15,
                                        alignLabels: true,
                                        logFormula: {
                                            logicalOffset: 4,
                                            coordOffset: 0.0001
                                        }
                                    },
                                    sources: [
                                        "Tpv9Jx"
                                    ]
                                }, 
                            ],
                            overlayPriceScales: {},
                            priceScaleRatio: null
                        }, 
                    ],
                    timeScale: {
                        m_barSpacing: 6,
                        m_rightOffset: 35,
                        rightOffsetPercentage: 5,
                        usePercentageRightOffset: false
                    },
                    chartProperties: {
                        paneProperties: {
                            backgroundType: "solid",
                            background: "#ffffff",
                            backgroundGradientStartColor: "#ffffff",
                            backgroundGradientEndColor: "#ffffff",
                            gridLinesMode: "both",
                            vertGridProperties: {
                                color: "rgba(237, 237, 237, 0.3)"
                            },
                            horzGridProperties: {
                                color: "rgba(237, 237, 237, 0.3)"
                            },
                            crossHairProperties: {
                                color: "#9598A1",
                                style: 2,
                                transparency: 0,
                                width: 1,
                                "color:": "#9598A1"
                            },
                            topMargin: 17,
                            bottomMargin: 15,
                            axisProperties: {
                                autoScale: true,
                                autoScaleDisabled: false,
                                lockScale: false,
                                percentage: false,
                                percentageDisabled: false,
                                indexedTo100: false,
                                log: false,
                                logDisabled: false,
                                alignLabels: true,
                                isInverted: false
                            },
                            legendProperties: {
                                showStudyArguments: true,
                                showStudyTitles: true,
                                showStudyValues: false,
                                showSeriesTitle: true,
                                showSeriesOHLC: true,
                                showLegend: true,
                                showBarChange: true,
                                showVolume: false,
                                showBackground: true,
                                showPriceSource: true,
                                backgroundTransparency: 50,
                                showLogo: true,
                                wrapText: false,
                                showOnlyPriceSource: true
                            },
                            separatorColor: "#E0E3EB",
                            gridProperties: {
                                color: "#e1ecf2",
                                style: 0
                            },
                            leftAxisProperties: {
                                autoScale: true,
                                autoScaleDisabled: false,
                                lockScale: false,
                                percentage: false,
                                percentageDisabled: false,
                                indexedTo100: false,
                                log: false,
                                logDisabled: false,
                                alignLabels: true
                            },
                            rightAxisProperties: {
                                autoScale: true,
                                autoScaleDisabled: false,
                                lockScale: false,
                                percentage: false,
                                percentageDisabled: false,
                                log: false,
                                logDisabled: false,
                                alignLabels: true,
                                indexedTo100: false
                            },
                            rightOffset: null
                        },
                        scalesProperties: {
                            backgroundColor: "#ffffff",
                            lineColor: "rgba(42, 46, 57, 0)",
                            textColor: "#131722",
                            fontSize: 12,
                            scaleSeriesOnly: false,
                            showSeriesLastValue: true,
                            seriesLastValueMode: 1,
                            showSeriesPrevCloseValue: false,
                            showStudyLastValue: true,
                            showSymbolLabels: false,
                            showStudyPlotLabels: false,
                            showBidAskLabels: false,
                            showPrePostMarketPriceLabel: true,
                            showFundamentalNameLabel: false,
                            showFundamentalLastValue: true,
                            barSpacing: 6,
                            axisHighlightColor: "rgba(41, 98, 255, 0.25)",
                            axisLineToolLabelBackgroundColorCommon: "#2962FF",
                            axisLineToolLabelBackgroundColorActive: "#143EB3",
                            showPriceScaleCrosshairLabel: true,
                            showTimeScaleCrosshairLabel: true,
                            crosshairLabelBgColorLight: "#131722",
                            crosshairLabelBgColorDark: "#363A45",
                            showCurrency: true,
                            showUnit: true,
                            showLeftScale: false,
                            showRightScale: true
                        },
                        chartEventsSourceProperties: {
                            visible: true,
                            futureOnly: true,
                            breaks: {
                                color: "rgba(85, 85, 85, 1)",
                                visible: false,
                                style: 2,
                                width: 1
                            }
                        },
                        tradingProperties: {
                            showPositions: true,
                            positionPL: {
                                visibility: true,
                                display: 2
                            },
                            bracketsPL: {
                                visibility: true,
                                display: 0
                            },
                            showOrders: true,
                            showExecutions: true,
                            showExecutionsLabels: false,
                            showReverse: true,
                            horizontalAlignment: 2,
                            extendLeft: true,
                            lineLength: 5,
                            lineWidth: 1,
                            lineStyle: 0
                        },
                        priceScaleSelectionStrategyName: "auto"
                    },
                    sessions: {
                        properties: {
                            graphics: {
                                backgrounds: {
                                    outOfSession: {
                                        color: "#2962FF",
                                        transparency: 92,
                                        visible: false
                                    },
                                    preMarket: {
                                        color: "#FF9800",
                                        transparency: 92,
                                        visible: false
                                    },
                                    postMarket: {
                                        color: "#2962FF",
                                        transparency: 92,
                                        visible: false
                                    }
                                },
                                vertlines: {
                                    sessBreaks: {
                                        color: "#4985e7",
                                        style: 2,
                                        visible: false,
                                        width: 1
                                    }
                                }
                            }
                        }
                    },
                    version: 3,
                    timezone: "Asia/Jakarta",
                    shouldBeSavedEvenIfHidden: true,
                    linkingGroup: null,
                    lineToolsGroups: {
                        groups: []
                    },
                    chartId: "1",
                    theme: "light"
                }, 
            ],
            symbolLock: 0,
            intervalLock: 0,
            trackTimeLock: 0,
            dateRangeLock: 0,
            crosshairLock: 1,
            layoutsSizes: {
                s: [
                    {
                        percent: 1
                    }
                ]
            }
        }
    }, 
];
/* harmony default export */ __webpack_exports__["Z"] = (templates);


/***/ }),

/***/ 51346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ku": function() { return /* binding */ localStorageOrderbookHandler; },
/* harmony export */   "M6": function() { return /* binding */ transformNewOrderbookListToExisting; },
/* harmony export */   "Qh": function() { return /* binding */ checkShowTableByType; }
/* harmony export */ });
/* unused harmony exports getErrorMessage, memoizeChild */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var global_Securities_types_stockType__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56644);



var localStorageOrderbookHandler = {
    get: function() {
        var orderbookName = localStorage.getItem("orderbooklistName");
        var orderbookID = localStorage.getItem("orderbooklistID");
        return {
            orderbookName: orderbookName,
            orderbookID: orderbookID
        };
    },
    set: function(orderbookName, orderbookID) {
        localStorage.setItem("orderbooklistID", orderbookID);
        localStorage.setItem("orderbooklistName", orderbookName);
    },
    remove: function() {
        localStorage.removeItem("orderbooklistID");
        localStorage.removeItem("orderbooklistName");
    }
};
var getErrorMessage = function(error) {
    var ref;
    var err = _instanceof(error, Error) ? (error === null || error === void 0 ? void 0 : (ref = error.cause) === null || ref === void 0 ? void 0 : ref.message) || error.message : String(error);
    return err;
};
var memoizeChild = function(component) {
    var circular = function() {
        var seen = new WeakSet();
        return function(key, value) {
            if (key.startsWith("_")) return; // Don't compare React's internal props.
            if (typeof value === "object" && value !== null) {
                if (seen.has(value)) return;
                seen.add(value);
            }
            // eslint-disable-next-line consistent-return
            return value;
        };
    };
    return memo(component, function(prevProps, nextProps) {
        var prev = JSON.stringify(prevProps, circular());
        var next = JSON.stringify(nextProps, circular());
        return prev === next;
    });
};
var transformNewOrderbookListToExisting = function(newResponse) {
    if (!newResponse) return null;
    var tradeable = newResponse.tradable ? 1 : 0;
    var bidObject = {};
    var offerObject = {};
    newResponse.bid.forEach(function(value, index) {
        var priceNameKey = "price".concat(index + 1);
        bidObject[priceNameKey] = value.price;
        var queNumNameKey = "que_num".concat(index + 1);
        bidObject[queNumNameKey] = value.que_num;
        var valueNameKey = "volume".concat(index + 1);
        bidObject[valueNameKey] = value.volume;
    });
    newResponse.offer.forEach(function(value, index) {
        var priceNameKey = "price".concat(index + 1);
        offerObject[priceNameKey] = value.price;
        var queNumNameKey = "que_num".concat(index + 1);
        offerObject[queNumNameKey] = value.que_num;
        var valueNameKey = "volume".concat(index + 1);
        offerObject[valueNameKey] = value.volume;
    });
    return {
        id: newResponse.id,
        symbol: newResponse.symbol,
        symbol_2: newResponse.symbol,
        symbol_3: newResponse.symbol,
        name: newResponse.name,
        status: newResponse.status,
        lastprice: newResponse.lastprice,
        previous: newResponse.previous,
        change: newResponse.change,
        percentage_change: newResponse.percentage_change,
        open: newResponse.open,
        high: newResponse.high,
        low: newResponse.low,
        close: newResponse.close,
        volume: newResponse.volume,
        value: newResponse.value,
        average: newResponse.average,
        bid: bidObject,
        offer: offerObject,
        frequency: newResponse.frequency,
        fbuy: newResponse.fbuy,
        fsell: newResponse.fsell,
        fnet: newResponse.fnet,
        fpercent: newResponse.fpercent,
        tradeable: tradeable,
        notation: newResponse.notation,
        uma: newResponse.uma,
        GUID: null,
        is_foreignbs_exist: newResponse.has_foreign_bs,
        exchange: newResponse.exchange,
        country: null,
        foreign: null,
        domestic: null,
        up: null,
        down: null,
        unchanged: null,
        iepiev: newResponse.iepiev,
        ara: newResponse.ara,
        arb: newResponse.arb,
        company_type: newResponse.company_type,
        corp_action: newResponse.corp_action,
        market_data: newResponse.market_data,
        auto_reject_estimation: newResponse.auto_reject_estimation
    };
};
var checkShowTableByType = function() {
    var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var showTable = [
        global_Securities_types_stockType__WEBPACK_IMPORTED_MODULE_1__/* .StockType.Saham */ .Z.Saham,
        global_Securities_types_stockType__WEBPACK_IMPORTED_MODULE_1__/* .StockType.Right */ .Z.Right,
        global_Securities_types_stockType__WEBPACK_IMPORTED_MODULE_1__/* .StockType.Waran */ .Z.Waran,
        global_Securities_types_stockType__WEBPACK_IMPORTED_MODULE_1__/* .StockType.Etf */ .Z.Etf, 
    ].includes(type.toLowerCase());
    return showTable;
};


/***/ }),

/***/ 25516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AlertErrorMessage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 1 modules
var message = __webpack_require__(12461);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/AlertErrorMessage/styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: 50%;\n  margin-right: 10px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var IconWrapper = (0,styled_components_browser_esm/* default */.ZP)(Iconmoon/* IconWrapper */.a).withConfig({
    componentId: "sc-1624a33f-0"
})(_templateObject(), color/* default.primary */.Z.primary);
// eslint-disable-next-line import/prefer-default-export


;// CONCATENATED MODULE: ./src/global/AlertErrorMessage/index.js
/* eslint-disable max-len */ 







/**
 * handleErrorMessageAPI to activate message
 * @param {string} content
 * @param {string} type - "alert-green" | "alert-red" | "alert-orange" | "alert-blue" | "snackbar-green" | "plain-green"
 * @param {=boolean} hasCloseIcon
 */ var handleErrorMessageAPI = function(content, type) {
    var hasCloseIcon = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!(0,app/* isClient */.C5)()) return null;
    // destroy last message alert
    message/* default.destroy */.ZP.destroy();
    var Icon = null;
    var closeIcon = hasCloseIcon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
        src: "/icon/alert-close.svg",
        onClick: function() {
            return message/* default.destroy */.ZP.destroy();
        }
    }) : null;
    if (type === "alert-green") {
        Icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                size: "14px",
                className: "icon-toolbar_check",
                color: color/* default.light */.Z.light
            })
        });
    } else if (type === "snackbar-green") {
        Icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: "/icon/alert-success.svg"
        });
    }
    // show alert
    message/* default.open */.ZP.open({
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: type,
            "data-cy": "global-alert-message",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "center",
                children: [
                    Icon,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: content
                    }),
                    closeIcon
                ]
            })
        }),
        duration: 3,
        style: {
            top: "50px",
            fontFamily: "ProximaNovaRg",
            left: 0,
            margin: "auto",
            position: "fixed",
            right: 0,
            maxWidth: "320px"
        },
        className: "sysmsg-content",
        onClick: function() {
            return message/* default.destroy */.ZP.destroy();
        }
    });
    return null;
};
/* harmony default export */ var AlertErrorMessage = (handleErrorMessageAPI);


/***/ }),

/***/ 6430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12461);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(579);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25935);





var alertIcon = {
    success: "alert-success.svg",
    warning: "alert-warning.svg",
    info: "alert-info.svg",
    error: "alert-error.svg"
};
function alertMessage(param) {
    var content = param.content, messageType = param.messageType, alertType = param.alertType, _hasCloseIcon = param.hasCloseIcon, hasCloseIcon = _hasCloseIcon === void 0 ? false : _hasCloseIcon, _duration = param.duration, duration = _duration === void 0 ? 3 : _duration, _onCloseHandler = param.onCloseHandler, onCloseHandler = _onCloseHandler === void 0 ? function() {} : _onCloseHandler;
    antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"].destroy */ .ZP.destroy();
    var Icon = null;
    if (alertType === "snackbar" || alertType === "snackbar-dark") {
        Icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            src: "/icon/".concat(alertIcon[messageType])
        });
    }
    var closeIcon = hasCloseIcon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: "notif-close-icon",
        src: "/icon/alert-close.svg",
        onClick: function() {
            return antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"].destroy */ .ZP.destroy();
        }
    }) : null;
    antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"].open */ .ZP.open({
        type: messageType,
        content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "message-".concat(messageType, " alert-").concat(alertType),
            "data-cy": "global-alert-message",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                align: "center",
                children: [
                    Icon,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: typeof content === "string" ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(content) : ""
                    }),
                    closeIcon
                ]
            })
        }),
        duration: duration,
        style: {
            top: "50px",
            fontFamily: "ProximaNovaRg",
            left: 0,
            margin: "auto",
            position: "fixed",
            right: 0
        },
        icon: null,
        className: "sysmsg-alert",
        onClick: function() {
            return antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"].destroy */ .ZP.destroy();
        },
        onClose: onCloseHandler
    });
    return null;
}
/* harmony default export */ __webpack_exports__["Z"] = (alertMessage);


/***/ }),

/***/ 66620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useLivePriceStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14671);



var livePriceState = {
    symbols: {}
};
var livePriceActions = function(set) {
    return {
        setLivePriceSymbols: function(key, symbols) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.symbols[key] = symbols.filter(function(v, i, a) {
                        return a.indexOf(v) === i;
                    });
                });
            });
        }
    };
};
var useLivePriceStore = (0,zustand__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(function(set, get, store, storeMutation) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, livePriceState, livePriceActions(set, get, store, storeMutation));
});


/***/ }),

/***/ 25288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useMarketMoverStore; }
/* harmony export */ });
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);


var useMarketMoverStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return {
        request: {},
        setMoverRequest: function(key, value) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(state, function(draft) {
                    if (!value) delete draft.request[key];
                    else draft.request[key] = value;
                });
            });
        }
    };
});


/***/ }),

/***/ 23782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useOrderbookStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14671);



var orderbookState = {
    symbols: {}
};
var orderbookActions = function(set) {
    return {
        setOrderbookSymbols: function(key, symbols) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.symbols[key] = symbols.filter(function(v, i, a) {
                        return a.indexOf(v) === i;
                    });
                });
            });
        }
    };
};
var useOrderbookStore = (0,zustand__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(function(set, get, store, storeMutation) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, orderbookState, orderbookActions(set, get, store, storeMutation));
});


/***/ }),

/***/ 87637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ DatafeedContext; },
  "l": function() { return /* binding */ DatafeedProvider; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/utils/auth.js + 1 modules
var auth = __webpack_require__(19225);
// EXTERNAL MODULE: ./src/lib/api/ws.ts
var ws = __webpack_require__(66679);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./node_modules/@stockbitgroup/protos/securities/transactional/datafeed/v1/websocket_pb.js + 13 modules
var websocket_pb = __webpack_require__(84);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
;// CONCATENATED MODULE: ./src/global/Datafeed/store/index.ts



var datafeedState = {
    channel: {},
    error: undefined
};
var datafeedActions = function(set) {
    return {
        setChannel: function(value) {
            set(function(state) {
                return (0,immer_esm/* default */.ZP)(state, function(draft) {
                    draft.channel = (0,_object_spread/* default */.Z)({}, draft.channel, value);
                });
            });
        },
        setError: function(value) {
            set(function(state) {
                return (0,immer_esm/* default */.ZP)(state, function(draft) {
                    draft.error = value;
                });
            });
        }
    };
};
var useDatafeedStore = (0,esm/* default */.ZP)(function(set, get, store, storeMutation) {
    return (0,_object_spread/* default */.Z)({}, datafeedState, datafeedActions(set, get, store, storeMutation));
});

// EXTERNAL MODULE: ./src/global/Datafeed/UseLivePrice/liveprice.store.ts
var liveprice_store = __webpack_require__(66620);
// EXTERNAL MODULE: ./src/global/Datafeed/UseOrderbook/orderbook.store.ts
var orderbook_store = __webpack_require__(23782);
// EXTERNAL MODULE: ./src/global/Datafeed/UseMarketMover/marketmover.store.ts
var marketmover_store = __webpack_require__(25288);
// EXTERNAL MODULE: ./src/global/Datafeed/store/runningTrade/index.ts
var runningTrade = __webpack_require__(90094);
;// CONCATENATED MODULE: ./src/global/Datafeed/index.tsx



















var DatafeedContext = /*#__PURE__*/ (0,react.createContext)(undefined);
var MAX_RECONNECT_COUNTER = 5;
var routesBlacklist = [
    "/logout"
];
var DatafeedProvider = function(param) {
    var _heartbeatDuration = param.heartbeatDuration, heartbeatDuration = _heartbeatDuration === void 0 ? 10000 : _heartbeatDuration, isLoggedIn = param.isLoggedIn, children = param.children;
    var router = (0,next_router.useRouter)();
    var socket = (0,react.useRef)();
    var actionsRef = (0,react.useRef)({});
    var reconnectCounter = (0,react.useRef)(1);
    var isLoggedInRef = (0,react.useRef)(false);
    var authRetries = (0,react.useRef)(0);
    var ref = (0,react.useState)(), authToken = ref[0], setAuthToken = ref[1];
    var ref1 = (0,react.useState)(false), isSocketConnected = ref1[0], setConnectionStatus = ref1[1];
    var isBlacklisted = (0,react.useMemo)(function() {
        return routesBlacklist.includes(router.pathname);
    }, [
        router.pathname
    ]);
    var ref2 = useDatafeedStore(function(state) {
        return {
            setChannel: state.setChannel,
            setError: state.setError,
            error: state.error,
            channel: state.channel
        };
    }), setChannel = ref2.setChannel, setError = ref2.setError, error = ref2.error, channel = ref2.channel;
    var livePriceStoreSymbols = (0,liveprice_store/* useLivePriceStore */.H)(function(s) {
        return s.symbols;
    });
    var orderbookStoreSymbols = (0,orderbook_store/* useOrderbookStore */.a)(function(s) {
        return s.symbols;
    });
    var marketMoverList = (0,marketmover_store/* useMarketMoverStore */.x)(function(s) {
        return s.request;
    });
    var rtSymbols = (0,runningTrade/* useRunningTradeStore */.C)(function(s) {
        return s.getSymbols();
    });
    var initSocket = function() {
        setAuthToken(undefined);
        socket.current = new WebSocket("wss://wss-trading.stockbit.com/ws");
        socket.current.binaryType = "arraybuffer";
        // eslint-disable-next-line no-use-before-define
        socket.current.addEventListener("open", handleAuth, {
            once: true
        });
        // eslint-disable-next-line no-use-before-define
        socket.current.addEventListener("close", handleReconnection, {
            once: true
        });
        window.datafeedSocket = socket.current;
    };
    var resetSocket = function() {
        var ref;
        if (((ref = socket.current) === null || ref === void 0 ? void 0 : ref.readyState) !== WebSocket.CLOSED) {
            var ref1;
            (ref1 = socket.current) === null || ref1 === void 0 ? void 0 : ref1.close();
        }
        socket.current = undefined;
        window.datafeedSocket = undefined;
        setAuthToken(undefined);
    };
    var sendMessageChannel = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(authToken_, messageChannel) {
            var ref, ref1, ref2, userId, buffer;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!(!socket.current || ((ref = socket.current) === null || ref === void 0 ? void 0 : ref.readyState) !== WebSocket.OPEN)) {
                            _ctx.next = 4;
                            break;
                        }
                        ;
                        return _ctx.abrupt("return");
                    case 4:
                        ref2 = auth/* default.getUserAccess */.Z.getUserAccess(), userId = ref2.id;
                        buffer = new websocket_pb/* WebsocketRequest */.vC({
                            channel: messageChannel,
                            key: authToken_,
                            userId: userId
                        }).toBinary();
                        (ref1 = socket.current) === null || ref1 === void 0 ? void 0 : ref1.send(buffer);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(authToken_, messageChannel) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var sendPingHeartbeat = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, buffer;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!(!socket.current || ((ref = socket.current) === null || ref === void 0 ? void 0 : ref.readyState) !== WebSocket.OPEN)) {
                            _ctx.next = 4;
                            break;
                        }
                        ;
                        return _ctx.abrupt("return");
                    case 4:
                        buffer = new websocket_pb/* WebsocketRequest */.vC({
                            ping: {
                                message: "ping"
                            }
                        }).toBinary();
                        (ref1 = socket.current) === null || ref1 === void 0 ? void 0 : ref1.send(buffer);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function sendPingHeartbeat() {
            return _ref.apply(this, arguments);
        };
    }();
    var combinedChannel = (0,react.useMemo)(function() {
        var flattenedLivePriceStoreSymbols = Object.values(livePriceStoreSymbols).flat();
        var flattenedOrderbookStoreSymbols = Object.values(orderbookStoreSymbols).flat();
        var _liveprice, _orderBook;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, channel), {
            liveprice: Array.from(new Set((0,_to_consumable_array/* default */.Z)((_liveprice = channel.liveprice) !== null && _liveprice !== void 0 ? _liveprice : []).concat((0,_to_consumable_array/* default */.Z)(flattenedLivePriceStoreSymbols)))),
            orderBook: Array.from(new Set((0,_to_consumable_array/* default */.Z)((_orderBook = channel.orderBook) !== null && _orderBook !== void 0 ? _orderBook : []).concat((0,_to_consumable_array/* default */.Z)(flattenedOrderbookStoreSymbols)))),
            runningTradeBatch: rtSymbols,
            marketMover: Object.values(marketMoverList)
        });
    }, [
        channel,
        livePriceStoreSymbols,
        orderbookStoreSymbols,
        marketMoverList,
        rtSymbols, 
    ]);
    var handleSendChannel = (0,react.useCallback)(lodash_debounce_default()(sendMessageChannel, 100), []);
    var setAction = function(channelKey, actionKey, callbackFn) {
        actionsRef.current = (0,immer_esm/* default */.ZP)(actionsRef.current, function(draft) {
            if (!draft[channelKey]) draft[channelKey] = {};
            draft[channelKey][actionKey] = callbackFn;
        });
    };
    var removeAction = function(channelKey, actionKey) {
        actionsRef.current = (0,immer_esm/* default */.ZP)(actionsRef.current, function(draft) {
            var ref;
            if (draft === null || draft === void 0 ? void 0 : (ref = draft[channelKey]) === null || ref === void 0 ? void 0 : ref[actionKey]) delete draft[channelKey][actionKey];
        });
    };
    var handleUnauthorized = function(message) {
        if (authRetries.current > 3) {
            setError(message.error);
            return;
        }
        authRetries.current += 1;
        setAuthToken(undefined);
        // eslint-disable-next-line no-use-before-define
        handleAuth();
    };
    var handleErrorMessage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(message) {
            var ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        // Consider moving the error handling code to a separate 'utils' module
                        // if the amount of error handling logic is increasing
                        if ((message === null || message === void 0 ? void 0 : (ref = message.error) === null || ref === void 0 ? void 0 : ref.code) === 401) handleUnauthorized(message);
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleErrorMessage(message) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleMessage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(message) {
            var dataRaw, messageChannel, messageCase, value, decodedMessage;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dataRaw = websocket_pb/* WebsocketWrapMessageChannel.fromBinary */.iU.fromBinary(new Uint8Array(message.data));
                        messageChannel = dataRaw.messageChannel;
                        messageCase = messageChannel.case, value = messageChannel.value;
                        decodedMessage = (0,_define_property/* default */.Z)({}, messageCase, value);
                        if (decodedMessage === null || decodedMessage === void 0 ? void 0 : decodedMessage.error) handleErrorMessage(decodedMessage);
                        Object.keys(decodedMessage).forEach(function(messageChannelKey) {
                            Object.values(actionsRef.current[messageChannelKey] || {}).forEach(function(callbackFn) {
                                callbackFn(decodedMessage);
                            });
                        });
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleMessage(message) {
            return _ref.apply(this, arguments);
        };
    }();
    // handleHeartbeatMessage will only called when ping message available
    // filtered on handleMessage
    var handleHeartbeatMessage = function() {
        setTimeout(function() {
            return sendPingHeartbeat();
        }, heartbeatDuration);
    };
    var handleAuth = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, ref2, userId, data, bodyData, key, buffer;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        ref2 = auth/* default.getUserAccess */.Z.getUserAccess(), userId = ref2.id;
                        _ctx.next = 4;
                        return ws/* default.getWSTradingKey */.Z.getWSTradingKey();
                    case 4:
                        data = _ctx.sent.data;
                        bodyData = data.data;
                        key = bodyData.key;
                        buffer = new websocket_pb/* WebsocketRequest */.vC({
                            key: key,
                            userId: userId
                        }).toBinary();
                        if (((ref = socket.current) === null || ref === void 0 ? void 0 : ref.readyState) === WebSocket.OPEN) {
                            socket.current.send(buffer);
                        }
                        setAuthToken(key);
                        setAction("ping", "pingResponse", handleHeartbeatMessage);
                        sendPingHeartbeat();
                        (ref1 = socket.current) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("message", handleMessage);
                        setConnectionStatus(true);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleAuth() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleReconnection = function() {
        if (!isLoggedInRef.current) return;
        if (reconnectCounter.current > MAX_RECONNECT_COUNTER) {
            setError({
                code: 503,
                message: "Maximum reconnection"
            });
            return;
        }
        reconnectCounter.current += 1;
        setConnectionStatus(false);
        initSocket();
    };
    (0,react.useEffect)(function() {
        if (isBlacklisted) return;
        isLoggedInRef.current = isLoggedIn;
        if (!socket.current && isLoggedIn) initSocket();
        else if (socket.current && !isLoggedIn) resetSocket();
    }, [
        isLoggedIn,
        isBlacklisted
    ]);
    (0,react.useEffect)(function() {
        if (authToken) handleSendChannel(authToken, combinedChannel);
    }, [
        authToken,
        handleSendChannel,
        combinedChannel
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DatafeedContext.Provider, {
        value: {
            socket: socket.current,
            isSocketConnected: isSocketConnected,
            error: error,
            setChannel: setChannel,
            setAction: setAction,
            removeAction: removeAction,
            isAuthorized: !!authToken
        },
        children: children
    });
};


/***/ }),

/***/ 90094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ useRunningTradeStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36305);
/* harmony import */ var global_MainLayout_SideWidget_RunningTrade_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7365);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14671);






var initialInstance = {
    stock: {
        type: global_MainLayout_SideWidget_RunningTrade_types__WEBPACK_IMPORTED_MODULE_0__/* .StockFilterTypeEnum.AllStock */ .dC.AllStock,
        selected: []
    },
    isActive: false,
    isQueue: false,
    isPaused: false,
    filter: null,
    date: null
};
var useRunningTradeStore = (0,zustand__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(function(set, get) {
    return {
        instances: {
            company: initialInstance,
            widget: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, initialInstance), {
                stock: {
                    type: global_MainLayout_SideWidget_RunningTrade_types__WEBPACK_IMPORTED_MODULE_0__/* .StockFilterTypeEnum.AllStock */ .dC.AllStock,
                    selected: [
                        "*"
                    ]
                }
            }),
            fastOrder: initialInstance
        },
        setActive: function(key, value) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.instances[key].isActive = value;
                });
            });
        },
        setStock: function(key, value) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.instances[key].stock = value;
                    if (value.type === global_MainLayout_SideWidget_RunningTrade_types__WEBPACK_IMPORTED_MODULE_0__/* .StockFilterTypeEnum.AllStock */ .dC.AllStock || value.type === global_MainLayout_SideWidget_RunningTrade_types__WEBPACK_IMPORTED_MODULE_0__/* .StockFilterTypeEnum.Watchlist */ .dC.Watchlist || value.selected.length > 1) {
                        draft.instances[key].date = null;
                    }
                    state.play(key);
                });
            });
        },
        setFilter: function(key, value) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.instances[key].filter = value;
                });
            });
        },
        setDate: function(key, value) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.instances[key].date = value;
                });
            });
        },
        play: function(key) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.instances[key].isPaused = false;
                });
            });
        },
        pause: function(key) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.instances[key].isPaused = true;
                });
            });
        },
        getSymbols: function(key) {
            var ref, ref1;
            var instances = get().instances;
            if (key) return ((ref = instances[key]) === null || ref === void 0 ? void 0 : (ref1 = ref.stock) === null || ref1 === void 0 ? void 0 : ref1.selected) || [];
            var allSymbols = [];
            Object.values(instances).forEach(function(instance) {
                var ref;
                if (!instance.isActive) return;
                var symbols = ((ref = instance.stock) === null || ref === void 0 ? void 0 : ref.selected) || [];
                allSymbols = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(allSymbols).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(symbols));
            });
            return Array.from(new Set(allSymbols));
        }
    };
});


/***/ }),

/***/ 29658:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var If = function(param) {
    var children = param.children, condition = param.condition;
    if (!condition) {
        return null;
    }
    // render children if the condition is truthy
    return children;
};
/* harmony default export */ __webpack_exports__["Z"] = (If); /**
 * https://www.stefanjudis.com/snippets/a-react-if-component/
 *
 * Use the component as follows:
 *
 * <IF condition={condition}>
 *   <Greeter username={user.name} />
 * </IF>
 */ 


/***/ }),

/***/ 579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86123);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);





var Image = function(_param) {
    var src = _param.src, _alt = _param.alt, alt = _alt === void 0 ? "" : _alt, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "src",
        "alt"
    ]);
    var source = src || "";
    var isBlob = source.startsWith("blob:");
    var isBase64 = source.startsWith("data:");
    var isUrl = source.startsWith("http") || source.startsWith("//");
    if (source && !isUrl && !isBlob && !isBase64) {
        var separator = source.startsWith("/") ? "" : "/";
        source = "".concat(constants_app__WEBPACK_IMPORTED_MODULE_1__/* .assetPrefix */ .Vc).concat(separator).concat(source);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        src: source,
        alt: alt
    }, rest));
};
Image.defaultProps = {
    alt: ""
};
Image.propTypes = {
    src: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (Image);


/***/ }),

/***/ 7365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qz": function() { return /* binding */ RunningTradeCustomFilterActionEnum; },
/* harmony export */   "dC": function() { return /* binding */ StockFilterTypeEnum; },
/* harmony export */   "lZ": function() { return /* binding */ MarketBoardEnum; }
/* harmony export */ });
var RunningTradeCustomFilterActionEnum;
(function(RunningTradeCustomFilterActionEnum) {
    RunningTradeCustomFilterActionEnum[RunningTradeCustomFilterActionEnum["ALL"] = 0] = "ALL";
    RunningTradeCustomFilterActionEnum[RunningTradeCustomFilterActionEnum["BUY"] = 1] = "BUY";
    RunningTradeCustomFilterActionEnum[RunningTradeCustomFilterActionEnum["SELL"] = 2] = "SELL";
})(RunningTradeCustomFilterActionEnum || (RunningTradeCustomFilterActionEnum = {}));
var MarketBoardEnum;
(function(MarketBoardEnum) {
    MarketBoardEnum[MarketBoardEnum["ALL"] = 0] = "ALL";
    MarketBoardEnum[MarketBoardEnum["REGULAR"] = 1] = "REGULAR";
    MarketBoardEnum[MarketBoardEnum["NEGO"] = 3] = "NEGO";
    MarketBoardEnum[MarketBoardEnum["CASH"] = 2] = "CASH";
})(MarketBoardEnum || (MarketBoardEnum = {}));
var StockFilterTypeEnum;
(function(StockFilterTypeEnum) {
    StockFilterTypeEnum["Custom"] = "custom";
    StockFilterTypeEnum["AllStock"] = "allstock";
    StockFilterTypeEnum["Watchlist"] = "watchlist";
})(StockFilterTypeEnum || (StockFilterTypeEnum = {}));


/***/ }),

/***/ 73580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand_vanilla__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59148);



var initialState = {
    errorCode: null,
    errorMessage: "",
    errorType: ""
};
var mainLayoutStore = (0,zustand_vanilla__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setErrorCode: function(code) {
            var message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
            set({
                errorCode: code,
                errorMessage: message,
                errorType: type
            });
        },
        resetErrorCode: function() {
            set(initialState);
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (mainLayoutStore);


/***/ }),

/***/ 56644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ StockType; }
/* harmony export */ });
var StockType;
(function(StockType) {
    StockType["Saham"] = "saham";
    StockType["Right"] = "right";
    StockType["Waran"] = "waran";
    StockType["Index"] = "index";
    StockType["IndexAsing"] = "index_asing";
    StockType["Reksadana"] = "reksadana";
    StockType["Commodities"] = "commodities";
    StockType["Crypto"] = "crypto";
    StockType["Fx"] = "fx";
    StockType["Etf"] = "etf";
    StockType["Bond"] = "bond";
    StockType["FR"] = "fr";
})(StockType || (StockType = {}));


/***/ }),

/***/ 13114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$6": function() { return /* binding */ AcceptanceLanguageEnum; },
/* harmony export */   "RD": function() { return /* binding */ SubAccountType; },
/* harmony export */   "el": function() { return /* binding */ TnCFeaturesIDEnum; },
/* harmony export */   "go": function() { return /* binding */ SubAccountStatus; },
/* harmony export */   "hO": function() { return /* binding */ TnCFeatureIDEnum; },
/* harmony export */   "rO": function() { return /* binding */ TnCFeaturePersistMap; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var AcceptanceLanguageEnum;
(function(AcceptanceLanguageEnum) {
    AcceptanceLanguageEnum["BAHASA"] = "ID";
    AcceptanceLanguageEnum["ENGLISH"] = "EN";
})(AcceptanceLanguageEnum || (AcceptanceLanguageEnum = {}));
var TnCFeatureIDEnum;
(function(TnCFeatureIDEnum) {
    TnCFeatureIDEnum[TnCFeatureIDEnum["FEATURE_UNSPECIFIED"] = 0] = "FEATURE_UNSPECIFIED";
    TnCFeatureIDEnum[TnCFeatureIDEnum["FEATURE_TRADING_LIMIT"] = 1] = "FEATURE_TRADING_LIMIT";
})(TnCFeatureIDEnum || (TnCFeatureIDEnum = {}));
var SubAccountType;
(function(SubAccountType) {
    SubAccountType["DAY_TRADE"] = "SUB_ACCOUNT_TYPE_DAY_TRADE";
})(SubAccountType || (SubAccountType = {}));
var SubAccountStatus;
(function(SubAccountStatus) {
    SubAccountStatus["ACTIVE"] = "SUB_ACCOUNT_STATUS_ACTIVE";
})(SubAccountStatus || (SubAccountStatus = {}));
var TnCFeaturesIDEnum;
(function(TnCFeaturesIDEnum) {
    TnCFeaturesIDEnum["TRADING_LIMIT"] = "FEATURE_ID_TRADING_LIMIT";
    TnCFeaturesIDEnum["AUTO_ORDER"] = "FEATURE_ID_AUTO_ORDER";
    TnCFeaturesIDEnum["DAY_TRADE"] = "FEATURE_ID_DAY_TRADE";
    TnCFeaturesIDEnum["MULTI_PORTO"] = "FEATURE_ID_MULTIPLE_PORTFOLIO";
})(TnCFeaturesIDEnum || (TnCFeaturesIDEnum = {}));
var _obj;
var TnCFeaturePersistMap = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, TnCFeaturesIDEnum.TRADING_LIMIT, "tradingLimitTnc"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, TnCFeaturesIDEnum.AUTO_ORDER, "autoOrderTnc"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, TnCFeaturesIDEnum.DAY_TRADE, "dayTradeTnc"), _obj);


/***/ }),

/***/ 46895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useSecuritiesContext; },
/* harmony export */   "i": function() { return /* binding */ SecuritiesContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var SecuritiesContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    isAuthorized: false,
    token: undefined,
    socket: undefined,
    setChannel: function() {},
    setAction: function() {},
    removeAction: function() {}
});
var useSecuritiesContext = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SecuritiesContext);
    if (context === undefined) {
        throw new Error("useSecuritiesContext must be used within a SecuritiesProvider");
    }
    return context;
};



/***/ }),

/***/ 93313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bq": function() { return /* binding */ ERROR_CODE; },
/* harmony export */   "Dp": function() { return /* binding */ UPTIME; },
/* harmony export */   "FJ": function() { return /* binding */ SecuritiesMessageCase; },
/* harmony export */   "Ie": function() { return /* binding */ NetworkStatus; },
/* harmony export */   "LU": function() { return /* binding */ MAX_POLLING_ATTEMPTS; },
/* harmony export */   "Nl": function() { return /* binding */ HEARTBEAT_FACTOR; },
/* harmony export */   "S0": function() { return /* binding */ DATA_ACTION; },
/* harmony export */   "aG": function() { return /* binding */ RECONNECT_INTERVAL; },
/* harmony export */   "al": function() { return /* binding */ HEARTBEAT_INTERVAL; },
/* harmony export */   "kQ": function() { return /* binding */ ReadyState; },
/* harmony export */   "pm": function() { return /* binding */ MAX_RECONNECT_ATTEMPTS; }
/* harmony export */ });
var RECONNECT_INTERVAL = 30000; // 30 seconds
var HEARTBEAT_INTERVAL = 15000; // 15 seconds
var HEARTBEAT_FACTOR = 1.5; // 1.5 times the heartbeat interval
var MAX_RECONNECT_ATTEMPTS = 3;
var MAX_POLLING_ATTEMPTS = 50;
var UPTIME = 2000; // 2 seconds
var SecuritiesMessageCase = {
    SUMMARY: "portfolioSummary",
    PORTFOLIO_LIST: "portfolioList",
    PORTFOLIO_DETAIL: "portfolioDetail",
    PORTFOLIO_DETAIL_DAY_TRADE: "portfolioDetailDayTrade",
    ORDER_LIST: "orderList",
    ORDER_DETAIL: "orderDetail"
};
var DATA_ACTION = {
    UPSERT: 1,
    DELETE: 2
};
var ERROR_CODE;
(function(ERROR_CODE) {
    ERROR_CODE[ERROR_CODE["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    ERROR_CODE[ERROR_CODE["FORBIDDEN"] = 403] = "FORBIDDEN";
    ERROR_CODE[ERROR_CODE["NOT_FOUND"] = 404] = "NOT_FOUND";
    ERROR_CODE[ERROR_CODE["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
})(ERROR_CODE || (ERROR_CODE = {}));
var ReadyState;
(function(ReadyState) {
    ReadyState[ReadyState["UNINSTANTIATED"] = -1] = "UNINSTANTIATED";
    ReadyState[ReadyState["CONNECTING"] = 0] = "CONNECTING";
    ReadyState[ReadyState["OPEN"] = 1] = "OPEN";
    ReadyState[ReadyState["CLOSING"] = 2] = "CLOSING";
    ReadyState[ReadyState["CLOSED"] = 3] = "CLOSED";
})(ReadyState || (ReadyState = {}));
var NetworkStatus;
(function(NetworkStatus) {
    NetworkStatus["ONLINE"] = "online";
    NetworkStatus["OFFLINE"] = "offline";
})(NetworkStatus || (NetworkStatus = {}));


/***/ }),

/***/ 17985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jd": function() { return /* binding */ SecuritiesChannel; },
/* harmony export */   "e7": function() { return /* binding */ PayloadCase; }
/* harmony export */ });
/* unused harmony exports RequestCommand, RequestChannel */
var SecuritiesChannel;
(function(SecuritiesChannel) {
    SecuritiesChannel["PING"] = "ping";
    SecuritiesChannel["AUTH"] = "auth";
    SecuritiesChannel["SECURITIES"] = "securities";
})(SecuritiesChannel || (SecuritiesChannel = {}));
var PayloadCase;
(function(PayloadCase) {
    PayloadCase["COMMAND"] = "command";
    PayloadCase["SUBSCRIBE"] = "subscribe";
    PayloadCase["UNSUBSCRIBE"] = "unsubscribe";
})(PayloadCase || (PayloadCase = {}));
var RequestCommand;
(function(RequestCommand) {
    RequestCommand[RequestCommand["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    RequestCommand[RequestCommand["PING"] = 1] = "PING";
    RequestCommand[RequestCommand["AUTH"] = 2] = "AUTH";
})(RequestCommand || (RequestCommand = {}));
var RequestChannel;
(function(RequestChannel) {
    RequestChannel[RequestChannel["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    RequestChannel[RequestChannel["SECURITIES_LIVE_PORTO"] = 1] = "SECURITIES_LIVE_PORTO";
})(RequestChannel || (RequestChannel = {}));


/***/ }),

/***/ 46238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c$": function() { return /* binding */ createPingPayload; },
/* harmony export */   "y_": function() { return /* binding */ generateWSCookie; }
/* harmony export */ });
/* unused harmony exports getAccountNumber, createUint8Array, createSubscribePayload, createUnsubscribePayload */
/* harmony import */ var utils_securitiesLocalStorage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11763);
/* harmony import */ var _store_securities_store_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17985);


var getAccountNumber = function() {
    var accountNumber = securitiesLocalStorage.getSecuritiesAccountInfo().accountNumber;
    return accountNumber !== null && accountNumber !== void 0 ? accountNumber : null;
};
var createUint8Array = function(value) {
    var textEncoder = new TextEncoder();
    return textEncoder.encode(value);
};
var createPingPayload = function() {
    return {
        action: {
            case: _store_securities_store_types__WEBPACK_IMPORTED_MODULE_1__/* .PayloadCase.COMMAND */ .e7.COMMAND,
            value: 1
        },
        value: new Uint8Array()
    };
};
var createSubscribePayload = function(accountNumber) {
    return {
        action: {
            case: _store_securities_store_types__WEBPACK_IMPORTED_MODULE_1__/* .PayloadCase.SUBSCRIBE */ .e7.SUBSCRIBE,
            value: 1
        },
        value: createUint8Array(accountNumber)
    };
};
var createUnsubscribePayload = function(accountNumber) {
    return {
        action: {
            case: _store_securities_store_types__WEBPACK_IMPORTED_MODULE_1__/* .PayloadCase.UNSUBSCRIBE */ .e7.UNSUBSCRIBE,
            value: 1
        },
        value: createUint8Array(accountNumber)
    };
};
var generateWSCookie = function(value) {
    return "gen-websocket=".concat(value, "; domain=stockbit.com; path=/v1; Secure;");
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    createPingPayload: createPingPayload,
    createSubscribePayload: createSubscribePayload,
    createUnsubscribePayload: createUnsubscribePayload,
    generateWSCookie: generateWSCookie
});


/***/ }),

/***/ 47514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78372);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* harmony import */ var features_chartbit_TradingView_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51077);
/* eslint-disable no-undef */ 




var requestExodus = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"].noAlert */ .Z.noAlert;
var CHARTBIT_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/chartbit");
var ORDERBOOK_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/orderbook");
var getSearchCompany = function(query) {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/search"), {
        params: {
            keyword: query,
            type: "company",
            page: 0
        }
    });
};
var getInitialData = function(symbol) {
    return requestExodus.get("".concat(CHARTBIT_URL, "/initial/").concat(symbol));
};
var getDailyPriceData = function(_param) {
    var symbol = _param.symbol, from = _param.from, to = _param.to, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "symbol",
        "from",
        "to"
    ]);
    var params = {};
    if (from && to) {
        params = {
            from: from,
            to: to,
            limit: 0
        };
    }
    params = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, params, props);
    return requestExodus.get("".concat(CHARTBIT_URL, "/").concat(symbol, "/price/daily"), {
        params: params
    });
};
var getIntradayPriceData = function(_param) {
    var symbol = _param.symbol, from = _param.from, to = _param.to, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "symbol",
        "from",
        "to"
    ]);
    var params = {};
    if (from && to) {
        params = {
            from: from,
            to: to,
            limit: 0
        };
    }
    params = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, params, props);
    return requestExodus.get("".concat(CHARTBIT_URL, "/").concat(symbol, "/price/intraday"), {
        params: params
    });
};
var getEvents = function(param) {
    var symbol = param.symbol, from = param.from, to = param.to;
    return requestExodus.get("".concat(CHARTBIT_URL, "/chart/corpaction"), {
        params: {
            from: from,
            to: to,
            symbol: symbol
        }
    });
};
var getLayout = function(symbol) {
    return requestExodus.get("".concat(CHARTBIT_URL, "/").concat(symbol, "/layout"));
};
var saveLayout = function(symbol, drawing) {
    var normalizedDrawing = (0,features_chartbit_TradingView_utils__WEBPACK_IMPORTED_MODULE_2__/* .normalizeToSeriesId */ .Fj)(JSON.stringify(drawing));
    return requestExodus.post("".concat(CHARTBIT_URL, "/").concat(symbol, "/layout"), {
        content: normalizedDrawing
    });
};
var getChartTemplate = function() {
    return requestExodus.get("".concat(CHARTBIT_URL, "/template"));
};
var loadChartTemplate = function(id, symbol) {
    return requestExodus.get("".concat(CHARTBIT_URL, "/").concat(symbol, "/template/").concat(id));
};
var saveChartTemplate = function(name, content) {
    return requestExodus.post("".concat(CHARTBIT_URL, "/template"), {
        name: name,
        content: JSON.stringify(content)
    });
};
var deleteChartTemplate = function(id) {
    return requestExodus.delete("".concat(CHARTBIT_URL, "/template/").concat(id));
};
var getCustomIndicator = function(params) {
    return requestExodus.get("".concat(CHARTBIT_URL, "/custom/indicator"), {
        params: params
    });
};
var getMobileTokenData = function(token) {
    return requestExodus.get("".concat(CHARTBIT_URL, "/token/").concat(token, "/mobile"));
};
var getQuote = function(symbol) {
    return requestExodus.get("".concat(ORDERBOOK_URL, "/companies/").concat(symbol));
};
var getVersion = function() {
    return requestExodus.get("".concat(CHARTBIT_URL, "/version"));
};
var getUserSettings = function() {
    return requestExodus.get("/user-setting/configurations", {
        params: {
            user_setting_type: "1"
        }
    });
};
var saveUserSettings = function(param) {
    var content = param.content;
    return requestExodus.post("/user-setting/configurations", {
        content: content,
        user_setting_type: 1
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getSearchCompany: getSearchCompany,
    getDailyPriceData: getDailyPriceData,
    getIntradayPriceData: getIntradayPriceData,
    getInitialData: getInitialData,
    getEvents: getEvents,
    getLayout: getLayout,
    saveLayout: saveLayout,
    getChartTemplate: getChartTemplate,
    loadChartTemplate: loadChartTemplate,
    saveChartTemplate: saveChartTemplate,
    deleteChartTemplate: deleteChartTemplate,
    getCustomIndicator: getCustomIndicator,
    getMobileTokenData: getMobileTokenData,
    getQuote: getQuote,
    getVersion: getVersion,
    getUserSettings: getUserSettings,
    saveUserSettings: saveUserSettings
});


/***/ }),

/***/ 78372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);
/* harmony import */ var global_Securities_types_termsAndCondition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13114);


var exodusInstance = {
    defaultInstance: (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(),
    noAlert: (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(false),
    customUserAgent: (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(false, null, true),
    withLanguageInstance: function() {
        var language = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : global_Securities_types_termsAndCondition__WEBPACK_IMPORTED_MODULE_1__/* .AcceptanceLanguageEnum.BAHASA */ .$6.BAHASA, disableErrorAlert = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(disableErrorAlert, undefined, false, {
            "Accept-Language": language
        });
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (exodusInstance);


/***/ }),

/***/ 34737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A3": function() { return /* binding */ FLIPT_URL_HOST; },
/* harmony export */   "HZ": function() { return /* binding */ FLIPT_TOKEN; },
/* harmony export */   "Ii": function() { return /* binding */ FLIPT_CHARTBIT_NAMESPACE; },
/* harmony export */   "S3": function() { return /* binding */ FLIPT_DESKTOP_NAMESPACE; },
/* harmony export */   "Vr": function() { return /* binding */ FLIPT_CHARTBIT_TOKEN; },
/* harmony export */   "WQ": function() { return /* binding */ FLIPT_FINANCIAL_DATA_NAMESPACE; },
/* harmony export */   "ad": function() { return /* binding */ FLIPT_NAMESPACE; },
/* harmony export */   "g0": function() { return /* binding */ FLIPT_FINANCIAL_DATA_TOKEN; },
/* harmony export */   "uL": function() { return /* binding */ FLIPT_DESKTOP_TOKEN; }
/* harmony export */ });
// Environment variables
var _NEXT_PUBLIC_FLIPT_URL_HOST;
var FLIPT_URL_HOST = (_NEXT_PUBLIC_FLIPT_URL_HOST = "https://flipt.stockbit.com") !== null && _NEXT_PUBLIC_FLIPT_URL_HOST !== void 0 ? _NEXT_PUBLIC_FLIPT_URL_HOST : "";
var _NEXT_PUBLIC_FLIPT_NAMESPACE;
var FLIPT_NAMESPACE = (_NEXT_PUBLIC_FLIPT_NAMESPACE = "transaction") !== null && _NEXT_PUBLIC_FLIPT_NAMESPACE !== void 0 ? _NEXT_PUBLIC_FLIPT_NAMESPACE : "";
var _NEXT_PUBLIC_FLIPT_TOKEN;
var FLIPT_TOKEN = (_NEXT_PUBLIC_FLIPT_TOKEN = "3m1ehM_SYRRg0NDWbzixtn4O5ZcVWaaQW7ytx7NAm0A=") !== null && _NEXT_PUBLIC_FLIPT_TOKEN !== void 0 ? _NEXT_PUBLIC_FLIPT_TOKEN : undefined;
var _NEXT_PUBLIC_FLIPT_CHARTBIT_NAMESPACE;
var FLIPT_CHARTBIT_NAMESPACE = (_NEXT_PUBLIC_FLIPT_CHARTBIT_NAMESPACE = "chartbit") !== null && _NEXT_PUBLIC_FLIPT_CHARTBIT_NAMESPACE !== void 0 ? _NEXT_PUBLIC_FLIPT_CHARTBIT_NAMESPACE : "";
var _NEXT_PUBLIC_FLIPT_CHARTBIT_TOKEN;
var FLIPT_CHARTBIT_TOKEN = (_NEXT_PUBLIC_FLIPT_CHARTBIT_TOKEN = "N58pKzjn1zMJNwH5pGTOwy3-ufiL1Xdb0VQmRCl5kek=") !== null && _NEXT_PUBLIC_FLIPT_CHARTBIT_TOKEN !== void 0 ? _NEXT_PUBLIC_FLIPT_CHARTBIT_TOKEN : undefined;
var _NEXT_PUBLIC_FLIPT_FINANCIAL_DATA_TOKEN;
var FLIPT_FINANCIAL_DATA_TOKEN = (_NEXT_PUBLIC_FLIPT_FINANCIAL_DATA_TOKEN = "7BcKXp5uJ9xPlBrKLorMCGWnzM4zE6PoPkYXdh5iMys=") !== null && _NEXT_PUBLIC_FLIPT_FINANCIAL_DATA_TOKEN !== void 0 ? _NEXT_PUBLIC_FLIPT_FINANCIAL_DATA_TOKEN : undefined;
var _NEXT_PUBLIC_FLIPT_FINANCIAL_DATA_NAMESPACE;
var FLIPT_FINANCIAL_DATA_NAMESPACE = (_NEXT_PUBLIC_FLIPT_FINANCIAL_DATA_NAMESPACE = "financial-data") !== null && _NEXT_PUBLIC_FLIPT_FINANCIAL_DATA_NAMESPACE !== void 0 ? _NEXT_PUBLIC_FLIPT_FINANCIAL_DATA_NAMESPACE : "";
var _NEXT_PUBLIC_FLIPT_DESKTOP_TOKEN;
var FLIPT_DESKTOP_TOKEN = (_NEXT_PUBLIC_FLIPT_DESKTOP_TOKEN = "Kmho-j0dflXhQTvnnNA7y_tkuUN16W-Sg7pUo2hWPUg=") !== null && _NEXT_PUBLIC_FLIPT_DESKTOP_TOKEN !== void 0 ? _NEXT_PUBLIC_FLIPT_DESKTOP_TOKEN : undefined;
var _NEXT_PUBLIC_FLIPT_DESKTOP_NAMESPACE;
var FLIPT_DESKTOP_NAMESPACE = (_NEXT_PUBLIC_FLIPT_DESKTOP_NAMESPACE = "desktop-production") !== null && _NEXT_PUBLIC_FLIPT_DESKTOP_NAMESPACE !== void 0 ? _NEXT_PUBLIC_FLIPT_DESKTOP_NAMESPACE : "";


/***/ }),

/***/ 90060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ store_useFliptStore; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./src/stores/useUIConfigStore/index.ts + 1 modules
var useUIConfigStore = __webpack_require__(7639);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
// EXTERNAL MODULE: ./src/utils/auth.js + 1 modules
var auth = __webpack_require__(19225);
;// CONCATENATED MODULE: ./src/lib/flipt/constants/endpoints.ts
// endpoints
var endpoints = {
    evaluate: {
        boolean: "evaluate/v1/boolean",
        variant: "evaluate/v1/variant",
        batch: "evaluate/v1/batch"
    }
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/lib/flipt/constants/env.ts
var env = __webpack_require__(34737);
;// CONCATENATED MODULE: ./src/lib/flipt/instance.ts




var fliptApi = axios_default().create({
    baseURL: env/* FLIPT_URL_HOST */.A3,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
    }
});
fliptApi.interceptors.request.use(function(config) {
    if (env/* FLIPT_TOKEN */.HZ) {
        // eslint-disable-next-line no-param-reassign
        config.headers = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.headers), {
            Authorization: "Bearer ".concat(env/* FLIPT_TOKEN */.HZ)
        });
    }
    return config;
});
var fliptChartbitApi = axios_default().create({
    baseURL: env/* FLIPT_URL_HOST */.A3,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
    }
});
fliptChartbitApi.interceptors.request.use(function(config) {
    if (env/* FLIPT_CHARTBIT_TOKEN */.Vr) {
        // eslint-disable-next-line no-param-reassign
        config.headers = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.headers), {
            Authorization: "Bearer ".concat(env/* FLIPT_CHARTBIT_TOKEN */.Vr)
        });
    }
    return config;
});
var fliptFinancialDataApi = axios_default().create({
    baseURL: env/* FLIPT_URL_HOST */.A3,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
    }
});
fliptFinancialDataApi.interceptors.request.use(function(config) {
    if (env/* FLIPT_FINANCIAL_DATA_TOKEN */.g0) {
        // eslint-disable-next-line no-param-reassign
        config.headers = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.headers), {
            Authorization: "Bearer ".concat(env/* FLIPT_FINANCIAL_DATA_TOKEN */.g0)
        });
    }
    return config;
});
var fliptDesktopApi = axios_default().create({
    baseURL: env/* FLIPT_URL_HOST */.A3,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
    }
});
fliptDesktopApi.interceptors.request.use(function(config) {
    if (env/* FLIPT_DESKTOP_NAMESPACE */.S3) {
        // eslint-disable-next-line no-param-reassign
        config.headers = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.headers), {
            Authorization: "Bearer ".concat(env/* FLIPT_DESKTOP_TOKEN */.uL)
        });
    }
    return config;
});

;// CONCATENATED MODULE: ./src/lib/flipt/helpers.ts

var createEntityID = function(userId) {
    return "web-".concat(userId);
};
var createEvaluationPayload = function(userId, flagKey, namespaceKey) {
    return {
        context: {
            user_id: userId
        },
        entityId: createEntityID(userId),
        flagKey: flagKey,
        namespaceKey: namespaceKey !== null && namespaceKey !== void 0 ? namespaceKey : env/* FLIPT_NAMESPACE */.ad
    };
};

;// CONCATENATED MODULE: ./src/lib/flipt/endpoints.ts




var getService = function(service) {
    if (service === "chartbit") {
        return fliptChartbitApi;
    }
    if (service === "financial-data") {
        return fliptFinancialDataApi;
    }
    if (service.includes("desktop")) {
        return fliptDesktopApi;
    }
    return fliptApi;
};
// endpoints handlers
var evaluateBoolean = function(userId, flagKey, namespaceKey) {
    var api = namespaceKey ? getService(namespaceKey) : fliptApi;
    return api.post(endpoints.evaluate.boolean, createEvaluationPayload(userId, flagKey, namespaceKey !== null && namespaceKey !== void 0 ? namespaceKey : env/* FLIPT_NAMESPACE */.ad));
};
var evaluateVariant = function(userId, flagKey, namespaceKey) {
    var api = namespaceKey ? getService(namespaceKey) : fliptApi;
    return api.post(endpoints.evaluate.variant, createEvaluationPayload(userId, flagKey, namespaceKey !== null && namespaceKey !== void 0 ? namespaceKey : env/* FLIPT_NAMESPACE */.ad));
};

;// CONCATENATED MODULE: ./src/lib/flipt/store/useFliptStore.ts







var useFliptStore = (0,esm/* default */.ZP)(function(set, get) {
    return {
        setUserId: function setUserId(userId) {
            set({
                userId: userId ? String(userId) : undefined
            });
        },
        loadBooleanEvaluation: function loadBooleanEvaluation(flagKey, namespaceKey, enableGuest) {
            return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var ref, ref1, userId, ref2, getUIValue, setUIValue, featureFlags, namespace, response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            userId = get().userId || ((ref = auth/* default.getUserAccess */.Z.getUserAccess()) === null || ref === void 0 ? void 0 : (ref1 = ref.id) === null || ref1 === void 0 ? void 0 : ref1.toString()) || "guest";
                            if (!(userId === "guest" && !enableGuest)) {
                                _ctx.next = 6;
                                break;
                            }
                            // Return a rejected promise if user id is not found
                            // to prevent the function from continuing
                            (0,esm_exports/* addBreadcrumb */.n_)({
                                message: "Flipt:loadBooleanEvaluation: missing userId (guest user)",
                                category: "feature-flag",
                                level: "info",
                                data: {
                                    flagKey: flagKey,
                                    namespaceKey: namespaceKey
                                }
                            });
                            return _ctx.abrupt("return", false);
                        case 6:
                            ref2 = useUIConfigStore/* default.getState */.Z.getState(), getUIValue = ref2.getUIValue, setUIValue = ref2.setUIValue;
                            featureFlags = getUIValue("featureFlags");
                            if (!(featureFlags && featureFlags[flagKey])) {
                                _ctx.next = 10;
                                break;
                            }
                            return _ctx.abrupt("return", featureFlags[flagKey].isEnabled);
                        case 10:
                            namespace = namespaceKey !== null && namespaceKey !== void 0 ? namespaceKey : "transaction";
                            _ctx.next = 13;
                            return evaluateBoolean(userId, flagKey, namespace);
                        case 13:
                            response = _ctx.sent;
                            setUIValue("featureFlags", function(draft) {
                                draft[flagKey] = {
                                    isEnabled: response.data.enabled
                                };
                            });
                            return _ctx.abrupt("return", response.data.enabled);
                        case 18:
                            _ctx.prev = 18;
                            _ctx.t0 = _ctx["catch"](0);
                            (0,esm_exports/* captureException */.Tb)(_ctx.t0, {
                                tags: {
                                    action: "Flipt:loadBooleanEvaluation",
                                    flagKey: flagKey,
                                    namespaceKey: namespaceKey
                                }
                            });
                            return _ctx.abrupt("return", false);
                        case 22:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        18
                    ]
                ]);
            }))();
        },
        loadVariantEvaluation: function loadVariantEvaluation(flagKey, namespaceKey) {
            return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var ref, ref1, userId, setUIValue, response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            userId = get().userId || ((ref = auth/* default.getUserAccess */.Z.getUserAccess()) === null || ref === void 0 ? void 0 : (ref1 = ref.id) === null || ref1 === void 0 ? void 0 : ref1.toString()) || "guest";
                            if (!(userId === "guest")) {
                                _ctx.next = 6;
                                break;
                            }
                            // Return a rejected promise if user id is not found
                            // to prevent the function from continuing
                            (0,esm_exports/* addBreadcrumb */.n_)({
                                message: "Flipt:loadVariantEvaluation: missing userId (guest user)",
                                category: "feature-flag",
                                level: "info",
                                data: {
                                    flagKey: flagKey,
                                    namespaceKey: namespaceKey
                                }
                            });
                            return _ctx.abrupt("return", false);
                        case 6:
                            setUIValue = useUIConfigStore/* default.getState */.Z.getState().setUIValue;
                            _ctx.next = 9;
                            return evaluateVariant(userId, flagKey, namespaceKey);
                        case 9:
                            response = _ctx.sent;
                            setUIValue("featureFlags", function(draft) {
                                draft[flagKey] = {
                                    variance: response.data
                                };
                            });
                            return _ctx.abrupt("return", response.data);
                        case 14:
                            _ctx.prev = 14;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                            return _ctx.abrupt("return", false);
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        14
                    ]
                ]);
            }))();
        }
    };
});
/* harmony default export */ var store_useFliptStore = (useFliptStore);


/***/ }),

/***/ 76260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand_vanilla__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59148);



var initialState = {
    errorCode: 0,
    errorMessage: "",
    errorType: ""
};
var tradingStore = (0,zustand_vanilla__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setErrorCode: function(code) {
            var message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
            set({
                errorCode: code,
                errorMessage: message,
                errorType: type
            });
        },
        resetErrorCode: function() {
            set(initialState);
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (tradingStore);


/***/ }),

/***/ 19225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ auth; }
});

// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isAfter/index.js
var isAfter = __webpack_require__(42699);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(57632);
;// CONCATENATED MODULE: ./src/constants/cookies.js
var ACCESS_TOKEN_KEY = "access_token";
var ACCESS_TOKEN_KEY_EXP = "access_token_exp";
var REFRESH_TOKEN_KEY = "refresh_token";
var REFRESH_TOKEN_KEY_EXP = "refresh_token_exp";
var ACCESS_USER_KEY = "access_user";
/*  securities/trading related cookies */ var TRADING_ACCESS_TOKEN = "securities_access_token";
var TRADING_REFRESH_TOKEN = "securities_refresh_token";
var TRADE_IS_LOGGED_IN = "trade_is_logged_in";
var TRADING_ACCOUNT_TYPE = "trading_account_type";
var LAST_TRADING_ACCOUNT_TYPE = "last_trading_account_type";
var TRADING_BROKER = "stockbit";
var PLAYER_ID = "player-id";


// EXTERNAL MODULE: ./src/constants/localstorage.js
var localstorage = __webpack_require__(44252);
// EXTERNAL MODULE: ./src/features/orderbook/utils.ts
var utils = __webpack_require__(51346);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
;// CONCATENATED MODULE: ./src/utils/auth.js







function getToken() {
    if (!(0,app/* isClient */.C5)()) {
        return {
            accessToken: {
                token: null,
                expiry: null,
                isValid: null
            },
            refresh: {
                token: null,
                expiry: null,
                isValid: null
            }
        };
    }
    var ls = localStorage;
    // set cookies
    // format date from backend is still in seconds, while
    // JS' date is in miliseconds format, thus multiply the date by 1000
    var accessToken = ls[localstorage/* ACCESS_TOKEN_KEY */.Wx] ? (0,general/* decodeBase64ToJS */.OB)(ls[localstorage/* ACCESS_TOKEN_KEY */.Wx]) : null;
    var accessTokenExp = ls[localstorage/* ACCESS_TOKEN_KEY_EXP */.z0] ? parseInt((0,general/* decodeBase64ToJS */.OB)(ls[localstorage/* ACCESS_TOKEN_KEY_EXP */.z0]), 10) : null;
    var refreshToken = ls[localstorage/* REFRESH_TOKEN_KEY */.w4] ? (0,general/* decodeBase64ToJS */.OB)(ls[localstorage/* REFRESH_TOKEN_KEY */.w4]) : null;
    var refreshTokenExp = ls[localstorage/* REFRESH_TOKEN_KEY_EXP */.Nv] ? parseInt((0,general/* decodeBase64ToJS */.OB)(ls[localstorage/* REFRESH_TOKEN_KEY_EXP */.Nv]), 10) : null;
    // check expiry
    var currentTime = Date.now();
    var isAccessTokenValid = (0,isAfter/* default */.Z)(accessTokenExp, currentTime);
    var isRefreshTokenValid = (0,isAfter/* default */.Z)(refreshTokenExp, currentTime);
    return {
        accessToken: {
            token: accessToken,
            expiry: accessTokenExp,
            isValid: isAccessTokenValid
        },
        refresh: {
            token: refreshToken,
            expiry: refreshTokenExp,
            isValid: isRefreshTokenValid
        }
    };
}
function saveToken(param) {
    var accessToken = param.accessToken, accessTokenExp = param.accessTokenExp, refreshToken = param.refreshToken, refreshTokenExp = param.refreshTokenExp, accessUser = param.accessUser;
    if (!(0,app/* isClient */.C5)()) {
        return;
    }
    if (accessUser) {
        localStorage[localstorage/* ACCESS_USER_KEY */.ns] = (0,general/* encodeBase64FromJS */.me)(accessUser);
    }
    localStorage[localstorage/* ACCESS_TOKEN_KEY */.Wx] = (0,general/* encodeBase64FromJS */.me)(accessToken);
    localStorage[localstorage/* ACCESS_TOKEN_KEY_EXP */.z0] = (0,general/* encodeBase64FromJS */.me)(accessTokenExp.toString());
    localStorage[localstorage/* REFRESH_TOKEN_KEY */.w4] = (0,general/* encodeBase64FromJS */.me)(refreshToken);
    localStorage[localstorage/* REFRESH_TOKEN_KEY_EXP */.Nv] = (0,general/* encodeBase64FromJS */.me)(refreshTokenExp.toString());
}
function updateAccessUser(accessUser) {
    if ((0,app/* isClient */.C5)()) {
        localStorage[localstorage/* ACCESS_USER_KEY */.ns] = (0,general/* encodeBase64FromJS */.me)(accessUser);
    }
}
function destroyToken() {
    if ((0,app/* isClient */.C5)()) {
        localStorage.removeItem(localstorage/* ACCESS_USER_KEY */.ns);
        localStorage.removeItem(localstorage/* ACCESS_TOKEN_KEY */.Wx);
        localStorage.removeItem(localstorage/* ACCESS_TOKEN_KEY_EXP */.z0);
        localStorage.removeItem(localstorage/* REFRESH_TOKEN_KEY */.w4);
        localStorage.removeItem(localstorage/* REFRESH_TOKEN_KEY_EXP */.Nv);
        localStorage.removeItem("stbx-active-indexwatchlist");
        localStorage.removeItem("stbx-active-watchlist");
        localStorage.removeItem("stbx-active-widget");
        localStorage.removeItem("stbx-active-stream-header");
        localStorage.removeItem("stbx-active-stream");
        localStorage.removeItem("trade-orderbook-show-confirmation");
        localStorage.removeItem("tradeIsLogin");
        localStorage.removeItem("tradingVersion");
        localStorage.removeItem("tradingAccountType");
        localStorage.removeItem("taps");
        localStorage.removeItem("tradingBroker");
        localStorage.removeItem("lastTradingAccountType");
        localStorage.removeItem("register_trading_useractive_sinarmas");
        localStorage.removeItem("register_trading_sinarmas");
        localStorage.removeItem("register_trading_useractive");
        localStorage.removeItem("tradingBrokerList");
        localStorage.removeItem("financials-panel-amount");
        localStorage.removeItem("financials-panel-currency");
        localStorage.removeItem("financials-panel-datatype");
        localStorage.removeItem("financials-panel-lang");
        localStorage.removeItem("financials-panel-ordertype");
        localStorage.removeItem("financials-panel-reportype");
        localStorage.removeItem("financials-panel-rounding-count");
        localStorage.removeItem("financials-panel-rounding-symbol");
        localStorage.removeItem("financials-panel-statetype");
        localStorage.removeItem("crisp");
        localStorage.removeItem("formula");
        localStorage.removeItem("stbx-active-trending-date");
        localStorage.removeItem("ws");
        utils/* localStorageOrderbookHandler.remove */.Ku.remove();
        localStorage.removeItem("orderbooklistID");
        localStorage.removeItem("orderbooklistName");
    }
}
/**
 * getUserAccess
 * to get user data from auth login
 * @param {*} ctx
 */ function getUserAccess() {
    return (0,app/* isClient */.C5)() && localStorage && localStorage[localstorage/* ACCESS_USER_KEY */.ns] ? (0,general/* decodeBase64ToJS */.OB)(localStorage[localstorage/* ACCESS_USER_KEY */.ns]) : {};
}
var setLocalCrispSettings = function(crisp) {
    localStorage.location = window.location.origin;
    localStorage.crisp = (0,general/* encodeBase64FromJS */.me)(crisp);
};
var setLocalIntercomSettings = function(intercom) {
    localStorage.location = window.location.origin;
    localStorage.intercom = (0,general/* encodeBase64FromJS */.me)(intercom);
};
var isLoggedIn = function() {
    return (0,app/* isClient */.C5)() && Boolean(localStorage === null || localStorage === void 0 ? void 0 : localStorage.at);
};
var getPlayerId = function(req) {
    var playerId = (req === null || req === void 0 ? void 0 : req.cookies[PLAYER_ID]) || (0,v4/* default */.Z)();
    return playerId;
};
/* harmony default export */ var auth = ({
    isLoggedIn: isLoggedIn,
    getToken: getToken,
    saveToken: saveToken,
    destroyToken: destroyToken,
    getUserAccess: getUserAccess,
    updateAccessUser: updateAccessUser,
    setLocalCrispSettings: setLocalCrispSettings,
    setLocalIntercomSettings: setLocalIntercomSettings,
    getPlayerId: getPlayerId
});


/***/ }),

/***/ 48028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$b": function() { return /* binding */ clevertapProfilingUser; },
/* harmony export */   "Lq": function() { return /* binding */ clevertapEvent; },
/* harmony export */   "QU": function() { return /* binding */ clevertapInitProfileQueue; },
/* harmony export */   "Vg": function() { return /* binding */ clearClevertapState; },
/* harmony export */   "nh": function() { return /* binding */ academyUserProfiling; },
/* harmony export */   "ze": function() { return /* binding */ academyEventAnalytic; }
/* harmony export */ });
/* unused harmony export clevertapProfilingUserEligible */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86123);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91635);
/* eslint-disable no-underscore-dangle */ 


var clevertapProfileQueue = [];
function clevertapInitProfileQueue() {
    clevertapProfileQueue.forEach(function(instance) {
        return instance();
    });
    clevertapProfileQueue = [];
}
/**
 * this function will executes clevertap analytic based on isInitProfile
 * @param {boolean} isInitProfile
 * @param {string} username
 * @param {boolean} isVirtualTrading
 * @param {boolean} isTopUser
 * @param {boolean} isVerifiedUser
 * @param {boolean} isStockbitPro
 * @param {Date} registrationStartDate
 * @param {string} profilePictureUrl
 * @param {boolean} isSinarmasSecuritas
 * @param {string} email
 * @param {isStockbitSecuritas} isStockbitSecuritas
 * @return {void} no return after execute this function
 */ function clevertapProfilingUser(param) {
    var isInitProfile = param.isInitProfile, identity = param.identity, isVirtualTrading = param.isVirtualTrading, isTopUser = param.isTopUser, isVerifiedUser = param.isVerifiedUser, isStockbitPro = param.isStockbitPro, registrationStartDate = param.registrationStartDate, profilePictureUrl = param.profilePictureUrl, isSinarmasSecuritas = param.isSinarmasSecuritas, email = param.email, isStockbitSecuritas = param.isStockbitSecuritas, _isEmitenUser = param.isEmitenUser, isEmitenUser = _isEmitenUser === void 0 ? false : _isEmitenUser;
    // Track if username is empty
    if (!identity) {
        (0,_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(new Error("[CT initialization Error]: username is empty"), {
            place: "src/utils/clevertap.ts",
            event: "clevertapProfilingUser",
            eventParam: {
                profile: {
                    identity: identity,
                    email: email
                }
            }
        });
    }
    var clevertapProfilingData = {
        Name: identity,
        Identity: identity,
        "Is Virtual Trading": isVirtualTrading !== undefined ? isVirtualTrading : undefined,
        "Is Top User": isTopUser !== undefined ? isTopUser : undefined,
        "Is Verified User": isVerifiedUser !== undefined ? isVerifiedUser : undefined,
        "Is Stockbit Pro": isStockbitPro !== undefined ? isStockbitPro : undefined,
        "Registration Start Date": registrationStartDate !== undefined ? registrationStartDate : undefined,
        Photo: profilePictureUrl !== undefined ? "".concat(constants_app__WEBPACK_IMPORTED_MODULE_0__/* .AWS_AVATAR_BUCKET */ .cU, "/").concat(profilePictureUrl) : undefined,
        "Is Sinarmas Sekuritas": isSinarmasSecuritas !== undefined ? isSinarmasSecuritas : undefined,
        Email: email !== undefined ? email : undefined,
        "Is Stockbit Sekuritas": isStockbitSecuritas !== undefined ? isStockbitSecuritas : undefined,
        "Is Emiten User": isEmitenUser !== undefined ? isEmitenUser : undefined
    };
    // filter to remove undefined value of object
    var payload = Object.keys(clevertapProfilingData).reduce(function(acc, key) {
        var _acc = acc;
        if (clevertapProfilingData[key] !== undefined) {
            _acc[key] = clevertapProfilingData[key];
        }
        return _acc;
    }, {});
    var handleInitProfile = function() {
        var ref;
        (ref = window.clevertap) === null || ref === void 0 ? void 0 : ref.onUserLogin.push({
            Site: payload
        });
    };
    var handleProfilePush = function() {
        var ref;
        (ref = window.clevertap) === null || ref === void 0 ? void 0 : ref.profile.push({
            Site: payload
        });
    };
    var initProfileFunction = isInitProfile ? handleInitProfile : handleProfilePush;
    if (!window.clevertap) {
        clevertapProfileQueue.push(initProfileFunction);
        return;
    }
    initProfileFunction();
}
function clevertapEvent(eventName) {
    var eventObject = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (Object.keys(eventObject).length > 0) {
        var // execute this impression if impression has additional attributes
        ref, ref1;
        (ref = window.clevertap) === null || ref === void 0 ? void 0 : (ref1 = ref.event) === null || ref1 === void 0 ? void 0 : ref1.push(eventName, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, eventObject));
    } else {
        var ref2, ref3;
        (ref2 = window.clevertap) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.event) === null || ref3 === void 0 ? void 0 : ref3.push(eventName);
    }
}
function clevertapProfilingUserEligible(param) {
    var followers = param.followers, following = param.following, posts = param.posts, isMuted = param.isMuted, isVerifiedEligible = param.isVerifiedEligible;
    var clevertapProfilingDataEligible = {
        Followers: followers !== undefined ? followers : undefined,
        Following: following !== undefined ? following : undefined,
        Posts: posts !== undefined ? posts : undefined,
        "is Muted": isMuted !== undefined ? isMuted : undefined,
        "Is Verified Badge Eligible": isVerifiedEligible !== undefined ? isVerifiedEligible : undefined
    };
    // filter to remove undefined value of object
    var payload = Object.keys(clevertapProfilingDataEligible).reduce(function(acc, key) {
        var _acc = acc;
        if (clevertapProfilingDataEligible[key] !== undefined) {
            _acc[key] = clevertapProfilingDataEligible[key];
        }
        return _acc;
    }, {});
    window.clevertap.profile.push({
        Site: payload
    });
}
function academyEventAnalytic(eventName, parameter) {
    if (!eventName) {
        return;
    }
    clevertapEvent(eventName, parameter);
}
function academyUserProfiling() {
    var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : undefined;
    var ref;
    if (!data && !data.parameter) {
        return;
    }
    // filter to remove undefined value of object
    // eslint-disable-next-line array-callback-return
    var payload = Object.keys(data.parameter).reduce(function(acc, key) {
        var currentAcc = acc;
        if (data[key] !== undefined) {
            currentAcc[key] = data[key];
            return currentAcc;
        }
        return null;
    }, {});
    (ref = window.clevertap) === null || ref === void 0 ? void 0 : ref.profile.push({
        Site: payload
    });
}
function clearClevertapState() {
    var ref, ref1;
    (ref = window.clevertap) === null || ref === void 0 ? void 0 : ref.logout();
    (ref1 = window.clevertap) === null || ref1 === void 0 ? void 0 : ref1.clear();
}


/***/ }),

/***/ 42227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BF": function() { return /* binding */ isMobileVersion; },
/* harmony export */   "C9": function() { return /* binding */ getLastSlashURL; },
/* harmony export */   "Ex": function() { return /* binding */ saveObject; },
/* harmony export */   "FD": function() { return /* binding */ emptyObject; },
/* harmony export */   "GD": function() { return /* binding */ convertToEventValue; },
/* harmony export */   "Gf": function() { return /* binding */ sanitizeHTMLTags; },
/* harmony export */   "OB": function() { return /* binding */ decodeBase64ToJS; },
/* harmony export */   "St": function() { return /* binding */ parseCountAbbrv2; },
/* harmony export */   "TE": function() { return /* binding */ copyTextToClipboard; },
/* harmony export */   "Tk": function() { return /* binding */ handleErrorAvatar; },
/* harmony export */   "fm": function() { return /* binding */ capitalizeFirstLetter; },
/* harmony export */   "hB": function() { return /* binding */ popupWindowToCenter; },
/* harmony export */   "hr": function() { return /* binding */ escapeRegExp; },
/* harmony export */   "k6": function() { return /* binding */ convertToSlug; },
/* harmony export */   "ko": function() { return /* binding */ replaceAll; },
/* harmony export */   "lz": function() { return /* binding */ sanitizeURL; },
/* harmony export */   "me": function() { return /* binding */ encodeBase64FromJS; },
/* harmony export */   "pV": function() { return /* binding */ getColorBasedOnNumber; },
/* harmony export */   "r$": function() { return /* binding */ capitalizer; },
/* harmony export */   "rK": function() { return /* binding */ transformAvatarUrl; }
/* harmony export */ });
/* unused harmony exports sortAlpha, setCharAt, newlineToBr, getPathFromUrl, trimText */
/* harmony import */ var js_base64__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52300);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* harmony import */ var constants_successMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41208);
/* harmony import */ var global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25516);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22147);
/* eslint-disable no-restricted-syntax */ /* eslint-disable indent */ /* eslint-disable no-param-reassign */ /* eslint-disable no-useless-escape */ /* eslint-disable no-restricted-globals */ /* eslint-disable no-nested-ternary */ /* eslint-disable wrap-iife */ 




/* eslint-disable import/prefer-default-export */ var copyTextToClipboard = function(text) {
    var customAlert = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var input = document.createElement("input");
    input.setAttribute("type", "text");
    var body = document.querySelector("body");
    input.value = text;
    body.appendChild(input);
    input.select();
    document.execCommand("copy");
    body.removeChild(input);
    if (customAlert) {
        customAlert();
    } else {
        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("Link copied", constants_successMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ALERT_GREEN */ .Z.ALERT_GREEN);
    }
};
function isMobileVersion() {
    var check = false;
    // eslint-disable-next-line func-names
    (function(a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
            check = true;
        }
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}
function popupWindowToCenter(url, title, w, h) {
    // Fixes dual-screen position                         Most browsers      Firefox
    var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
    var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;
    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
    var left = width / 2 - w / 2 + dualScreenLeft;
    var top = height / 2 - h / 2 + dualScreenTop;
    var newWindow = window.open(url, title, "scrollbars=yes, width=".concat(w, ", height=").concat(h, ", top=").concat(top, ", left=").concat(left));
    // Puts focus on the newWindow
    if (window.focus) {
        newWindow.focus();
    }
}
function getLastSlashURL(url) {
    return url.substr(url.lastIndexOf("/") + 1);
}
function handleErrorAvatar(e, paramUsername) {
    var fallbackUrl = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .SITE_URL */ ._O, "/images/avatar.png");
    e.target.onerror = null;
    e.target.src = fallbackUrl;
}
function parsePureValueSep(pv) {
    if (typeof pv !== "number") pv = parseFloat(pv);
    return parseFloat(pv.toFixed(2)).toLocaleString("en-US");
}
var parseCountAbbrv2 = function(number, decPlaces) {
    var thoSep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",";
    var result = 0;
    if (typeof decPlaces !== "number") decPlaces = 3;
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces);
    // Enumerate number abbreviations
    var abbrev = [
        "K",
        "M",
        "B"
    ];
    var oldNumber = number;
    // Go through the array backwards, so we do the largest first
    for(var i = abbrev.length - 1; i >= 0; i -= 1){
        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10, (i + 1) * 3);
        // If the number is bigger or equal do the abbreviation
        if (size <= number) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            number = Math.round(number * decPlaces / size) / decPlaces;
            // Handle special case where we round up to the next abbreviation
            if (number === 1000 && i < abbrev.length - 1) {
                number = 1;
                i += 1;
            }
            // Add the letter for the abbreviation
            number += " ".concat(abbrev[i]);
            break;
        }
    }
    var raw = [];
    if (number) {
        number = number.toString();
        raw = number.split(" ");
        if (raw[0] && raw[1]) {
            result = parsePureValueSep(raw[0]);
            result = raw[1] && raw[1] !== "K" ? "".concat(result, " ").concat(raw[1]) : result;
            if (raw[1] === "K") {
                result = parseFloat(oldNumber);
                result = parsePureValueSep(result);
            }
        } else {
            result = number;
        }
    }
    return result;
};
function sortAlpha(a, b) {
    var ax = a.toLowerCase();
    var bx = b.toLowerCase();
    return ax < bx ? -1 : ax > bx ? 1 : 0;
}
/**
 * Convert data to event change data to be used in `useForm` hooks
 * @param {*} val
 * @returns {Object}
 */ var convertToEventValue = function(val) {
    var data = {
        target: {
            value: val
        }
    };
    return data;
};
/**
 * Convert text to slug
 * @param {string} text
 * @return {string}
 */ function convertToSlug(text) {
    if (!text) return text;
    return text.toString().toLowerCase().replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w\-]+/g, "") // Remove all non-word chars
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-$/, ""); // Trim - from end of text
}
/**
 * Capitalize
 * @param {string} string
 * @return {string}
 */ function capitalizeFirstLetter(string) {
    if (!string) return string;
    var newString = string.toLowerCase();
    return newString.charAt(0).toUpperCase() + newString.slice(1);
}
function setCharAt(str, index, chr) {
    if (index > str.length - 1) return str;
    return str.substring(0, index) + chr + str.substring(index + 1);
}
/**
 * Capitalizer
 * @param {string} string
 * @param {number} at
 * @return {string}
 */ function capitalizer(string) {
    var at = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (!string) return string;
    var upperCasedLetter = string.charAt(at).toUpperCase();
    return setCharAt(string, at, upperCasedLetter);
}
// helpers
var encodeBase64FromJS = function(object) {
    var result = object;
    if (typeof object === "object") {
        result = JSON.stringify(object);
    }
    return js_base64__WEBPACK_IMPORTED_MODULE_0__/* .Base64.encode */ .DS.encode(result);
};
var decodeBase64ToJS = function(base64) {
    var decoded = js_base64__WEBPACK_IMPORTED_MODULE_0__/* .Base64.decode */ .DS.decode(base64);
    var result = decoded;
    try {
        result = JSON.parse(decoded);
    } catch (e) {
        result = decoded;
    }
    return result;
};
// local storage utils
var saveObject = function(key, object) {
    window.localStorage.setItem("location", window.location.origin);
    window.localStorage.setItem(key, encodeBase64FromJS(object));
};
/**
 * Turn newline into <br/>
 * @param {string} str
 * @param {string=} isXhtml
 * @returns {string}
 */ function newlineToBr(str, isXhtml) {
    var breakTag = isXhtml || typeof isXhtml === "undefined" ? "<br />" : "<br>";
    return "".concat(str).replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, "$1".concat(breakTag, "$2"));
}
function emptyObject(obj) {
    return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
}
function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}
/**
 * @deprecated - do not use for user input manipulation
 * @param {} str
 * @param {*} match
 * @param {*} replacement
 * @returns str
 */ function replaceAll(str, match, replacement) {
    return str.replace(new RegExp(escapeRegExp(match), "g"), function() {
        return replacement;
    });
}
var getColorBasedOnNumber = function(number) {
    if (Number(number) > 0) return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].primary */ .Z.primary;
    if (Number(number) < 0) return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].sunsetOrange */ .Z.sunsetOrange;
    return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].highempahis */ .Z.highempahis;
};
function getPathFromUrl(url) {
    return url.split("?")[0];
}
function trimText(description, maxLength) {
    var trimmedString = description.substr(0, maxLength);
    var lastStringIndex = Math.min(trimmedString.length, trimmedString.lastIndexOf(" "));
    trimmedString = trimmedString.substr(0, lastStringIndex);
    if (description.length > maxLength) {
        trimmedString += "...";
    }
    return trimmedString;
}
var transformAvatarUrl = function() {
    var avatarUrl = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (avatarUrl.startsWith("http")) {
        return avatarUrl;
    }
    return "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .AVATAR_URL */ .q$, "/").concat(avatarUrl);
};
/**
 * sanitizeHTMLTags
 * Remove Curve Brackets from string
 * to prevent xss, security issues
 *
 * This function is created because regex "/(<([^>]+)>)/gi" that already
 * used in v2 is not accepted in sonar-scan v3.
 * This function already have unit test
 * to makesure the result same as the previous regex implementation.
 * @param {String} originalString
 * @returns
 */ var sanitizeHTMLTags = function() {
    var originalString = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var result = "";
    var start = 0;
    while(true){
        var startBracket = originalString.indexOf("<", start);
        if (startBracket === -1) break;
        var endBracket = originalString.indexOf(">", startBracket);
        if (endBracket === -1) break;
        if (endBracket - startBracket === 1) {
            result += originalString.substring(startBracket - (startBracket - start), endBracket + 1);
        } else {
            result += originalString.substring(start, startBracket);
        }
        start = endBracket + 1;
    }
    result += originalString.substring(start);
    return result;
};
function sanitizeURL() {
    var urlToCheck = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "/";
    if (urlToCheck[0] === "/") {
        return urlToCheck;
    }
    try {
        var safeProtocol = [
            "https",
            "http"
        ];
        var safeHost = [
            "stockbit.com",
            "ui.lab.stockbit.com",
            "itunes.apple.com",
            "play.google.com", 
        ];
        var url = new URL(urlToCheck);
        if (safeProtocol.indexOf(url === null || url === void 0 ? void 0 : url.protocol) < 0) {
            throw Error("Not safe protocol: ".concat(url === null || url === void 0 ? void 0 : url.protocol));
        }
        if (safeHost.indexOf(url === null || url === void 0 ? void 0 : url.host) < 0) {
            throw Error("Not safe host: ".concat(url === null || url === void 0 ? void 0 : url.host));
        }
        return urlToCheck;
    } catch (err) {
        ;
        return constants_api__WEBPACK_IMPORTED_MODULE_1__/* .SITE_URL */ ._O;
    }
}



/***/ }),

/***/ 91635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iv": function() { return /* binding */ setUserId; },
/* harmony export */   "Kp": function() { return /* binding */ sentrySetUser; },
/* harmony export */   "gB": function() { return /* binding */ sentryLog; }
/* harmony export */ });
/* unused harmony export noticeError */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64487);
/* harmony import */ var _auth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19225);
/* harmony import */ var _general__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42227);







var setUserId = function(userId) {
    if (false) {}
    var logger = window === null || window === void 0 ? void 0 : window.NREUM;
    if (!logger || !(logger === null || logger === void 0 ? void 0 : logger.setUserId)) return;
    if (userId !== null) logger === null || logger === void 0 ? void 0 : logger.setUserId(userId.toString());
};
var noticeError = function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
err, customAttr) {
    if (false) {}
    var logger = window === null || window === void 0 ? void 0 : window.NREUM;
    if (!logger) return;
    // Get User Id from localStorage
    var ref = _auth__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getUserAccess */ .Z.getUserAccess() || {}, userId = ref.id;
    // Set New Relic User Id
    if (err) {
        setUserId(userId || null);
        var mappedCustomAttr;
        try {
            mappedCustomAttr = Object.keys(customAttr).reduce(function(a, key) {
                var newKey = key.startsWith("sb") ? (0,_general__WEBPACK_IMPORTED_MODULE_1__/* .capitalizer */ .r$)(key, 2) : "sb".concat((0,_general__WEBPACK_IMPORTED_MODULE_1__/* .capitalizer */ .r$)(key, 0));
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, a), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, newKey, customAttr[key]));
            }, {});
        } catch (error) {
            mappedCustomAttr = customAttr;
        }
        logger.noticeError(err, mappedCustomAttr);
    }
};
/* harmony default export */ __webpack_exports__["ZP"] = (noticeError);
var sentryLog = function(options) {
    var error = options.error, scopeName = options.scope, level = options.level, username = options.username, httpStatusCode = options.httpStatusCode, tags = options.tags;
    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .withScope */ .$e(function(scope) {
        scope.setTag("scope", scopeName);
        scope.setLevel(level);
        if (httpStatusCode) {
            scope.setTag("http-status-code", httpStatusCode);
        }
        if (Array.isArray(tags) && tags.length > 0) {
            tags.forEach(function(item) {
                scope.setTag(item.title, item.value);
            });
        }
        if (username) {
            scope.setUser({
                username: username
            });
        }
        if (typeof error === "string") {
            _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .captureMessage */ .uT(error);
        }
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(error, Error)) {
            _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .captureException */ .Tb(error);
        }
    });
};
var sentrySetUser = function(isLoggedIn) {
    if (!isLoggedIn) {
        return;
    }
    var userData = _auth__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getUserAccess */ .Z.getUserAccess();
    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .setUser */ .av({
        username: userData === null || userData === void 0 ? void 0 : userData.username,
        id: userData === null || userData === void 0 ? void 0 : userData.id
    });
};


/***/ })

}]);